/* eslint-disable no-useless-concat */
import antdData from 'antd/lib/locale-provider/de_DE'

const messages = {
  'esopTable.priceUpdateWarning.title': 'Mögliche Preisanpassung für andere Investitionen',
  'esopTable.priceUpdateWarning.content':
    'Der Preis anderer Investitionen wird auf der Grundlage der Gesamtzahl voll verwässerter Anteile berechnet, welche sich gerade verändert hat. Bitte passen Sie Ihre Eigenkapital Investitionen und Wandlungen bei Bedarf an.',
  'esopTable.priceUpdateWarning.confirm': 'Ok',
  'esopTable.priceUpdateWarning.cancel': 'Abbrechen',

  'conversionInvestments.priceUpdateWarning.title':
    'Mögliche Preisanpassung der Eigenkapital Investitionen',
  'conversionInvestments.priceUpdateWarning.content':
    'Der Preis einiger Eigenkapital Investitionen wird auf der Grundlage der Anzahl der Anteile berechnet, die in dieser Runde aus Wandelanleihen erhalten wurden. Möchten Sie die Eigenkapital Investitionen anpassen?',
  'conversionInvestments.priceUpdateWarning.confirm': 'Ja, zeig mir die Eigenkapital Investitionen',
  'conversionInvestments.priceUpdateWarning.cancel': 'Abbrechen',

  'conversionPrice.info.title': 'Wandlungspreis',
  'conversionPrice.info.excerpt':
    'Der Wadnlungspreis basiert auf dem vereinbarten Rundenpreis, der um die Parameter Discount und Pre-Money-Cap reduziert wird. ' +
    'Das Wandeldarlehen hat einen Abschlag von <b>{discount}</b>, {preMoneyCapInfo} und {preMoneyFloorInfo}. ',
  'conversionPrice.info.noPreMoneyFloor': 'kein Pre-Money Floor',
  'conversionPrice.info.preMoneyFloor': 'ein Pre-Money Floor von {preMoneyFloor}',
  'conversionPrice.info.noPreMoneyCap': 'kein Pre-Money Cap',
  'conversionPrice.info.preMoneyCap': 'ein Pre-Money Cap von {preMoneyCap}',
  'conversionPrice.info.roundPrice':
    'Damit entspricht der Wandlungspreis dem Rundenpreis <b>{conversionPrice}</b> auf Basis der ausgewählten Berechnungsmethode.',
  'conversionPrice.info.preMoneyCapCalculation':
    '<br /><br />Der effektive Discount des Pre-Money-Caps wird wie folgt berechnet: <br /> 1 - Pre-Money Cap/Pre-Money Bewertung. <br />' +
    'In dieser Runde: <b>{preMoneyCapDiscount} = 1-({preMoneyCap}/{preMoneyValuation}).</b> <br />',
  'conversionPrice.info.preMoneyFloorCalculation':
    '<br /><br />Der effektive Discount des Pre-Money-Caps wird wie folgt berechnet: <br /> 1 - Pre-Money Floor/Pre-Money Bewertung. <br />' +
    'In dieser Runde: <b>{preMoneyFloorDiscount} = 1-({preMoneyFloor}/{preMoneyValuation}).</b> <br />',
  'conversionPrice.info.appliedPrice':
    '<br />Angewandte Discount <b>{appliedDiscount} basierend auf dem {appliedParameter}-Parameter.</b> <br /> ' +
    'Dies führt zu folgendem Wandlungspreis: <b>{conversionPrice} = {roundPrice} * {discountMultiply}.</b> ',
  'conversionPrice.info.customPrice':
    '<br /><br />In dieser Runde wurde ein individueller Wandlungspreis verwendet: <b>{conversionPrice}.<b/>',

  'conversionInvestments.automaticShareCalculation': 'Update discounted prices automatically.',
  'investmentForm.defaultSharePrice':
    'Anteile automatisch auf Basis des {prices} Preises aktualisieren',
  'investmentForm.equity.automaticShareCalculation':
    'Alle Anteile automatisch aus Basis der Anteilspreise aktualisieren. ({prices})',

  // Default price calculation methods share/CN selection
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_FD': 'Fully Diluted',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_ND': 'Non Diluted',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_FD': 'Fully Diluted inkl. Wandlungen',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_INC_CNS_ND': 'Non Diluted inkl. Wandlungen',
  'defaultPriceCalculationMethods.AUTO_PRE_MONEY_AS_IF_FD': 'Reduzierte Pre-Money Bewertung',
  'defaultPriceCalculationMethods.MANUAL_PRICE': 'Manuelle Eingabe',

  // Price helper display in round
  'capTable.recap.preMoneyBasedPricePerShareND': 'Pre-Money Preis (non diluted)',
  'capTable.recap.preMoneyBasedPricePerShareND.title': 'Pre-Money Preis (non diluted)',
  'capTable.recap.preMoneyBasedPricePerShareND.excerpt':
    'Der Pre-Money Preis (NV) der Finanzierungsrunde wird auf der Grundlage der <b>Pre-Money Bewertung</b> berechnet und durch die Gesamtzahl der Anteile auf einer <b>nicht verwässerten</b> Basis vor der Runde geteilt. ' +
    'In dieser Runde: {preMoneyBasedPricePerShareND} = {preMoneyValuation} / {prevTotalNumberOfSharesND}.',

  'capTable.recap.avgPrice': 'Ø bezahlter Preis',
  'capTable.recap.avgPrice.title': 'Ø bezahlter Preis',
  'capTable.recap.avgPrice.excerpt':
    'Der Durchschnittspreis pro Aktie berücksichtigt alle <b>effektiv bezahlten Preise für Anteile.</b> ' +
    'Z.B. mit Berücksichtigung von Discounts bei Wandeldarlehen, aber ohne Berücksichtigung der Verwässerung durch einen neuen V(E)SOP. <br /><br />' +
    'In dieser Runde: {averagePricePerShare} = {totalShareInvestments} / {totalNumberOfNewShares}.',

  'capTable.recap.preMoneyBasedPricePerShareFD': 'Pre-Money Preis (fully diluted)',
  'capTable.recap.preMoneyBasedPricePerShareFD.title': 'Pre-Money Preis (fully diluted)',
  'capTable.recap.preMoneyBasedPricePerShareFD.excerpt':
    'Der Pre-Money Preis (fully diluted) der Finanzierungsrunde wird auf der Grundlage der <b>Pre-Money Bewertung</b> berechnet und durch die Gesamtzahl der Anteile auf einer <b>voll verwässerten</b> Basis vor der Runde geteilt. ' +
    'V(E)SOP-Anteile, die vor oder während der Runde geschaffen wurden (Option "mit Preisanpassung"), werden mitgezählt. <br /><br />' +
    'In dieser Runde: {preMoneyBasedPricePerShareFD} = {preMoneyValuation} / {prevTotalNumberOfSharesFD}.',

  // Previous translations before 01.01.2022
  'investmentHistoryTrace.untriggeredEvents.title': 'Geplante Transaktionen (Zukunft)',
  'grantsOverview.grantsTable.columns.buttons.sharing.no-link': 'Noch kein Zugriff gewährt',
  'grantsOverview.grantsTable.columns.buttons.sharing.access-link': 'Zugang ist noch gültig',
  'grantsOverview.grantsTable.columns.buttons.sharing.permanent-link':
    'Dauerhafter Zugriff gewährt',
  'grantsOverview.grantsTable.columns.buttons.sharing.expired-link': 'Der Zugriff ist abgelaufen',

  'employeeDashboard.preview.settings.labels.defaultExitAmount.isRequired':
    'Bitte geben Sie einen Standard-Exit-Betrag ein',
  'employeeDashboard.preview.settings.labels.defaultExitDate.isRequired':
    'Bitte geben Sie ein Standard-Exit-Datum ein',
  'employeeDashboard.preview.settings.labels.defaultExitDate': 'Voreinstellung Exit-Datum',
  'employeeDashboard.preview.settings.labels.defaultExitAmount': 'Voreinstellung Exit-Betrag',
  'employeeDashboard.preview.settings.labels.previewEmployee': 'Vorschau für Mitarbeiter',
  'employeeDashboard.preview.settings.headings.companyLogo': 'Firmenlogo',
  'employeeDashboard.preview.settings.headings.introText': 'Begrüßungstext',
  'employeeDashboard.preview.settings.headings.customText': 'Ihre Nachricht',
  'employeeDashboard.preview.settings.headings.other': 'Andere Einstellungen',

  'employeeDashboard.error.expired.heading': 'Die Zugriffslink ist ausgelaufen.',
  'employeeDashboard.error.expired.description':
    'Bitte kontaktieren Sie Ihre Firma, um einen aktualisierten Link zu erhalten.',
  'employeeDashboard.error.expired.button': 'Registrieren/Anmelden',
  'employeeDashboard.error.overridden.heading':
    'Der aufgerufene Link wurde durch eine neuere Version überschrieben und ist ungültig.',
  'employeeDashboard.error.overridden.description':
    'Bitte kontaktieren Sie Ihre Firma, um einen aktualisierten Link zu erhalten.',
  'employeeDashboard.error.overridden.button': 'Registrieren/Anmelden',
  'employeeDashboard.error.revoked.heading':
    'Der aufgerufene Link wurde widerrufen und ist ungültig.',
  'employeeDashboard.error.revoked.description':
    'Bitte kontaktieren Sie Ihre Firma, um einen aktualisierten Link zu erhalten.',
  'employeeDashboard.error.revoked.button': 'Registrieren/Anmelden',
  'employeeDashboard.error.general.heading': 'Der Zugriffslink ist ungültig.',
  'employeeDashboard.error.general.description':
    'Bitte kontaktieren Sie Ihre Firma, um einen aktualisierten Link zu erhalten.',
  'employeeDashboard.error.general.button': 'Registrieren/Anmelden',

  'employeeDashboard.box.valuation.title': 'Ihre Exit-Erwartungen',
  'employeeDashboard.box.valuation.description':
    'Um eine Auszahlung berechnen zu können, muss eine Bewertung ermittelt werden, zu der das Unternehmen verkauft werden soll. Hier können Sie einen realistischen Wert, aber auch einen Wunschwert eingeben. Auf Basis dieses Wertes wird das folgende Diagramm aktualisiert.',

  'employeeDashboard.box.intro.title': 'Lieber {name},',
  'employeeDashboard.box.intro.description':
    'herzlich willkommen zu Ihrer individuellen V(E)SOP-Übersicht. Jeder einzelne Mitarbeiter ist wichtig für den Erfolg unseres Unternehmens und soll an dessen Wachstum teilhaben. Aus diesem Grund haben wir ein Optionsprogramm aufgelegt. Hier finden Sie alle Informationen zu Ihren Mitarbeiteroptionen.',

  'employeeDashboard.box.info.title': 'Was ist V(E)SOP?',
  'employeeDashboard.box.info.description':
    'V(E)SOP ist eine Abkürzung für "virtueller Mitarbeiteroptionsplan".  Das bedeutet, dass es einen realen Optionsplan simuliert, der es den Mitarbeitern ermöglicht, sich am Eigenkapital zu beteiligen, ohne für das Kapital bezahlen zu müssen. Er bietet Ihnen den Vorteil, dass Sie eine Zahlung für die Optionen erhalten, wenn ein "Ausübungsereignis" eintritt. Wie viel Ihre V(E)SOP-Beteiligung wert sein könnte, hängt vom Unternehmenswert ab.',
  'employeeDashboard.box.info.button': 'Lernen Sie die Grundlagen',

  'employeeDashboard.box.custom.title': 'Unsere Nachricht an Sie',
  'employeeDashboard.box.custom.description':
    'Hier finden Sie eine Übersicht über alle Verträge, die Ihr V(E)SOP-Programm betreffen. Die Grafik in der Mitte zeigt Ihnen, wie hoch der Erlös für Sie in einem Exit-Fall ist und wie hoch der geplante Erlös ist. Oft unterliegen Mitarbeiteroptionen einem sogenannten Vesting. Falls zutreffend, finden Sie hier auch Informationen über das aktuelle und zukünftige Vesting Ihrer Optionen. Sollten Sie weitere Fragen haben, können Sie sich gerne an COMPANY_CONTACT wenden.',
  'employeeDashboard.box.custom.footer': 'Diese Nachricht wurde von {companyName} gesendet.',

  'employeeDashboard.box.facts.title': 'Datenblatt',
  'employeeDashboard.box.facts.subtitle1':
    'Sie haben insgesamt {numberOfGrants} Optionspakete (Grants) erhalten.',
  'employeeDashboard.box.facts.subtitle2':
    'Diese Pakete sollen in einem Exit-Fall etwa {totalPlannedValue} auszahlen.',
  'employeeDashboard.box.facts.fields.packages': 'Pakete',
  'employeeDashboard.box.facts.fields.plannedProceeds': 'Geplante Erlöse',
  'employeeDashboard.box.facts.fields.packet': 'Paket {idx}',
  'employeeDashboard.box.facts.fields.date': 'Ausgabe',
  'employeeDashboard.box.facts.fields.shareAmount': 'Optionen',
  'employeeDashboard.box.facts.fields.strikePrice': 'Strikepreis',
  'employeeDashboard.box.facts.fields.vesting': 'Vesting',
  'employeeDashboard.box.facts.fields.vestingMonths': '{months} Monate',

  'employeeDashboard.box.diagram.title': 'Mögliche Erlöse',
  'employeeDashboard.box.diagram.options': '{options} Optionen',
  'employeeDashboard.box.diagram.labelX1': 'Vesting level zum',
  'employeeDashboard.box.diagram.labelX2': 'Bewertung',
  'employeeDashboard.box.diagram.today': 'Heute',
  'employeeDashboard.box.diagram.fullyVested': 'Vollständiges vesting',
  'employeeDashboard.box.diagram.totalPlanned': 'Summe der geplanten Erlöse {totalPlannedValue}',

  'employeeDashboardPage.pathName': 'Mitarbeiter-Dashboard',
  'employeeLinkShareModal.title': 'Mitarbeiterzugriff verwalten',
  'grantsOverview.grantsTable.title.shareAccess': 'Mitarbeiterzugriff verwalten',
  'employeeLinkShareModal.tabs.accessTable': 'Zugriff freigeben',
  'employeeLinkShareModal.tabs.preview': 'Vorschau',
  'employeeAccessTable.menu.grantAccess': 'Zugriff gewähren/überschreiben',
  'employeeAccessTable.menu.revokeAccess': 'Zugriff widerrufen',
  'employeeAccessTable.menu.permanent': 'Permanent',
  'employeeAccessTable.menu.expirationDate': 'Ablaufdatum',
  'employeeAccessTable.table.headers.link': 'Link',
  'employeeAccessTable.table.headers.status': 'Status',
  'employeeAccessTable.table.headers.status.none': 'Noch keine Einladung verschickt',
  'employeeAccessTable.table.headers.status.permanent': 'Permanenter Zugang',
  'employeeAccessTable.table.headers.status.access': 'Zugriff bis {date}',
  'employeeAccessTable.table.headers.status.expired': 'Zugriff abgelaufen am {date}',
  'employeeAccessTable.table.headers.mail.add': 'E-Mail Adresse hinzufügen',
  'employeeAccessTable.table.footer.buttons.grant':
    'Überschreiben des Zugriffs für {number} Mitarbeiter',
  'employeeAccessTable.table.footer.buttons.revoke': 'Zugriff für {number} Mitarbeiter widerrufen',
  'employeeAccessTable.table.headers.link.previewNewTab': 'Vorschau in einem neuem Tab',
  'employeeAccessTable.table.filters.email.some': 'Akzeptierte E-Mail',
  'employeeAccessTable.table.filters.email.none': 'Fehlende E-Mail',
  'employeeAccessTable.table.filters.link.some': 'Geteilter Zugang',
  'employeeAccessTable.table.filters.link.none': 'Kein geteilter Zugang',
  'employeeAccessTable.table.filters.status.none': 'Kein geteilter Zugang',
  'employeeAccessTable.table.filters.status.expired': 'Ausgelaufener Zugang',
  'employeeAccessTable.table.filters.status.permanent': 'Permanenter Zugang',
  'employeeAccessTable.table.filters.status.access': 'Geteilter Zugang',

  'cnConversionsTable.buttons.addMultiple': 'Mehrere Wandlungen',
  'conversionInvestments.headers.totalAmount': 'Gesamter gewandelter Betrag',
  'conversionInvestments.importdata.title': 'Mehrere Wandlungen hinzufügen/bearbeiten',
  'conversionInvestments.headers.conversionPrice': 'Diskontierter Preis',
  'conversionInvestments.headers.conversionPriceRequired':
    'Bitte geben Sie einen diskontierten Preis größer Null ein',
  'conversionInvestments.importdata.info.1':
    'In dieser Tabelle können Sie alle Tranchen von Wandelanleihen einfach umrechnen',
  'conversionInvestments.importdata.info.2':
    'Bitte verwenden Sie das Einzeltransaktionsmodal für weitere Erklärungen und Anpassungen der verschiedenen Parameter',
  'conversionInvestments.rules.nominalExceeds':
    'Der gewandelte Nominalbetrag ({convertedNominal}) übersteigt den verfügbaren Nominalbetrag ({nominal}).',
  'conversionInvestments.rules.interestExceeds':
    'Der gewandelte Zinsbetrag ({convertedInterest}) übersteigt den verfügbaren Zinsbetrag ({interest}).',

  'cnInvestments.importdata.title': 'Hinzufügen/Bearbeiten von mehreren Wandeldarlehen',
  'cnInvestments.importdata.info.1':
    'In dieser Tabelle können Sie einfach alle Tranchen der Wandeldarlehen für diese Finanzierungsrunde kopieren und einfügen',
  'cnInvestments.importdata.info.2':
    'Für weitere Anpassungen bearbeiten Sie die Tranchen-Details im Einzeltransaktionsmodal',
  'cnInvestments.importdata.info.3': 'Haben Sie vergessen, einen Stakeholder hinzuzufügen?',

  'investmentForm.limitAsDatePlaceholder': 'Wählen Sie das Enddatum',
  'historyTrace.cnConversion.totalAmount.help':
    'Der Gesamtbetrag besteht aus einem {conversionAmount} ({nominal} Nominal und {interest} Zinsen) und einem {supplementaryAmount} Nachzahlungsbetrag.',
  'roundForm.futureDateDisallowed':
    'Termine in der Zukunft sind deaktiviert. Sie können die Modellierungsseite verwenden, um im Voraus zu planen.',
  'grantsModelling.calculator.freePremiumTryOut':
    'Sie können diese Premium-Funktion zum gewähren Ihrer ersten Mitarbeiteroption kostenlos nutzen!',

  'grantsOverview.grantsTable.icons.rise':
    'Der Ist-Wert des Optionspakets ist über dem geplanten Wert',
  'grantsOverview.grantsTable.icons.fall':
    'Der Ist-Wert des Optionspakets ist unter dem geplanten Wert',
  'grantsOverview.grantsTable.filters.plannedGreaterActual':
    'Der tatsächliche Gesamtwert des Pakets ist kleiner als der geplante Wert',
  'grantsOverview.grantsTable.filters.plannedApproxActual':
    'Der tatsächliche Gesamtwert des Pakets entspricht ungefähr dem geplanten Wert',
  'grantsOverview.grantsTable.filters.plannedSmallerActual':
    'Der tatsächliche Gesamtwert des Pakets ist größer als der geplante Wert',
  'shareholder.add.employee.button': 'Mitarbeiter hinzufügen',
  'grantsOverview.grantsTable.columns.buttons.edit': 'Mitarbeiterdetails bearbeiten',
  'grantsOverview.grantsTable.columns.buttons.modelling':
    'Neues Optionspaket gewähren - zum Rechner',
  'grantsOverview.grantsTable.columns.plannedReturn': 'Geplanter Erlös',
  'employee.add.modal.section.general': 'Allgemein',
  'employee.add.modal.section.compensationplanning': 'Kompensationsplanung',
  'employee.add.modal.title.edit': 'Mitarbeiterdetails',
  'employee.add.modal.title': 'Mitarbeiterdetails (neu)',
  'grantsModelling.calculator.forms.form4.date': 'Ausgabedatum',

  'grantsOverview.exit.settings.accelerationOnExit': 'Vesting Aufholung im Exit-Fall',
  'grantsOverview.exit.settings.title':
    'Exit Erwartungen zur Berechnung der Werte der Optionspakete',
  'grantsOverview.headerTable.title': 'V(E)SOPs Übersicht',
  'grantsOverview.grantsTable.title': 'Übersicht über ausgegebene Optionspakete',
  'grantsOverview.grantsTable.title.addEditEmployees': 'Mitarbeiter hinzufügen/bearbeiten',
  'grantsOverview.grantsTable.columns.jobTitle': 'Job-Titel',
  'grantsOverview.grantsTable.columns.salary': 'Gehalt jährl.',
  'grantsOverview.grantsTable.columns.options': 'Optionen heute (Vested/Gesamt)',
  'grantsOverview.grantsTable.columns.plannedPackage': 'Geplanter Wert des Optionspakets',
  'grantsOverview.grantsTable.columns.actualPackage': 'Ist-Wert des Optionspakets',
  'grantsOverview.grantsTable.columns.status': 'Status',
  'grantsOverview.grantsTable.columns.status.vestingEnd': 'Vesting endet {end}',
  'grantsOverview.grantsTable.columns.status.none': 'Ohne',
  'grantsOverview.grantsTable.columns.status.ongoing': 'Laufend',
  'grantsOverview.grantsTable.columns.status.finished': 'Abgeschlossenes Vesting',

  'grantsOverview.grantsTable.columns.pool': 'V(E)SOP',
  'grantsOverview.grantsTable.columns.optionsAtExit': 'Stammanteilsoption beim Exit',
  'grantsOverview.grantsTable.columns.incAcceleration': 'inkl. Akzeleration',
  'grantsOverview.grantsTable.columns.csOptionValue': 'Stammanteilsoption <br />Wert beim Exit',
  'grantsOverview.grantsTable.columns.strikePrice': 'Ausübungspreis',
  'grantsOverview.grantsTable.columns.returnPerOption': 'Erlös pro Option',
  'grantsOverview.grantsTable.columns.returnTotal': 'Gesamterlös',

  'grantsModelling.calculator.forms.form2.enablePackageValueInput':
    'Geplanten Paketwert direkt eingeben',
  'shareholder.add.emplyoee.button': 'Mitarbeiter hinzufügen',
  'grantsModelling.calculator.forms.form2.example.title':
    'Beispielfall für Eigenkapitalkompensation',
  'grantsModelling.calculator.forms.form2.example.info':
    'Sie haben einen Mitarbeiter mit einem Jahresgehalt von 50.000,00€. Diese Person ist Ihr Lead UX Designer und das durchschnittliche Gehalt beträgt 65.000,00€. Sie möchten diesen Mitarbeiter für 4 Jahre motivieren. Sie möchten den Gehaltsverlust von 15.000,00€ und einen Bonus zahlen.',
  'grantsModelling.calculator.header.steps.step1.button': 'Beispiel anzeigen',
  'grantsModelling.calculator.forms.form2.example.text1': 'Aktuelles Gehalt des Mitarbeiters',
  'grantsModelling.calculator.forms.form2.example.text2':
    'Bonus basierend auf dem aktuellen Gehalt',
  'grantsModelling.calculator.forms.form2.example.text3': 'Gehaltskompensation',
  'grantsModelling.calculator.forms.form2.example.text4': 'Geplanter Anreizzeitraum',
  'grantsModelling.calculator.forms.form2.example.text5':
    'Größe des Pakets ({amount} pro Jahr x {years} Jahre)',

  'grantsModelling.tabs.settings': 'Infos & Einstellungen',
  'grantsModelling.tabs.calculator': 'Rechner',
  'grantsModelling.settings.card.company.title': 'Exit Erwartungen',
  'grantsModelling.settings.card.package.title': 'Variable Optionspakete (optional)',
  'grantsModelling.settings.form.postMoneyValuation': 'Letzte Post-Money-Bewertung',
  'grantsModelling.settings.form.exitAmount': 'Erwarteter Exit-Betrag',
  'grantsModelling.settings.form.exitAmount.isRequired':
    'Bitte geben Sie einen erwarteten Exit-Betrag ein',
  'grantsModelling.settings.form.exitDate.isRequired': 'Bitte geben Sie ein Exit-Datum ein',
  'grantsModelling.settings.form.exitDate': 'Exit-Datum',
  'grantsModelling.settings.form.roundPrice': 'Letzter Rundenpreis',
  'grantsModelling.settings.form.csOptionValue': 'Erwartete Erlöse eines Stammanteils',
  'grantsModelling.settings.form.bonusCompensationLevels.name': 'Level',
  'grantsModelling.settings.form.bonusCompensationLevels.percentFromSalary': '% vom Gehalt',
  'grantsModelling.settings.info.welcome': 'Willkommen bei unserem V(E)SOP-Rechner',
  'grantsModelling.settings.info.list.title': 'Erste Schritte',
  'grantsModelling.settings.info.list':
    'Hier legen Sie die beiden Hauptfaktoren fest, um eine faire Strategie zur Eigenkapitalkompensation für Ihr Unternehmen zu bestimmen',
  'grantsModelling.settings.info.list.item1': 'Das erwartete Exit-Potenzial für das Unternehmen',
  'grantsModelling.settings.info.list.item2':
    'Wie viel % des Gehalts soll als Eigenkapital gezahlt werden',
  'grantsModelling.settings.card.company.info':
    'Die Exit-Erwartung ist wichtig, um die potenzielle Rendite für alle Optionen zu bewerten, die Sie den Mitarbeitern anbieten. Zum Beispiel könnten Sie davon ausgehen, Ihren Wert in den nächsten 4 Jahren zu verdreifachen.',
  'grantsModelling.settings.card.package.info':
    'Abhängig von der Rolle eines Mitarbeiters können Sie mehr/weniger % des Gehalts als Equity-Bonus gewähren. Hier können Sie standardisierte Werte für verschiedene Stufen eingeben.',

  'grantsModelling.calculator.sidebar.steps.step1.title': 'Mitarbeiter-Auswahl',
  'grantsModelling.calculator.sidebar.steps.step1.description':
    'Wählen Sie den begünstigten Mitarbeiter',
  'grantsModelling.calculator.sidebar.steps.step2.title': 'Vergütungspaket',
  'grantsModelling.calculator.sidebar.steps.step2.description':
    'Berechnen Sie die Höhe der Kompensation',
  'grantsModelling.calculator.sidebar.steps.step3.title': 'Ausübungspreis und Optionsberechnung',
  'grantsModelling.calculator.sidebar.steps.step3.description':
    'Berechnen Sie den Wert des Eigenkapitalanteils',
  'grantsModelling.calculator.sidebar.steps.step4.title': 'Pool-Auswahl',
  'grantsModelling.calculator.sidebar.steps.step4.description': 'Wählen Sie den tragenden Pool',
  'grantsModelling.calculator.sidebar.steps.step5.title': 'Vesting (Optional)',
  'grantsModelling.calculator.sidebar.steps.step5.description': 'Anpassen des Vesting-Plans',
  'grantsModelling.calculator.header.steps.step1.info':
    'Beginnen Sie mit der Auswahl des Mitarbeiters, für den Sie Optionen gewähren möchten.',
  'grantsModelling.calculator.header.steps.step2.info':
    'Optionen können auf unterschiedliche Weise eingesetzt werden. Als Gehaltskompensation, für mögliche Bonuszahlungen oder beides zusammen. <br />Der Wert des Gesamtpakets wird dann auf der Grundlage der Incentivierungsdauer berechnet.',
  'grantsModelling.calculator.header.steps.step3.info':
    'Es gibt zwei Möglichkeiten, den Wert des Optionspakets zu erhöhen. Entweder, indem Sie einen niedrigeren Ausübungspreis festlegen, oder indem Sie die Anzahl der Optionen erhöhen, die Sie dem Mitarbeiter gewähren. <br />Passen Sie den Ausübungspreis an und wir berechnen Ihnen automatisch die Anzahl der Optionen, die erforderlich sind, um das Optionspaket für die von Ihnen im Setup angegebene Unternehmensbewertung zu kompensieren (Normalfall).',
  'grantsModelling.calculator.header.steps.step4.info':
    'Wählen Sie den Pool, aus dem Sie die Optionen gewähren möchten.',
  'grantsModelling.calculator.header.steps.step5.info':
    'Fügen Sie optional einen Vesting-Plan für die Mitarbeiteroptionen hinzu und finalisieren Sie diese.',
  'grantsModelling.calculator.footer.button.finish': 'Jetzt gewähren',
  'grantsModelling.calculator.forms.form1.chooseEmployee': 'Wählen Sie einen Mitarbeiter',
  'grantsModelling.calculator.forms.form2.salary': 'Gehalt jährl.',
  'grantsModelling.calculator.forms.form2.employeeLevel': 'MA-Level',
  'grantsModelling.calculator.forms.form2.bonusCompensation': 'Variabler Bonus jährl.',
  'grantsModelling.calculator.forms.form2.bonusCompensation.ofSalary': '{percent} vom Gehalt',
  'grantsModelling.calculator.forms.form2.salaryCompensation': 'Gehaltskompensation jährl.',
  'grantsModelling.calculator.forms.form2.compensationPeriodInMonths':
    'Incentivierungszeitraum (in Monaten)',
  'grantsModelling.calculator.forms.form2.requiredOptionPackage':
    'Geplanter Wert des Optionspakets',
  'grantsModelling.calculator.forms.form3.strikeprice': 'Ausübungspreis',
  'grantsModelling.calculator.forms.form3.shareAmount': 'Anzahl der Optionen',
  'grantsModelling.calculator.forms.analysis.table.headers.worst': 'Worst Case',
  'grantsModelling.calculator.forms.analysis.table.headers.normal': 'Normal Case',
  'grantsModelling.calculator.forms.analysis.table.headers.best': 'Best Case  ',
  'grantsModelling.calculator.forms.analysis.table.headers.exitAmount': 'Exit',
  'grantsModelling.calculator.forms.analysis.table.headers.csOptionValue':
    'Wert der Stammanteilsoptionen',
  'grantsModelling.calculator.forms.analysis.table.headers.packageValue': 'Optionspaket-Wert',
  'grantsModelling.calculator.forms.analysis.chart.labels.worst': 'Worst Case',
  'grantsModelling.calculator.forms.analysis.chart.labels.normal': 'Normal Case',
  'grantsModelling.calculator.forms.analysis.chart.labels.best': 'Best Case',
  'grantsModelling.calculator.forms.analysis.chart.labels.packageValue':
    'Wert des Optionspakets beim Exit',
  'grantsModelling.calculator.forms.analysis.chart.labels.requiredPackageValue':
    'Geplanter Wert des Optionspakets',

  'grantsModelling.calculator.forms.form4.shareAmount': 'Anzahl der Anteile des Optionspakets',
  'grantsModelling.calculator.forms.form4.esops': 'Pool-Auswahl',
  'grantsModelling.calculator.forms.form4.esops.table.available': 'Verfügbar',
  'grantsModelling.calculator.forms.form4.esops.table.options': 'Optionen gewähren',
  'grantsModelling.calculator.forms.form4.esops.table.optionsExceedMax':
    'Die Anzahl der gewährten Optionen übersteigt die Anzahl der verfügbaren Optionen im Pool.',
  'grantsModelling.calculator.forms.form4.esops.table.optionsSumToTotal':
    'Die Gesamtzahl der gewährten Optionen muss die Anzahl der Anteile im Optionspaket ausgleichen.',
  'grantsModelling.calculator.forms.form4.esops.table.availableAfter': 'Danach verfügbar',
  'grantsModelling.calculator.forms.form5.packageValue':
    'Wert des Optionspakets bei erwarteten Exit',
  'grantsModelling.calculator.forms.form5.success.title':
    'Erfolgreich Mitarbeiteroptionen hinzugefügt',
  'grantsModelling.calculator.forms.form5.success.description':
    '{name} erhielt {options} Optionen für einen Ausübungspreis von {price}',

  'esopSetup.bonusCompensationLevels.normalEmployee': 'Normaler Mitarbeiter',
  'esopSetup.bonusCompensationLevels.keyContributor': 'Hauptverantwortlicher',
  'esopSetup.bonusCompensationLevels.lead': 'Leitung',
  'esopSetup.bonusCompensationLevels.headOfVP': 'Direktor/VP',
  'grantsOverview.pathName': 'Mitarbeiteroptionen Überblick',
  'grantModelling.pathName': 'Mitarbeiteroptionen Modellierung',
  'modelling.analysis.investorBarCharts.shareQuota': 'Anteilsquote (verwässert)',

  'pageNotice.migrateUserInfo':
    'Wir starten ein neues Kapitel. Komm mit uns zu Gründerplattform.de.',
  'pageNotice.cancelMigration':
    'Ich widerspreche dem Datenübertrag. Mir ist bewusst, dass der Account dann von Seiten der Ventury Analytics GmbH zum 15.09.2023 gekündigt wird, wie in der Mail von 13.06 angekündigt.',
  'pageNotice.migrateUser': 'Ich stimme zu',
  'pageNotice.migrateUserText': `Ich willige ein, dass meine personenbezogenen Daten (z.B. Name, Telefonnummer, E-Mail-Adresse, Anschrift, Kundennummer) sowie Projektdaten zur Kommunikation bezüglich des Betreibens der Plattform und des darauf angelegten Projekts an die Firma BusinessPilot GmbH
  Schlesische Straße 32
  10997 Berlin , Deutschland übertragen und verarbeitet werden.
  
  Die Daten werden von der Firma BusinessPilot GmbH in keiner weiteren Weise weitergegeben und nur für den ordnungsgemäßen Betrieb der Plattform verwendet.
  
  Mir ist bewusst, dass ich diese Einwilligung jederzeit ohne Angabe von Gründen für die Zukunft widerrufen kann, indem ich BusinessPilot GmbH postalisch Schlesische Straße 32
  10997 Berlin oder per E-Mail kontakt@businesspilot.de meinen Widerruf gegen die Verarbeitung meiner personenbezogenen Daten mitteile.
  
  Mit der Zustimmung wird der komplette Account inklusive des Projektes auf die Business Pilot GmbH übertragen. Die Plattform kann im Anschluss wie gewohnt weiter genutzt werden.`,
  'pageNotice.joinProjects': 'Alle Organisationsprojekte anzeigen',
  'pageNotice.noProjectsButGroup': 'Keine Projekte vorhanden.',
  'modellingPage.analysis.result.heading.scenarios': 'Ergebnisse zum vergleichen',
  'modellingPage.menu.top.helpDrawer.simple.step1.title':
    'Neue Anteilseigner und Anteilsklassen hinzufügen',
  'modellingPage.menu.top.helpDrawer.simple.step1.description':
    'In der oberen Leiste können Sie neue Anteilseigner und Anteilsklassen hinzufügen, die in den verschiedenen Szenarien verwendet werden können, die Sie in der Struktur erstellen werden. Beginnen Sie damit, Anteilseigner hinzuzufügen, die in Ihr Unternehmen investieren könnten. Wenn Sie sich unsicher sind, können Sie es auch vage halten und sie einfach "Neuer Investor X" nennen.',
  'modellingPage.menu.top.helpDrawer.simple.step2.title': 'Eine neue Finanzierungsrunde hinzufügen',
  'modellingPage.menu.top.helpDrawer.simple.step2.description':
    'Fahren Sie einfach mit dem Mauszeiger über einen Knoten im Baum auf der linken Seite, um mit ihm zu interagieren. Beginnen Sie damit, eine Folgerunde zu Ihrer letzten Finanzierungsrunde hinzuzufügen.',
  'modellingPage.menu.top.helpDrawer.simple.step3.title': 'Eingabe der Rundendetails',
  'modellingPage.menu.top.helpDrawer.simple.step3.description':
    'In dem sich öffnenden Formular können Sie alle Rundendaten eingeben. Die Formulare sind identisch mit Ihrer historischen Dateneingabe. Zusätzlich können Sie Auszahlungsstufen hinzufügen, wie z. B. einen Gründer-Catch-up, um jedes Szenario vollständig anzupassen.',
  'modellingPage.menu.top.helpDrawer.simple.step4.title': 'Ergebnisse anzeigen',
  'modellingPage.menu.top.helpDrawer.simple.step4.description':
    'Bewegen Sie den Mauszeiger über einen Knoten in der Baumstruktur und wählen Sie "Details anzeigen", um die Captable- und Exit-Berechnungen für dieses Szenario zu untersuchen. Alternativ können Sie über die obere Leiste direkt in den Analyseabschnitt gehen. Wenn Sie die Szenarien nicht weiter bearbeiten wollen, empfehlen wir, den Analysebereich auf Vollbild zu erweitern, um eine weniger überfüllte Übersicht zu haben.',
  'modellingPage.menu.top.helpDrawer.simple.step5.title': 'Analyse-Bereich',
  'modellingPage.menu.top.helpDrawer.simple.step5.description':
    'Im Bereich "Analyse" auf der rechten Seite haben Sie zwei Registerkarten: "Details" und "Vergleichen". In der Registerkarte "Details" können Sie die Cap-Tabelle und die Exit-Berechnung für ein bestimmtes Szenario untersuchen. Beachten Sie, dass Sie unterhalb des Szenario-Auswahlmenüs zwischen den Registerkarten "Cap-Tabelle", "Wasserfall" und "Exit-Berechnung" wechseln können. Außerdem können Sie im Analysebereich das Ausstiegsdatum für jedes Szenario anpassen. Standardmäßig liegt es ein Jahr nach dem Szenariodatum. Auf der Registerkarte "Vergleichen" können Sie die Aktionärsquote und die Exit-Renditen verschiedener Beteiligter in verschiedenen Szenarien vergleichen.',
  'modellingPage.menu.top.helpDrawer.simple.step6.title': 'Exportieren Sie Ihre Daten',
  'modellingPage.menu.top.helpDrawer.simple.step6.description':
    'Zuletzt können Sie Ihre Daten in einem praktischen Excel-Format exportieren, einschließlich der meisten Berechnungen. Klicken Sie einfach auf die Download-Schaltflächen im Analysebereich oder rufen Sie das Exportmodal über die obere Leiste auf.',

  'modellingPage.menu.top.export': 'Exportieren',
  'shareclassTable.delete.isModellingProjectShare':
    'Ihr Projekt ist geteilt oder es sind Modellierungsprojekte angelegt, die die Anteilsklasse referenzieren. Wir möchten sicherstellen, dass alle Anteilseigner auf die gleichen Daten zugreifen, daher können Sie die Anteilsklasse nicht aus dem Projekt löschen, solange es Modellierungsprojekte gibt, die auf sie verweisen.',
  'termsheet.disableDelete.cnUsedInModelling':
    'Ihr Projekt ist geteilt oder es sind Modellierungsprojekte angelegt, die das Wandeldarlehen referenzieren. Wir möchten sicherstellen, dass alle Anteilseigner auf die gleichen Daten zugreifen, daher können Sie das Wandeldarlehen nicht aus dem Projekt löschen, solange es Modellierungsprojekte gibt, die auf sie verweisen.',
  'edit.canNotEdit':
    'Ihr Projekt ist geteilt oder es sind Modellierungsprojekte angelegt, die den Anteilseigner referenzieren. Wir möchten sicherstellen, dass alle Anteilseigner auf die gleichen Daten zugreifen, daher können Sie den Anteilseigner nicht aus dem Projekt löschen, solange es Modellierungsprojekte gibt, die auf sie verweisen.',

  'payouts.title': 'Auszahlungen',
  'modellingProject.addNewRoundModal.title': 'Hinzufügen/Editieren einer neuen Finanzierungsrunde',
  'modellingProject.addShareclassModal.table.title':
    'Füge neue Anteilsklassen hinzu, welche in den verschiedenen Szenarien verwendet werden',
  'modellingProject.addShareclassModal.title':
    'Hinzufügen/Editieren von verschiedenen Anteilsklassen',
  'shareclassTable.delete.isBaseProjectShare':
    'Im Modellierungsprojekt können nur neue Anteilsklassen gelöscht werden.',
  'modellingPage.stakeholder.importdata.info.1':
    'Fügen Sie neue Gesellschafter hinzu, die in den verschiedenen Szenarien verwendet werden können.',
  'modellingPage.stakeholder.importdata.info.2':
    'Bitte beachten Sie, dass Sie nur Gesellschafter löschen können, die in keinem Szenario eine Beteiligung haben. Ansonsten wird die Löschung nicht dauerhaft gespeichert.',

  'modellingProjectTypes.SIMULATION': 'Komplexes Modellierungsprojekt',
  'modellingProjectTypes.CALCULATION': 'Einfaches Modellierungsprojekt',
  'modellingPage.updateProject.success.title':
    'Das Modellierungsprojekt wurde erfolgreich geupdated.',
  'modellingProjectForm.nameRequired':
    'Bitte geben Sie einen Namen für das Modellierungsprojekt ein.',
  'modellingProjectForm.title': 'Ändern Sie den Namen für das Modellierungsprojekt',
  'addModellingProjectTour.title': 'Erstelle ein neues Modellierungsprojekt',
  'addModellingProjectTour.startModelling': 'Modellierung starten',
  'modellingProjectForm.type.calculation': 'Detailplanung',
  'modellingProjectForm.type.calculation.description':
    'Dieser Modus bietet Ihnen eine detaillierte Kontrolle über die Szenarien, die Sie simulieren möchten, in demselben Format, das Sie von Ihren historischen Finanzierungsrunden gewohnt sind. Erstellen Sie alle möglichen Szenarien in einem Baum und analysieren & vergleichen Sie diese direkt. Beachten Sie, dass dieser Modus zwar weniger Flexibilität für unbekannte Parameter bietet, aber viel einfacher zu bedienen ist und Ihre erste Option sein sollte.',
  'modellingProjectForm.type.simulation': 'Strategieplanung',
  'modellingProjectForm.type.simulation.description':
    'Dieser Modus bietet Ihnen große Flexibilität, um eine Landschaft von Szenarien grob zu simulieren. Geben Sie die grundlegenden Parameter für jede Finanzierungsrunde ein, z. B. Gesamtinvestitionsbetrag und Datum. Für unbekannte Parameter wie die Bewertung definieren Sie einfach einen Bereich (z.B. zwischen 30-50mio) und filtern & vergleichen alle Ergebnisse. Beachten Sie, dass dieser Modus schwieriger zu verwenden ist und keine detaillierten Investitionen wie Buyouts oder Teilumwandlungen unterstützt.',

  'modellingPage.deleteProject.confirm':
    'Sind Sie sicher Sie wollen das Modellierungsprojekt {name} löschen? Dies kann nicht rückgängig gemacht werden.',
  'modellingPage.deleteProject.success.title':
    'Das Modellierungsprojekt wurde erfolgreich gelöscht.',
  'modellingPage.helpDrawer.title': 'Erste Schritte',
  'modellingPage.menu.top.helpDrawer': 'Soforthilfe',
  'modellingPage.menu.top.helpDrawer.complex.step1.title':
    'Eine neue Finanzierungsrunde hinzufügen',
  'modellingPage.menu.top.helpDrawer.complex.step1.description':
    'Wechseln Sie in den Bearbeitungsmodus, indem Sie auf die Schaltfläche "Editierung" in der oberen Leiste klicken. Klicken Sie dann einfach auf einen Knoten im Baum auf der linken Seite, um mit ihm zu interagieren. Beginnen Sie damit, eine Folgerunde zu Ihrer letzten Finanzierungsrunde hinzuzufügen.',
  'modellingPage.menu.top.helpDrawer.complex.step2.title': 'Eingabe der Rundendetails',
  'modellingPage.menu.top.helpDrawer.complex.step2.description':
    'In dem Formular, das sich öffnet, können Sie alle Rundendetails eingeben. Es erlaubt Ihnen auch, einen Wertebereich für Parameter einzugeben, z. B. wenn Sie Ihre genaue Bewertung noch nicht kennen, dann können Sie einen Wertebereich eingeben und es werden alle möglichen Szenarien für Sie simuliert.',
  'modellingPage.menu.top.helpDrawer.complex.step3.title': 'Ergebnisse anzeigen',
  'modellingPage.menu.top.helpDrawer.complex.step3.description':
    'Wechseln Sie in den Ergebnismodus, indem Sie auf die Schaltfläche "Ergebnisse" in der oberen Leiste klicken. Klicken Sie auf einen Knoten im Baum und wählen Sie "Details anzeigen", um die Captable- und Exit-Berechnungen für dieses Szenario zu untersuchen. Alternativ können Sie über die Top-Leiste direkt in den Analysebereich wechseln.',
  'modellingPage.menu.top.helpDrawer.complex.step4.title': 'Analyse-Bereich',
  'modellingPage.menu.top.helpDrawer.complex.step4.description':
    'Im Bereich "Analyse" auf der rechten Seite haben Sie drei Registerkarten: Details, Vergleich und Filter. In der Registerkarte "Details" können Sie die Captable- und Exit-Berechnungen für ein bestimmtes Szenario untersuchen. In der Registerkarte "Vergleichen" können Sie die Anteilsquote und Exit-Renditen verschiedener Anteilseigner in verschiedenen Szenarien vergleichen. Schließlich kann die Registerkarte "Filter" Ihnen helfen, die Anzahl der Szenarien im Baum zu reduzieren, um nur realistische Ergebnisse zu behalten.',

  'projectsStats.filterBy.CREATED_DATE': 'Creation Date',
  'projectsStats.filterBy.MODIFIED_DATE': 'Last Edit',
  'usersStats.filterBy.CREATED_DATE': 'Signup',
  'usersStats.filterBy.MODIFIED_DATE': 'Login',

  'esop.editGrants': 'Mitarbeiteroptionen hinzufügen/bearbeiten',
  'vestingModal.selectedPersons.confirmOverride':
    '{override}/{total} der ausgewählten Zeilen haben bereits Vesting Schedules.<br /> Sind Sie sicher, dass Sie diese überschreiben wollen?',
  'general.checkAGB':
    'Ich habe die <a href="https://ventury-analytics.de/terms-of-use" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen<a/> gelesen und bin mit ihnen einverstanden',
  'general.updatedAGB':
    'Wir haben unsere Nutzungsbedingungen aktualisiert, bitte lesen und akzeptieren Sie diese, um fortzufahren.',
  'general.updatedAGBTitle': 'Nutzungsbedingungen wurden aktualisiert',

  'newRound.pathName': 'Add new financing round',
  'newRound.steps.shareholder.name': 'Neue Anteilseigner hinzufügen',
  'newRound.steps.shareholder.title': 'Neue Anteilseigner hinzufügen',
  'newRound.steps.shareholder.subtitle': 'Gibt es neue Anteilseigner, die investiert haben?',
  'newRound.steps.shareclass.name': 'Eine neue Anteilsklasse hinzufügen',
  'newRound.steps.shareclass.title': 'Eine neue Anteilsklasse hinzufügen',
  'newRound.steps.shareclass.subtitle': 'Welche Anteilsklasse wurde gekauft?',
  'newRound.steps.newRound.name': 'Neue Investitionen hinzufügen',
  'newRound.steps.newRound.title': 'Eine neue Finanzierungsrunde hinzufügen',
  'newRound.steps.newRound.subtitle':
    'Einschließlich aller Investitionen in Anteile und Wandelschuldverschreibungen',
  'newRound.steps.finalCheck.name': 'Abschlusskontrolle',
  'newRound.steps.finalCheck.title': 'Wir sind fast fertig.',
  'newRound.steps.finalCheck.subtitle': 'Lassen Sie uns überprüfen, ob alle Daten korrekt sind.',

  'overview.esopBox.newEmployees': 'Neue Mitarbeiter hinzufügen',
  'overview.esopBox.grantOptions': 'Mitarbeiteroptionen von {esopName} anlegen',
  'overview.esopBox.noEsopAdded':
    'Bisher wurde noch kein esop erstellt. Bitte klicken Sie, um einen Pool einzurichten.',
  'overview.esopBox.addEsop': 'Neuen V(E)SOP hinzufügen',
  'overview.modellingBox.title':
    'Modellieren Sie Ihre zukünftigen Runden, Cap Tables und Szenarien',
  'overview.modellingBox.continueModelling': 'Modellierung fortsetzen "{modellingName}"',
  'overview.modellingBox.addModelling': 'Neues Modellierungsprojekt starten',
  'overview.modellingBox.bodyTitle': 'Fortsetzen Ihrer Modellierungsprojekte',
  'overview.modellingBox.bodySubtitle':
    'Wählen Sie ein bestehendes Projekt oder erstellen Sie ein neues',
  'overview.modellingBox.initial.bodyTitle': 'Beginnen Sie mit Ihrem ersten Modellierungsprojekt!',
  'overview.modellingBox.initial.bodySubtitle':
    'Ein Experimentierfeld zur Simulation von Zukunftsszenarien und zur Auswertung der Ergebnisse',
  'overview.waterfallBox.title': 'Wasserfallrechnung',
  'overview.waterfallBox.extendedAnalysis': 'Ausführliche Analyse',
  'overview.waterfallBox.tableTitle': 'Exit-Verteilung (heute)',
  'overview.exportBox.title': 'Exportieren Sie Cap Tables, Wasserfallrechnungen & Transaktionen',
  'overview.exportBox.header.export': 'Exportieren',
  'overview.exportBox.header.round': 'Runde',
  'overview.exportBox.header.date': 'Exit-Datum',
  'overview.exportBox.waterfall': 'Wasserfallrechnungen exportieren',
  'overview.exportBox.capTables': 'Cap Table exportieren',
  'overview.exportBox.transactionHistory': 'Transaktionsverlauf exportieren',
  'overview.exportBox.consultingService':
    'Benötigen Sie Hilfe oder zusätzliche Dienstleistungen? Nehmen Sie Kontakt mit unserem Team auf!',

  'overview.esopBox.title': 'Verwalten Sie Ihre Mitarbeiterbeteiligungsprogramme',
  'overview.companyBox.lastRound': 'Letzte Runde: {roundName}',
  'overview.companyBox.title': 'Unternehmensinformationen von {companyName}',
  'overview.companyBox.newRound': 'Eine neue Finanzierungsrunde hinzufügen',
  'capTable.recap.roundDate': 'Runden Datum',
  'capTable.recap.shareholders': 'Gesellschafter',
  'overview.titleBox.morning': 'Guten Morgen, {name}',
  'overview.titleBox.noon': 'Guten Tag, {name}',
  'overview.titleBox.afternoon': 'Guten Tag, {name}',
  'overview.titleBox.evening': 'Guten Abend, {name}',
  'overview.titleBox.seeWhatsHappening': 'Sehen Sie, was in "{companyName}" passiert',
  'overview.updateBox.thingsTodo': 'Was noch zu tun ist',
  'overview.updateBox.recentChanges': 'Letzte Änderungen',
  'overview.updateBox.todos.continue':
    'Fahren Sie fort, Ihre historischen Finanzierungsinformationen hinzuzufügen',
  'overview.updateBox.todos.invite':
    'Laden Sie andere Gesellschafter ein, um sie einfach auf dem Laufenden zu halten',
  'overview.updateBox.todos.esop': 'Einrichten eines Mitarbeiteroptionsplans für Ihr Unternehmen',
  'overview.updateBox.todos.grant': 'Gewähren Sie Optionen an Ihre Mitarbeiter',
  'overview.updateBox.todos.vesting': 'Vestingpläne für Gründer oder Mitarbeiter hinzufügen',
  'overview.updateBox.todos.documents':
    'Hochladen Ihrer Gesellschaftervereinbarungen für gemeinsamen Zugriff',
  'overview.updateBox.todos.payouts':
    'Hinzufügen zusätzlicher Auszahlungsstufen wie z. B. Gründer-Catch-Ups',
  'overview.updateBox.todos.allDone': 'Alles erledigt. Nichts mehr zu tun.',

  'vestingTable.founders.title': 'Vesting-Pläne der Gründer',
  'vestingTable.grants.title': 'Vesting-Pläne der Mitarbeiter',
  'vestingModal.founders.title': 'Hinzufügen/Editieren',
  'vestingModal.grants.title': 'Hinzufügen/Editieren',
  'vestingModal.newVestingSchedule.label': 'Neuer Vestingplan',
  'vestingModal.selectedPersons.label': 'Betroffene Personen auswählen',
  'vestingModal.selectionTable.columns.name': 'Name',
  'vestingModal.selectionTable.columns.pool': 'Assoziierter Pool',
  'vestingModal.selectionTable.columns.amountOfShares': 'Anzahl der Anteile',
  'vestingModal.selectionTable.columns.typeName': 'Typ',
  'vestingModal.selectionTable.columns.roundName': 'Runde',
  'vestingModal.selectionTable.columns.subjectToVesting': 'Unterliegt bereits einem Vestingplan',
  'vestingModal.founderVesting.percentUnderlyingVesting': 'Vesting Grundlage',
  'vestingModal.founderVesting.percentUnderlyingVesting.suffix': 'von den {shareAmount}Anteilen',
  'esop.defaultVestingSchedule.info':
    'In der folgenden Tabelle kann ein Standard-Vestingplan für Ihren V(E)SOP-Pool erstellt werden. Er wird automatisch auf alle Optionen angewendet, die für den Pool ausgegeben werden. Natürlich können Sie ihn nachträglich für einzelne Mitarbeiter bearbeiten.',

  'esopGrant.exceltable.columns.shareAmount': 'Anzahl Optionen',
  'esopGrant.exceltable.columns.expirationDate': 'Auslaufdatum',
  'esopGrant.exceltable.columns.strikePrice': 'Ausübungspreis',
  'esopGrant.exceltable.columns.cliffPercent': 'Cliff %',
  'esopGrant.exceltable.columns.cliff': 'Cliff in Monaten',
  'esopGrant.exceltable.columns.vestingPercent': 'Vesting %',
  'esopGrant.exceltable.columns.months': 'Vesting Zeitraum (in Monaten)',
  'esopGrant.exceltable.columns.vestingTime': 'Vestinginterval',
  'esopGrant.exceltable.columns.accelerationOnExit': 'Vesting Aufholung im Exit-Fall',
  'esop.addGrants': 'Mitarbeiteroptionen hinzufügen',
  'esop.suffix': 'für {poolName}',
  'esopGrant.exceltable.rowErrorMsg':
    'Bitte stellen Sie einen gültigen Vestingplan zur Verfügung (voll ausgefüllt mit/ohne Cliff).',
  'esopGrant.excelmodal.showVesting': 'Vestingplan anzeigen',
  'esopGrant.excelmodal.hideVesting': 'Vestingplan ausblenden',
  'esopGrant.exceltable.columns.complexVesting': 'Komplexer Vestingplan',
  'esopGrant.exceltable.validator.exceedsPoolsize':
    'Die Summe der eingegebenen Mitarbeiteroptionen ({total}) übersteigt die Größe des V(E)SOP ({poolSize}).',
  'esopGrant.exceltable.info.1':
    'Fügen Sie alle Optionen hinzu, die gewährt worden sind oder gewährt werden. Sie können diese Informationen jederzeit bearbeiten.',
  'esopGrant.exceltable.info.2': 'Sie haben vergessen, einen Mitarbeiter hinzuzufügen?',
  'esopGrant.exceltable.info.3':
    'Der Vestingplan und der Ausübungspreis werden mit Werten aus dem letzten Rundenpreis und dem V(E)SOP Standard-Vestingplan gefüllt. Sie können komplexere Vestingpläne hinzufügen, indem Sie die Mitarbeiteroptionen auf der Vesting-Seite bearbeiten.',
  here: 'hier',
  'esopGrant.exceltable.validator.expirationDate':
    'Das Datum muss nach dem Datum der Schaffung des V(E)SOP ({esopDate}) und der Ausgabe der Optionen ({grantDate}) liegen.',
  'esopGrant.exceltable.validator.date':
    'Das Datum muss nach dem Erstellungsdatum des V(E)SOP ({esopDate}) liegen.',

  'esop.planned': 'Geplant',
  'esop.addEmployees': 'Mitarbeiter hinzufügen/bearbeiten',
  'employee.importdata.info.1':
    'Hinzufügen, Bearbeiten und Löschen von Mitarbeitern des Unternehmens.',
  'employee.importdata.info.2':
    'Sie können den Mitarbeitern Optionen gewähren und Vestingpläne verwalten.',
  'employee.importdata.info.3': 'Name ist das einzige Pflichtfeld.',
  'employee.importdata.title': 'Mitarbeiter hinzufügen/bearbeiten',
  'esop.defaultVestingSchedule.label': 'Vesting Vorlage anlegen',
  'esop.defaultVestingSchedule.cliff': 'Cliff',
  'esop.defaultVestingSchedule.cliff.text1': ' nach ',
  'esop.defaultVestingSchedule.cliff.text2': ' Monaten.',
  'esop.defaultVestingSchedule.cliffPercent': 'Cliff Prozent',
  'esop.defaultVestingSchedule.cliffMonths': 'Cliff Monate',
  'esop.defaultVestingSchedule.columns.vestingPeriod': 'Vesting Periode',
  'esop.defaultVestingSchedule.columns.percent': '%',
  'esop.defaultVestingSchedule.columns.months': 'Vesting in Monaten',
  'esop.defaultVestingSchedule.columns.vestingTime': 'Vestinginterval',
  'esop.defaultVestingSchedule.validator.percentSum':
    'Die Gesamtsumme ({percentTotal}) von Prozent aus Vesting ({percentVesting}) und Cliff ({percentCliff}) muss 100% betragen',
  'esop.defaultVestingSchedule.validator.percent':
    'Bitte geben Sie den Prozentsatz der gevesteten Anteile für die Vesting-Periode ein.',
  'esop.defaultVestingSchedule.validator.months':
    'Bitte geben Sie die Vesting-Dauer in Monaten ein (min. 1).',
  'esop.defaultVestingSchedule.validator.vestingTime':
    'Bitte geben Sie ein, wie oft das Vesting angewandt wird (min. 1).',

  'esopTable.title': 'V(E)SOPs',
  'manualSharesForm.date': 'Einzahlungsdatum',
  'manualSharesForm.dateRequired': 'Bitte geben Sie ein Datum ein',
  'cnConversionsTable.exceedsMaximum':
    'Der Wandlungsbetrag übersteigt das Gesamtinvestment des Wandeldarlehens.',

  'buyOutForm.duplicateBuyOut':
    'Es gibt bereits einen Kauf von diesem Käufer für den angegebenen Verkäufer, bitte passen Sie Anteile und Preis in der anderen Zeile an',
  'buyOutForm.buyerRequired': 'Ein Käufer muss ausgewählt werden',
  'buyOutForm.sellerRequired': 'Ein Verkäufer muss ausgewählt werden',
  'buyOutForm.sameSellerAndBuyer':
    'Bitte wählen Sie einen Verkäufer, der sich von dem des Käufers unterscheidet',
  'buyOutForm.buyingShareRequired': 'Es muss eine gekaufte Anteilsklasse ausgewählt werden',
  'buyOutForm.sellingShareRequired': 'Es muss eine verkaufte Anteilsklasse ausgewählt werden',
  'buyOutForm.buyingShare': 'Gekaufte Anteilsklasse',
  'buyOutForm.sellingShare': 'Verkaufte Anteilsklasse',
  'buyOutForm.numberOfSharesRequired':
    'Bitte geben Sie die Anzahl der Anteile ein, die gekauft wurden',
  'buyOutForm.notEnoughShares':
    'Die Anzahl ({sumOfBoughtShares}) der gekauften Anteile übersteigt die Anzahl der Anteile ({numberOfShares}), die der Verkäufer aus der verkauften Anteilsklasse besitzt.',
  'buyOutForm.pricePerShareRequired':
    'Bitte geben Sie den Einkaufspreis ein oder geben Sie einfach 1.0 ein',

  'buyOuts.importdata.title': 'Hinzufügen/Editieren von mehreren Buy Outs',
  'buyOuts.importdata.info.1':
    'In dieser Tabelle können Sie auf einfache Weise mehrere Buy Outs für diese Finanzierungsrunde eingeben oder kopieren',
  'buyOuts.importdata.info.2': 'Die Pflichtfelder sind mit einem Sternchen (*) gekennzeichnet',
  'buyOuts.importdata.info.3':
    'Sie können diese Informationen später jederzeit über die Bearbeitungsseite ändern',

  'manualShares.importdata.title': 'Hinzufügen/Editieren von mehreren manuellen Anteilseinträgen',
  'manualShares.importdata.info.1':
    'In dieser Tabelle können Sie auf einfache Weise manuelle Anteilseinträge für diese Finanzierungsrunde eingeben (z. B. für Anti-Dilution oder andere Reduktionen)',
  'manualShares.importdata.info.2': 'Die Pflichtfelder sind mit einem Sternchen (*) gekennzeichnet',
  'manualShares.importdata.info.3':
    'Sie können diese Informationen später jederzeit über die Bearbeitungsseite ändern',

  'guidedTour.helpMenu.documentation': 'Dokumentation',
  'shareholder.importdata.title': 'Hinzufügen/Editieren von mehreren Anteilseignern',
  'equityInvestments.importdata.title':
    'Hinzufügen/Editieren von mehreren Eigenkapital Investments',
  'equityInvestments.importdata.info.1':
    'In dieser Tabelle können Sie ganz einfach alle Ihre Beteiligungen für diese Finanzierungsrunde kopieren und einfügen',
  'equityInvestments.importdata.info.2': 'Alle Felder sind erforderlich',
  'equityInvestments.importdata.info.3': 'Sie haben vergessen, einen Anteilseigner hinzuzufügen? ',
  'importdata.info.justAddIt': 'Einfach hier hinzufügen',

  'investmentForm.preMoneyFloorVsCap':
    'Der Pre-Money-Cap muss größer oder gleich als der Pre-Money-Floor parameter sein.',
  'investmentForm.investorRequired': 'Ein Anteilseigner muss ausgewählt sein',
  'edit.pathName': 'Editieren der Transaktionshistorie',
  'guidedTour.helpMenu.feedback': 'Gib Feedback',
  'companyFormModal.title.add': 'Firma hinzufügen',
  'companyFormModal.title.edit': 'Firma editieren',
  back: 'Zurück',
  'roundForm.shareRequired': 'Bitte spezifizieren Sie die Anteilsklasse der Runde',
  'transactionTables.transactionSelect.title': 'Transaktionsarten der Runde auswählen',
  'edit.selectTermsheet.editRound': 'Runde editieren',

  'manualSharesTable.title': 'Manuelle Anteilsverteilung',
  'manualSharesTable.buttons.add': 'Manuellen Eintrag hinzufügen',
  'manualSharesForm.stakeholderRequired': 'Bitte wählen Sie den Anteilseigner aus.',

  'buyoutsTable.title': 'Buy Outs',
  'buyoutsTable.buttons.add': 'Buy Out hinzufügen',
  'buyoutsTable.columns.headers.totalPaidAmount': 'Gesamter Gezahlter Betrag',
  'buyoutsTable.columns.headers.shares': 'Anteile',
  'buyoutsTable.exceedsMaximum': 'Buy Out überschreitet die Anzahl an Anteilen von dem Investor.',

  'cnConversionsTable.title': 'Wandelbare Darlehen',
  'cnConversionsTable.columns.headers.amount': 'Gesamter möglicher Wandelbetrag',
  'cnConversionsTable.columns.headers.nominal': 'Wandelbarer Nominalbetrag',
  'cnConversionsTable.columns.headers.interest': 'Wandelbare Zinsen',
  'cnConversionsTable.columns.headers.amountOfShares': 'Neue Anteile',
  'cnConversionsTable.buttons.showInterestCalc': 'Zinsberechnungen anzeigen',
  'cnConversionsTable.buttons.edit': 'Editieren',
  'cnConversionsTable.buttons.convert': 'Wandeln',
  'cnConversionsTable.buttons.convertAll': 'Alles wandeln',
  'cnConversionsTable.buttons.convertNone': 'Wandlungen Rückgängig machen',

  'securities.shareclasses': 'Anteilsklassen',
  'cnInvestmentsTable.columns.headers.tranches': 'Tranchen',
  'cnInvestmentsTable.columns.headers.interest': 'Zinsen',
  'cnInvestmentsTable.columns.headers.capAndDiscount': 'Cap/Discount',
  'cnInvestmentsTable.columns.text.cap': 'Cap',
  'cnInvestmentsTable.columns.text.floor': 'Floor',
  'cnInvestmentsTable.columns.text.discount': 'Discount',
  'shareholder.exceltable.columns.typeSuffix': '(z.B. Gründer oder Venture Capitalist)',
  'cnInvestmentsTable.buttons.add': 'Wandeldarlehen hinzufügen',
  'cnInvestmentsTable.buttons.edit': 'Wandeldarlehen editieren',
  'cnInvestmentsTable.title': 'Wandeldarlehen Investitionen',

  // Translated
  'shareclassTable.delete.defaultOptions':
    'Stammanteile und Optionen sind Standardoptionen, die nicht gelöscht werden können.',
  'shareclassTable.delete.shareUsed':
    'Die Anteilskasse wird noch in {roundName} benutzt. Bitte ändern Sie die Runde zuerst.',
  'shareclassTable.columns.name': 'Anteilsklasse',
  'shareclassTable.columns.type': 'Typ',
  'shareclassTable.columns.seniority': 'Seniorität',
  'shareclassTable.columns.details': 'Details',
  'shareclassTable.columns.lpInformation': 'LP Informationen',
  'shareclassTable.columns.notes': 'Notizen',

  'shareclassTable.type.commonShares': 'Stammanteile',
  'shareclassTable.type.options': 'Optionen',
  'shareclassTable.type.preferredShares': 'Vorzugsanteile',

  'shareclassTable.notes.noNotes': 'Keine Notizen gespeichert',
  'shareclassTable.notes.showNotes': 'Notizen anzeigen',
  'shareclassTable.antiDilution': 'Verwässerungsschutz',

  'share.votingrights': 'Stimmrechte',
  'payouts.current': 'Aktuelle Ausschüttungen',

  'capped.participation.help.title': 'Kappung der Erlösverteilung der Anteilsklasse',
  'capped.participation.help.excerpt':
    'Einschränkung der Anteilsklasse an der Exitpartizipation bis zu einem gewissen Gesamtbetrag. Danach folgt in der Regel eine Wandlung der Anteilsklasse.',
  'capped.participation.NONE.SLP.help.title': 'Keine Begrenzung',
  'capped.participation.NONE.SLP.help.excerpt':
    'Das ist der Standard bei einer anrechenbaren Liquidationspräferenz. Der Investor wird im Fall einer pro rata Beteiligung nicht begrenzt.',
  'capped.participation.INVESTMENT_RETURN.SLP.help.title':
    'Begrenzung auf den Gesamterlös der Anteilsklasse',
  'capped.participation.INVESTMENT_RETURN.SLP.help.excerpt':
    'Das ist eine ungewöhnliche Regelung. Im Falle einer anrechenbaren Liquidationspräferenz hat dies auch keine Auswirkung. Hier darf nicht weniger als der Investmentbetrag bzw. der Vorzugsbetrag eingegeben werden.',
  'capped.participation.NONE.PLP.help.title': 'Investorenfreundliche Variante',
  'capped.participation.NONE.PLP.help.excerpt':
    'Die Anteilsklasse erhält keine Begrenzung bei der Auszahlung der Exiterlöse.',
  'capped.participation.INVESTMENT_RETURN.PLP.help.title': 'Gründerfreundliche Variante',
  'capped.participation.INVESTMENT_RETURN.PLP.help.excerpt':
    'Begrenzung der Auszahlung an die Anteilsklasse. Hier wird ein maximaler Gesamtbetrag eingetragen, der der Anteilsklasse zusteht. Dieser setzt sich aus dem Präferenzbetrag sowie der folgenden pro rata Beteiligung zusammen.',

  'shareclass.add.modal.info': 'Bitte alle Kondititionen der Anteilsklasse angeben',
  'shareclass.add.modal.title.edit': 'Anteilsklasse editieren',
  'shareclass.add.modal.title': 'Neue Anteilsklasse',
  'shareclass.add.shareclass.button': 'Anteilsklasse hinzufügen',
  'guidedTour.introSteps.shareclass.name': 'Anteilsklassen',
  'guidedTour.introSteps.shareclass.title': 'Anteilsklassen',
  'guidedTour.introSteps.shareclass.subtitle': 'Fügen sie Ihre Anteilsklassen hinzu',
  'revisionTable.usernameDisplay.supportNote':
    'Dies deutet darauf hin, dass das Feld aufgrund eines Software-Upgrades aktualisiert wurde.',
  'revisionTable.usernameDisplay.support': 'Ventury Software Update',
  'entity.CnConversion.date': 'Einzahlungsdatum',
  'entity.CnConversion.share.name': 'Anteilsklasse',
  'entity.EquityInvestment.date': 'Einzahlungsdatum',
  'entity.EquityInvestment.share.name': 'Anteilsklasse',
  'entity.Share.votingRights': 'Stimmrechte',
  'investmentForm.date': 'Einzahlungsdatum',
  'investmentForm.shareclass': 'Anteilsklasse',
  'investmentForm.dateRequired': 'Bitte geben Sie ein Datum ein',
  'investmentForm.shareclassRequired': 'Bitte wählen Sie eine Anteilsklasse aus',
  'excelliketable.import.edit.button': 'Mehrere hinzufügen',
  'equityInvestmentsTable.buttons.add': 'Eigenkapital Investment hinzufügen',
  'equityInvestmentsTable.buttons.edit': 'Eigenkapital Investment editieren',
  'roundDisplay.buttons.showCapTable': 'Zeige den Cap Table',
  'equityInvestmentsTable.title': 'Eigenkapital Investitionen',
  'equityInvestmentsTable.quota.before': 'Vor Runde',
  'equityInvestmentsTable.quota.after': 'Nach Runde',
  'shareholder.exceltable.error.name': 'Name des Investors muss angegeben werden',
  'shareholder.exceltable.error.type': 'Kein gültiger Investortyp ausgewählt',
  'shareholder.exceltable.error.email': 'E-Mail muss den regulären Standards entsprechen',
  'exceltable.rowInvalid': 'Die Reihe ist ungültig',
  'exceltable.cellError':
    'Fehler in der Reihe {rowNumber}, Spalte {colNumber} mit dem Wert "{value}" - {error}',
  'exceltable.ACTIONS': 'Aktionen',
  'exceltable.ID': 'Reihe',

  'termsheet.stillHasPayOut':
    'Es existiert noch eine Auszahlungsstufe ({name}) in welcher der Investor partizipiert. Bitte entfernen Sie diese zuerst.',
  'termsheet.stillHasBuyOut':
    'Es existiert noch ein Buy Out in {roundName} von dem Investor. Bitte entfernen Sie zuerst den Buy Out.',
  'termsheet.stillHasDefaultInvestor':
    'Es existiert noch eine Vertretung durch {userName}. Bitte entfernen Sie zuerst diesen Bezug.',
  'termsheet.stillHasEsopGrant':
    'Es existieren noch gewährte Optionen in {roundName}. Bitte entfernen Sie zuerst die Optionen.',
  'termsheet.stillHasEsop':
    'Es existieren V(E)SOP Pools in welchen er als Träger angegeben ist. Bitte ändern Sie erst die V(E)SOPs ab.',
  'termsheet.stillHasConversions':
    'Es existiert noch eine Wandlung in {roundName}. Bitte entfernen Sie zuerst die Wandlung',
  'termsheet.stillHasInvestment':
    'Es existiert noch eine Investition in {roundName}. Bitte entfernen Sie zuerst die Investition.',

  'general.invitation': 'Einladung',
  'stakeholdersPage.acceptedInvitation':
    'Die Einladung wurde angenommen und der Nutzer hat zugriff auf das Projekt.',
  'userProfile.companyURL': 'Company URL',
  'userProfile.companyInfo.urlRequired': 'Company URL wird benötigt',
  // Translated (Malte 03.10.2020)
  'shareholder.initial.button': 'Investoren hinzufügen',
  'guidedTour.introSteps.shareholder.name': 'Investoren',
  'guidedTour.introSteps.shareholder.title': 'Investoren',
  'guidedTour.introSteps.shareholder.subtitle': 'Fügen Sie all Ihre Investoren hinzu',
  'import.excel.heading': 'Importieren Sie Ihre Investoren via Excel',
  'import.excel.subheading':
    'Laden Sie sich einfach unsere Excel-Template runter und tragen Sie die benötigten Informationen ein',
  'shareholder.active.transactions': 'Entfernen nicht möglich, Investor hat aktive Transaktionen',
  'shareholder.table.delete.title': 'Diesen Investor wirklich löschen?',
  'stakeholder.importdata.info.1':
    'Füge <b>alle</b> Shareholder hinzu, die bisher in dein Unternehmen investiert haben oder werden. Sie können diese Informationen jederzeit auf der Stakeholderseite oder in der Guided-Tour bearbeiten',
  'stakeholder.importdata.info.2':
    'Benutzen Sie die Tabelle so wie sie es aus Excel gewohnt sind. Einfach kopieren und einfügen!',
  'stakeholder.importdata.info.3': 'Name und Typ sind Pflichtfelder',
  'exceltable.upload.import.button': 'Von Template importieren',
  'exceltable.template.download.button': 'Excel-Template',
  'exceltable.upload.importFromTemplate.instructions.hint': 'Zulässige Dateiendungen: .xls',
  'exceltable.upload.importFromTemplate.instructions.title':
    'Klicken oder ziehen Sie das vorgefüllte Template in diesen Bereich',
  'exceltable.upload.importFromTemplate.title': 'Upload Template',
  'excelTable.importdata.title': 'Daten importieren',
  'excelTable.importdata.ok': 'Daten importieren',
  'shareholder.add.shareholder.modal.content':
    'Bisher wurden noch keine Investoren angelegt. Bitt clicken sie Investoren hinzufügen.',
  'shareholder.add.shareholder.modal.title': 'Investoren hinzufügen',
  'shareholder.add.shareholder.button': 'Investor hinzufügen',
  'shareholder.add.modal.title': 'Investor hinzufügen',
  'shareholder.add.modal.title.edit': 'Investor editieren',
  'shareholder.add.modal.ok.edit': 'Speichern',
  'shareholder.modal.type': 'Typ',

  'entity.Share.liquidationPreference.customSharePrice': 'Alternativer Anteilspreis',
  'shareForm.liquidationPreference.customSharePrice': 'Alternativer Anteilspreis',
  'shareForm.liquidationPreference.customSharePriceQuestion': 'Fester statt bezahlter Preis?',
  // Translated (Malte 09.09.2020)
  'verification.email.sent': 'Bestätigungsemail versendet',
  'verification.email.sent.desc':
    'Eine weitere Bestätigunsemail wurde an folgende Adresse versendet {email}',
  'verification.email.resendEmail': 'Bestätigungsemail erneut versenden',
  // Translated (Jakob 07.09.2020)
  'billing.upgradeTemp.subject': 'Anfrage bezüglich Ventury Analytics Premium für Gründer',
  'billing.upgradeTemp.message':
    'Ich interessiere mich für Ventury Premium für Gründer und bitte um Rückmeldung.',

  // Translated (Malte 31.08.2020)
  'valuationInput.roundPrice.label': 'Preis',
  'enums.roundTypes.FOUNDING': 'Gründung',
  'enums.roundTypes.BUYOUT': 'Buy Out Runde',
  'enums.roundTypes.CONVERTIBLE_ONLY': 'Wandeldarlehen Runde',
  'enums.roundTypes.PRE_SEED': 'Pre Seed',
  'enums.roundTypes.SEED': 'Seed',
  'enums.roundTypes.SERIES_A': 'Series A',
  'enums.roundTypes.SERIES_B': 'Series B',
  'enums.roundTypes.SERIES_C': 'Series C',
  'enums.roundTypes.SERIES_D': 'Series D',
  'enums.roundTypes.SERIES_E': 'Series E',
  'enums.roundTypes.CUSTOM': 'Standard Runde',
  'roundForm.type': 'Runden Typ',
  'roundForm.typeRequired': 'Bitte spezifizieren sie den Typ der Runde',
  'roundForm.cashIn': 'Eingesammeltes Kapital',
  'roundForm.cashInRequired':
    'Bitte spezifizieren sie wieviel Geld in dieser Runde investiert wird',
  'roundForm.cashInNotEqual':
    'Der Betrag des eingesammelten Kapitals ({cashIn}) ist nicht gleich der Summer aller Investitionen ({totalInvestments}). Fahren sie fort falls die Post-Money-Bewertung korrekt ist.',

  'interestRateTable.totalAmount.hoverHelp.title': 'Präferenzbetrag Berechnung',
  'interestRateTable.totalAmount.hoverHelp.content.formula': 'Gesamt = Kapital * Multiple + Zinsen',
  'interestRateTable.totalAmount.hoverHelp.content.calculation':
    '{total} = {principal} * {multiple} + {interest}',
  'interestRateTable.endDate.hoverHelp.title': 'Angewandtes Enddatum (limitiert bei Monaten)',
  'interestRateTable.endDate.hoverHelp.content':
    'Das originale Enddatum {endDate} limitiert auf maximal {limitInMonths} Monate.',
  'interestRateTable.interestAmount.hoverHelp.title': 'Zinsberechnung',
  'interestRateTable.interestAmount.hoverHelp.content.explain.principal':
    'Kapitalbetrag K ({principal})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.interestRate':
    'Zinssatz i ({interestRate})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.time':
    'Zeit t in Jahren ({time} = {days} Tage / {denominator})',
  'interestRateTable.interestAmount.hoverHelp.content.explain.years':
    'Ganze Jahre y ({years} = {days} Tage / {denominator} abgerundet)',
  'interestRateTable.interestAmount.hoverHelp.content.explain.yearsRemaining':
    'Verbleibende Jahre r ({yearsRemaining})',
  'interestRateTable.interestAmount.hoverHelp.content.formula': 'Zinsen = K * i * t',
  'interestRateTable.interestAmount.hoverHelp.content.formula.cumulative':
    'Zinsen = K * (1+i)^y * (1+(i*r)) - K',
  'interestRateTable.title': 'Zinsberechnungen für Präferenzbeträge',
  'interestRateTable.nominal': 'Kapitalbetrag',
  'interestRateTable.interestRate': 'Zinssatz',
  'interestRateTable.startDate': 'Startdatum',
  'interestRateTable.endDate': 'Enddatum',
  'interestRateTable.days': 'Tage',
  'interestRateTable.method': 'Methode',
  'interestRateTable.interestAmount': 'Zinsen',
  'interestRateTable.totalAmount': 'Gesamt',

  // translated (Patrick 10.08.2020)
  'groupPage.organization.infoText':
    'Dies ist die Übersichtsseite Ihrer Organisation. Hier können Sie Ihre Mitglieder verwalten und den Premium-Zugang für Ihre verschiedenen Projekte aktivieren.',
  'groupPage.members.infoText':
    'Im Mitgliederbereich können Sie Mitglieder der Organisation hinzufügen und verwalten.' +
    'Jedes hinzugefügte Mitglied kann unabhängig allen Projekten beitreten. ' +
    'Sie erhalten die gleichen Zugriffsrechte auf die Projekte wie Sie.',
  'groupPage.packages.infoText':
    'Im Abschnitt "Pakete" können Sie sehen, wie viele Pakete Sie bereits gekauft haben. ' +
    'Sie können auch überprüfen, wie viele Kontingente in einem Paket noch verfügbar sind, wann sie auslaufen und für welche Projekte einige davon bereits verwendet wurden. ',
  'groupPage.projects.infoText':
    'Dies ist die Übersicht über alle Projekte, die zur Organisation gehören. Durch Klicken auf "Beitreten" können Sie so vielen Projekten beitreten, wie Sie möchten. ' +
    'Hier können Sie Ihre Kontingente auch verwenden, um Projekte in Premium-Projekte umzuwandeln. ' +
    'Bitte beachten Sie, dass ein Kontingent unwiederbringlich verbraucht wird.',
  'groupPage.projects.upgradeProject.confirm':
    'Wollen Sie dieses Projekt auf Premium hochstufen? Dies wird 1 Kontingent verbrauchen.',
  // Translated (Jakob 12.08.2020)
  'export.captable.filename': 'captable-ventury-export.xlsx',
  'export.waterfall.filename': 'waterfall-calculations-ventury-export.xlsx',
  // Newly translated (Jakob 08.08.2020)
  'extendedTable.searchBtn': 'Suchen',
  'extendedTable.resetBtn': 'Zurücksetzen',
  // Newly translated (Jakob 24.07.2020)
  'investmentForm.amountOfShares': 'Anteile',
  'investmentForm.amountOfSharesRequired':
    'Bitte spezifizieren sie wieviele Anteile übertragen werden sollen',
  'percentOfMaxInput.otherFormat': '({value}{max})',
  'percentOfMaxInput.showMax': 'max. {max}',
  'termsheet.convertibleNoteEdit': 'Wandeldarlehen bearbeiten',
  'general.import.success': 'Erfolgreicher Import des Projekts!',
  'general.import.failed':
    'Der Import des Projekts ist fehlgeschlagen. Es ist möglicherweise nicht vollständig.',
  'general.import.failedModelling':
    'Der Import der Modellierungsprojekte schlug fehl. Sie sind möglicherweise nicht vollständig.',
  'tranchenForm.tranchenTable.dateOfDeposit': 'Datum der Einzahlung',
  'tranchenForm.tranchenTable.amount': 'Betrag',
  'tranchenForm.tranchenTable.quota': '%',
  'tranchenForm.totalAmount': 'Gesamtbetrag',
  'tranchenForm.name': 'Tranche {idx}',
  'tranchenForm.customProps': 'Verwenden Sie andere Parameter als {name}',
  'tranchenForm.modalTitle': 'Wandeldarlehen Tranchen',
  'tranchenForm.errorTotalAmount': 'Der Gesamtbetrag muss der Summe aller Tranchen entsprechen',
  'tranchenForm.tranchenTable.converted': 'Insgesamt umgewandelt',
  'tranchenForm.tranchenTable.amount.error': 'Minimal Umwandlung',
  'tranchenForm.defaultPriceCalculationMethod': 'Preisberechnungsmethode',
  'tranchenForm.defaultPriceCalculationMethod.isRequired':
    'Bitte wählen Sie eine Preisberechnungsmethode aus',
  'cn.roundName.short': 'WD {roundName}',
  'cn.roundName.long': 'Wandeldarlehen {roundName}',
  'cn.nominal': 'Nominalbetrag',
  'cn.interest': 'Zinsbetrag',

  'conversionForm.modalTitle': '{cnName} Wandlung',
  'conversionForm.total.nominal': 'Gesamt gewandelter Nominalbetrag ',
  'conversionForm.total.interest': 'Gesamt gewandelter Zinsbetrag',
  'conversionForm.total.convertFullBtn.title': 'Vollständige Wandlung',
  'conversionForm.total.convertNoneBtn.title': 'Wandlung entfernen',
  'conversionForm.total.shares.label': 'Zusammenfassung',
  'conversionForm.total.shares.text': 'Wandel {conversionAmount} zu {numberOfShares} Anteilen',
  'conversionForm.trancheForm.fullConversion': 'Vollständig gewandelt',
  'conversionForm.trancheForm.partialConversion': 'Teilweise gewandelt',
  'conversionForm.trancheForm.noConversion': 'Nicht gewandelt',
  'conversionForm.trancheForm.emptyCn': 'Verbraucht',
  'conversionForm.trancheForm.shares': 'zu {numberOfShares} Anteilen',
  'conversionForm.trancheForm.nominal': 'Gewandelter Nominalbetrag',
  'conversionForm.trancheForm.interest': 'Gewandelter Zinsbetrag',

  // Translated
  'esop.pool.lowerThanMinAmountError':
    'Der Umfang des V(E)SOP muss höher sein als die Gesamtzahl der ausgegeben Anteile.',

  'waterfall.exactAmount': 'Genaue Werte anzeigen',
  'menu.projectOverview': 'Übersicht meiner Projekte',
  'menu.backToProject': 'Zurück zum Projekt {name}',
  'stepWiseExitTable.esopResiduals':
    'Restkapital des V(E)SOP (nicht investierte, nicht ausgeübte oder nicht vergebene Anteile)',
  'stepWiseExitTable.esopResiduals.strikeResiduals':
    'Restkapital des V(E)SOP (von ausgeübten Strike-preis Zahlungen)',
  'groupPage.projects.join.disable':
    'Nur Projekte mit einem Gruppenmitglied, das Administrator- oder Eigentümer-Zugriffsrechte hat, können beitreten.',
  'billing.earlyStagePremium.notification.title': 'Antrag auf Early-Stage Premium abgeschickt!',
  'billing.earlyStagePremium.notification.description':
    'Sie werden bald eine E-Mail mit der Bestätigung erhalten.',
  'general.browserIncompatible':
    'Leider unterstützt Ihr Browser diese Funktion nicht. Bitte versuchen Sie einen anderen Browser und melden Sie dies dem Support.',

  'billing.upgradeEnterprise.subject': 'Anfrage bezüglich Ventury Analytics premium Enterprise',
  'billing.upgradeEnterprise.message':
    'Ich interessiere mich für Ventury premium Enterprise und bitte um Rückmeldung.',
  'billing.actions.contact': 'Anfrage',

  // PAYMENT SYSTEM (translated Merlin 29.07.2020)
  'billing.plans.enterprise.individualPrice': 'Anfragen',
  'userProfile.groupInfo': 'Informationen zu der Organisation',
  'userProfile.groupName': 'Name der Organisation',
  'userProfile.groupOwner': 'Organisation Administrator',
  'userProfile.leaveOrganization.toolTip': 'Die Organisation verlassen',
  'userProfile.leaveOrganization.confirm':
    'Sind Sie sicher, dass Sie die Organisation verlassen wollen? <br />' +
    'Der Zugang zu gemeinsamen Projekten bleibt für alle Mitglieder der Organisation bestehen aber neue Projekte werden nicht geteilt.  <br />' +
    'Darüber hinaus verlieren Sie alle von der Organisation erworbenen Premium-Zugangsrechte.  <br />',

  'billing.earlyStagePremium.modal.title': 'Kostenloser Premium-Zugang zu Ventury Analytics',
  'billing.earlyStagePremium.modal.description-1':
    'Es scheint, als hätten Sie Anspruch auf kostenlosen Zugang zu unseren Premium-Funktionen.',
  'billing.earlyStagePremium.modal.description-2':
    'Nutzen Sie das Szenario-Modellierungswerkzeug und Wasserfallberechnungen kostenlos.',
  'billing.earlyStagePremium.modal.description-3':
    'Wenn Sie auf "OK" klicken, werden Sie zur Rechnungsseite weitergeleitet, wo Sie Ihren Statup Konto aktualisieren können.',
  'billing.earlyStagePremium.modal.confirm':
    'Wir bieten deutschen Start-ups, die nicht mehr als 1 Mio. Euro Fördermittel erhalten haben, unsere Software kostenlos an.',

  'adminDashboard.modalForm.validForDays': 'Laufzeit des Pakets in Tagen',
  'adminDashboard.modalForm.contingents': 'Anzahl der gewährten Kontingente',
  'adminDashboard.modalForm.organizationType': 'Organisation-Typ',
  'adminDashboard.modalForm.noSuccess.message':
    'Etwas ist schief gelaufen, bitte wenden Sie sich an den Support.',
  'adminDashboard.modalForm.success.message':
    'Erfolgreich ein neues Paket mit Kontingenten gewährt!',
  'organizationTypes.STARTUP': 'Startup',
  'organizationTypes.BUSINESS_ANGEL': 'Business Angel',
  'organizationTypes.SERVICE_PROVIDER': 'Service Provider', // wer ist hier gemeint?
  'organizationTypes.ENTERPRISE': 'Enterprise',

  'userAccount.group': 'Organisation',
  'userAccount.group.packages': 'Pakete',
  'adminDashboard.appliedPackages': 'Gültige Kontingente Eingesetzt/Gesamt',
  'adminDashboard.upgradeBtn': 'Kontigente gewähren',
  'adminDashboard.modalTitle': 'Kontigente gewähren an {userId}',

  'groupPage.pathName': 'Organisations-Management',
  'groupPage.members.organization': 'Organisation',
  'groupPage.members.invite': 'Einladen eines Organisationsmitglieds',
  'groupPage.members.membersTable.heading': 'Mitglieder',
  'groupPage.members.inviteTable.heading': 'Eingeladen',
  'groupPage.packages.packagesTable.heading': 'Pakete',

  'groupPage.members.inviteUser': 'Nutzer einladen',
  'groupPage.members.modal.checkRemoveFromProjects':
    'Auch aus allen Projekten der Organisation entfernen',
  'groupPage.members.modal.confirmRemoval': 'Bestätigen Sie die Entfernung',
  'groupPage.members.modal.removalQuestion':
    'Wollen Sie den Nutzer aus der Organisation entfernen?',
  'groupPage.invite.startupNotice':
    'Laden Sie bis zu zwei weitere Mitgründer oder Personen aus Ihrem Startup ein. Bitte beachten Sie, dass sie den gleichen E-Mail-Suffix haben müssen (z.B. @your-bussiness.com). Sie werden automatisch zu Ihrem Projekt hinzugefügt und haben Zugang zu allen Premium-Features!',
  'groupPage.invite.generalNotice':
    'Laden Sie andere Mitglieder Ihrer Organisation ein. Sie werden Zugang zu allen erstellten Projekten haben. Jedes Organisation-Mitglied kann den Projekten beitreten. Sie haben keinen Zugriff auf die Verwaltungsseite, nur der Ersteller der Organisation verwaltet die Premium-Upgrades.',
  'groupPage.invite.error.sameDomain':
    'Der Eingeladene muss dieselbe E-Mail-Domäne haben wie der Gruppenbesitzer.',
  'groupPage.invite.error.emailInvalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'groupPage.invite.error.emailRequired': 'Bitte geben Sie die E-Mail-Adresse des Benutzers ein',
  'groupPage.invite.error.emailExists': 'Diese E-Mail existiert bereits',
  'groupPage.invite.error.startupLimitNotice': 'Das Startup-Paket erlaubt maximal 3 Mitglieder',
  'groupPage.deleteMember.confirmation':
    'Möchten Sie diesen Benutzer aus der Organisation entfernen?',
  'groupPage.packages.orderId': 'Order Id',
  'groupPage.packages.contingents': 'Kontingente',
  'groupPage.packages.boughtAt': 'Gekauft am',
  'groupPage.packages.validUntil': 'Gültig bis',
  'groupPage.packages.usedBy': 'Genutzt von',
  'groupPage.packages.project': 'Projekt',
  'groupPage.packages.usedAt': 'Benutzt am',
  'groupPage.projects.column.companyName': 'Unternehmensname',
  'groupPage.projects.column.operations': 'Beitreten',
  'groupPage.projects.join': 'Beitreten',
  'groupPage.projects.column.upgrade': 'Premium',
  'groupPage.projects.upgrade': 'Upgrade',
  'groupPage.projects.premium': 'Premium',
  'groupPage.projects.cardTitle': 'Organisation-Projekte',
  'groupInvitationPage.pathName': 'Organisation-Einladung',
  'groupInvitationPage.accepted': 'Sie haben die Einladung zu der Organisation angenommen!',
  'paywall.buyAdditionalPackage': 'Zusätzliches Paket kaufen',
  'paywall.premiumRequired': 'Premium notwendig',
  'paywall.premiumRequired.description': 'Upgraden Sie Ihr Konto, um auf diese Seite zuzugreifen',
  'paywall.contactOwner':
    'Sie haben keinen Zugriff, um das Projekt zu upgraden. Wenden Sie sich wegen eines Upgrades an den Manager Ihrer Organisation. ',
  'paywall.upgradeProject': 'Upgrade zu premium',
  'paywall.noContingents': 'Sie haben keine Kontingente.',
  'paywall.modal.title': 'Projekt upgraden',
  'paywall.modal.description':
    'Upgraden Sie den Gruppenzugang zu dem Projekt auf Premium, um auf dieses Feature benutzen zu können. Ein Kontingent wird beim Upgrade verbraucht.',
  'topBar.menu.organization': 'Organisation-Management',
  'premiumProjectStar.tooltip': 'Premium Projekt',
  'billing.actions.renew': 'Erneuern',
  'billing.success.backToProject': 'Zurück zum Projekt',
  'billing.success.title': 'Sie haben erfolgreich auf Premium upgegradet!',
  'billing.success.description':
    'Wir haben die Zahlungsbestätigung erhalten und Ihr Konto hochgestuft. Über die Schaltfläche in der oberen Leiste können Sie die Organisationsdetails einsehen.',
  'billing.success.goGroup': 'Organisation anzeigen',
  'project.premiumAccessGranted': 'Sie haben den Premium-Zugang zum Projekt jetzt freigeschalten!',
  'project.premiumAccess.contingentUsed': 'Ein Kontingent wird aus Ihrem Paket verbraucht.',
  'project.joined.message': 'Sie sind dem Projekt beigetreten!',
  'project.joined.description': 'Erkunden Sie Ihre Stakeholder-Position im Unternehmen.',

  // Translated 23.06.2020
  'roundForm.noPostMoneyVal': 'Cash-In von der Post-Money-Bewertung ausschließen',
  'general.automatic': 'automatisch',

  // Translated 27.04.2020 (jakob)
  'waterfall.calculationInfos': 'Berechnungsinformationen (IRR/Multiple)',
  'waterfall.totalInvestments': 'Gesamtinvestitionsbetrag',
  'conversionPointSwitcher.totalPreferenceAmounts': 'Präferenzbeträge Gesamt',
  'conversionPointSwitcher.conversionPoint': 'Wandlungspunkt {name}',
  'conversionPointSwitcher.conversionPoints': 'Wandlungspunkt von: {names}',
  'conversionPointSwitcher.label': 'Wandlungspunkte',
  'payout.amount': 'Präferenzbeträge',

  'stepWiseExitTable.title': 'Exit-Verteilung nach Auszahlungsstufen',
  'stepWiseExitTable.columns.shareholder': 'Gesellschafter',
  'stepWiseExitTable.columns.equityholding': 'Anteilsquote (voll verwässert)',
  'stepWiseExitTable.columns.payoutLevel': 'Auszahlungsstufe {level} {suffix}',
  'stepWiseExitTable.columns.remainingProceeds': 'Verbleibender Erlös (Pro Rata)',
  'stepWiseExitTable.columns.totalProceeds': 'Gesamterlös',

  'exitRightTypes.LP': 'Liquidationspräferenz',
  'exitRightTypes.PAY_OUT': 'Auszahlung',
  'exitRightTypes.CN_PAY_BACK': 'Auszahlung WD',
  'exitRightTypes.DEBT_PAY_BACK': 'Auszahlung Schulden',
  'exitRightTypes.PRO_RATA_CAP': 'Pro Rata Cap',
  'exitRightTypes.PRO_RATA': 'Pro Rata',
  'exitRightTypes.SECONDARY': 'Secondary',
  'exitRightTypes.OTHER': 'Other',
  'exitRightTypesShort.LP': 'LP',

  // Translated 25.04.2020
  'revisionPage.pathName': 'Überarbeitungen',
  'revisionTable.columns.modifiedBy': 'Editor',
  'revisionTable.columns.entityRevTypes': 'Änderungen',
  'revisionTable.columns.revisionDate': 'Änderungsdatum',
  'revisionTable.title.allChanges': 'Änderungshistorie',
  'revisionTable.title.recentChanges': 'Letzte Änderungen',
  'entityHistory.columns.modifiedBy': 'Editor',
  'entityHistory.columns.operation': 'Type of change',
  'entityHistory.columns.revisionDate': 'Änderungsdatum',
  'entityHistory.entityDetails.previousValue': 'Original {type}',
  'entityHistory.entityDetails.newValue': 'Neu {type}',
  'entityHistory.showOnlyChanges.switch': 'Nur Änderungen zeigen',
  'revisionType.ADD': 'Hinzugefügt',
  'revisionType.MOD': 'Bearbeitet',
  'revisionType.DEL': 'Gelöscht',
  'revisionTable.changeDisplay': '{revisionType} a{n} {entityName}', // Bitte checken
  'revisionTable.usernameDisplay.noUser': 'Nutzer konnte nicht gefunden werden (Deleted?)',
  'revisionModal.title': 'Änderungshistorie für {suffix}',
  'entity.name': '{entityName} {name}',

  'entity.EsopSetup': 'Mitarbeiteroptionen Rechner',
  'entity.EsopSetup.exitAmount': 'Exit-Betrag',
  'entity.EsopSetup.exitDate': 'Exit-Datum',
  'entity.EsopSetup.defaultCompensationPeriodInMonths': 'Kompensationszeitraum',
  'entity.EsopSetup.bonusCompensationLevels': 'Kompensationsstufen',
  'entity.EsopSetup.bonusCompensationLevels.name': 'Stufe',
  'entity.EsopSetup.bonusCompensationLevels.percentFromSalary': '% vom Gehalt',

  'entity.Investor': 'Gesellschafter',
  'entity.Investor.name': 'Name',
  'entity.Investor.type': 'Typ',
  'entity.Investor.email': 'E-Mail',
  'entity.Investor.jobTitle': 'Job-Titel',
  'entity.Investor.salary': 'Gehalt jährl.',

  'entity.Company': 'Unternehmen',
  'entity.Company.name': 'Name',
  'entity.Company.sector': 'Branche',
  'entity.Company.location': 'Ort',
  'entity.Company.companyLogoURL': 'Firmenlogo',
  'entity.Company.companyURL': 'Firmen Website',
  'entity.Company.exist': 'EXIST',
  'entity.Company.invest': 'INVEST',
  'entity.Company.districtCourt': 'Amtsgericht',
  'entity.Company.registrationNumber': 'Handelsregisternummer',
  'entity.Company.information': 'Information',
  'entity.Company.address.additional': 'Weitere Informationen',
  'entity.Company.address.street': 'Straße',
  'entity.Company.address.city': 'Stadt',
  'entity.Company.address.postcode': 'PLZ',
  'entity.Company.address.country': 'Land',
  'entity.InvestmentRound': 'Finanzierungsrunde',
  'entity.InvestmentRound.date': 'Datum',
  'entity.InvestmentRound.name': 'Name',
  'entity.InvestmentRound.type': 'Typ',
  'entity.InvestmentRound.cashIn': 'Cash-In',
  'entity.InvestmentRound.preMoneyValuation': 'Pre-Money-Bewertung',
  'entity.InvestmentRound.share.name': 'Anteil',
  'entity.Share': 'Anteil',
  'entity.Share.name': 'Name',
  'entity.Share.seniority': 'Seniorität',
  'entity.Share.text': 'Text',
  'entity.Share.liquidationPreference.multiple': 'LP Multiple',
  'entity.Share.liquidationPreference.simple': 'LP Participating',
  'entity.Share.liquidationPreference.simple.SLP': 'SLP',
  'entity.Share.liquidationPreference.simple.PLP': 'PLP',
  'entity.Share.liquidationPreference.agreedConversion': 'LP Wandlung',
  'entity.Share.liquidationPreference.senior': 'LP senior',
  'entity.Share.liquidationPreference.capType': 'LP Cap Typ',
  'entity.Share.liquidationPreference.cap': 'LP Cap',
  'entity.Share.liquidationPreference.interestRate.interestRate': 'LP Zinssatz',
  'entity.Share.liquidationPreference.interestRate.cumulative': 'LP Zinseszins',
  'entity.Share.liquidationPreference.interestRate.accumulationType': 'LP Art der Verzinsung',
  'entity.Share.liquidationPreference.interestRate.retainDividends':
    'LP Zinssatz bei der Wandlung beibehalten',
  'entity.Share.liquidationPreference.interestRate.limitInMonths': 'LP Verzinsungsperiode',
  'entity.Share.liquidationPreference.interestRate.limitAsDate': 'LP Verzinsungslimit',
  'entity.Share.antiDilution.type': 'Anti-Dilution Typ',
  'entity.Share.antiDilution.compensation': 'AD Ausgleich',
  'entity.Share.antiDilution.duration': 'AD Dauer',
  'entity.Share.antiDilution.transferType': 'AD Art der Übertragung',
  'entity.PayOut': 'Auszahlungen',
  'entity.PayOut.name': 'Name',
  'entity.PayOut.seniority': 'Seniorität',
  'entity.PayOut.amount': 'Betrag',
  'entity.PayOut.receivers': 'Empfänger',
  'entity.PayOut.receivers.name': 'Gesellschafter',
  'entity.PayOut.distributionTable': 'Verteilung',
  'entity.PayOut.distributionTable.investor.name': 'Gesellschafter',
  'entity.PayOut.distributionTable.amount': 'Auszahlungsbetrag',
  'entity.BaseProject': 'Projekt',
  'entity.BaseProject.name': 'Name',
  'entity.BaseProject.roundingMode': 'Rundungsmethode',
  'entity.BaseProject.currencyCode': 'Währung',
  'entity.BaseProject.simulateAD': 'Berechnung der Anti-Dilution',
  'entity.ProjectDocument': 'Dokument',
  'entity.ProjectDocument.title': 'Title',
  'entity.ProjectDocument.dateAdded': 'Anlagedatum',
  'entity.ProjectDocument.uploader.firstname': 'Vorname',
  'entity.ProjectDocument.uploader.lastname': 'Nachname',
  'entity.ProjectMembership': 'Project Membership', // was ist ddamit gemeint?
  'entity.ProjectMembership.projectRole': 'Zugriffsrechte', // was ist ddamit gemeint?
  'entity.ProjectMembership.defaultInvestor.name': 'Represented Stakeholder', // was ist ddamit gemeint?
  'entity.ProjectMembership.userAccount.firstname': 'Vorname',
  'entity.ProjectMembership.userAccount.lastname': 'Nachname',
  'entity.ProjectInvitation': 'Einladung',
  'entity.ProjectInvitation.userEmail': 'E-Mail',
  'entity.ProjectInvitation.guestName': 'Name',
  'entity.ProjectInvitation.projectRole': 'Zugriffsrechte',
  'entity.ProjectInvitation.defaultInvestor.name': 'Represented Stakeholder',
  'entity.EquityInvestment': 'Eigenkapital Investment',
  'entity.EquityInvestment.round.name': 'Runde',
  'entity.EquityInvestment.investor.name': 'Gesellschafter',
  'entity.EquityInvestment.amount': 'Betrag',
  'entity.EquityInvestment.amountOfShares': 'Anzahl Shares',
  'entity.EquityInvestment.pricePerShare': 'Preis pro Anteil',
  'entity.EquityInvestment.vestingSchedule.cliff': 'Cliff in Monaten',
  'entity.EquityInvestment.vestingSchedule.cliffPercent': 'Cliff in %',
  'entity.EquityInvestment.vestingSchedule.accelerationOnExit':
    'Aufholung des Vestings im Exit-Fall',
  'entity.EquityInvestment.vestingSchedule.startDate': 'Start Datum',
  'entity.EquityInvestment.vestingSchedule.percentUnderlyingVesting':
    'Prozent die Vesting unterliegen',
  'entity.EquityInvestment.vestingSchedule.schedule': 'Vesting Plan',
  'entity.EquityInvestment.vestingSchedule.schedule.percent': 'Vesting %',
  'entity.EquityInvestment.vestingSchedule.schedule.months': 'Vesting in monaten',
  'entity.EquityInvestment.vestingSchedule.schedule.vestingTime': 'Vestinginterval',
  'entity.CnConversion': 'Wandlung des Wandeldarlehens',
  'entity.CnConversion.round.name': 'Runde',
  'entity.CnConversion.investor.name': 'Gesellschafter',
  'entity.CnConversion.amount': 'Vollständiger Betrag',
  'entity.CnConversion.amountofShares': 'Anzahl Shares',
  'entity.CnConversion.interestAmount': 'Zinsen Betrag',
  'entity.CnConversion.pricePerShare': 'Preis pro Anteil',
  'entity.CnInvestment': 'Wandeldarlehen Investment',
  'entity.CnInvestment.round.name': 'Runde',
  'entity.CnInvestment.investor.name': 'Gesellschafter',
  'entity.CnInvestment.amount': 'Betrag',
  'entity.CnInvestment.convertibleNote.discount': 'Discount',
  'entity.CnInvestment.convertibleNote.dateOfDeposit': 'Einzahlungsdatum',
  'entity.CnInvestment.convertibleNote.maturityDate': 'Fälligkeitsdatum',
  'entity.CnInvestment.convertibleNote.preMoneyCap': 'Pre-Money-Bewertung Cap',
  'entity.CnInvestment.convertibleNote.forcedPaymentOnConversion': 'Nachzahlungsbetrag',
  'entity.CnInvestment.convertibleNote.interestRate.interestRate': 'CN Zinssatz',
  'entity.CnInvestment.convertibleNote.interestRate.cumulative': 'CN Zinseszins',
  'entity.CnInvestment.convertibleNote.interestRate.accumulationType': 'CN Art der Verzinsung',
  'entity.CnInvestment.convertibleNote.interestRate.retainDividends':
    'CN LP Zinssatz bei der Wandlung beibehalten',
  'entity.CnInvestment.convertibleNote.interestRate.limitInMonths': 'CN Verzinsungsperiode',
  'entity.CnInvestment.convertibleNote.interestRate.limitAsDate': 'CN Verzinsungslimit',
  'entity.CnInvestment.convertibleNote.share.name': 'Erworbene Anteile',
  'entity.BuyOut': 'Buy Out',
  'entity.BuyOut.round.name': 'Runde',
  'entity.BuyOut.buyer.name': 'Käufer',
  'entity.BuyOut.seller.name': 'Verkäufer',
  'entity.BuyOut.amount': 'Betrag',
  'entity.BuyOut.pricePerShare': 'Preis pro Anteil',
  'entity.BuyOut.buyingShare.name': 'Erworbene Anteilsklasse',
  'entity.BuyOut.sellingShare.name': 'Verkaufte Anteilsklasse',
  'entity.BuyOut.vestingSchedule.cliff': 'Vesting cliff in Monaten',
  'entity.BuyOut.vestingSchedule.cliffPercent': 'Vesting cliff in %',
  'entity.BuyOut.vestingSchedule.accelerationOnExit': 'Vesting akzeleration',
  'entity.BuyOut.vestingSchedule.startDate': 'Start Datum',
  'entity.BuyOut.vestingSchedule.percentUnderlyingVesting': 'Prozent die Vesting unterliegen',
  'entity.BuyOut.vestingSchedule.schedule': 'Vesting Plan',
  'entity.BuyOut.vestingSchedule.schedule.percent': 'Vesting in %',
  'entity.BuyOut.vestingSchedule.schedule.months': 'Vesting in Monaten',
  'entity.BuyOut.vestingSchedule.schedule.vestingTime': 'Vestinginterval',
  'entity.ManualShares': 'Manuelle Eingabe von Anteilen',
  'entity.ManualShares.name': 'Name',
  'entity.ManualShares.round.name': 'Runde',
  'entity.ManualShares.share.name': 'Anteil',
  'entity.ManualShares.investor.name': 'Gesellschafter',
  'entity.ManualShares.investment': 'Investmentbetrag',
  'entity.ManualShares.price': 'Preis',
  'entity.ManualShares.shares': 'Anzahl der Anteile',
  'entity.ManualShares.isVirtualBacking': 'Virtual Anteile',
  'entity.ManualShares.notes': 'Notizen',
  'entity.EsopCreation': 'V(E)SOP',
  'entity.EsopCreation.esop.name': 'Name',
  'entity.EsopCreation.esop.dilutionType': 'Dilution type', // was ist das?
  'entity.EsopCreation.esop.notes': 'Notizen',
  'entity.EsopCreation.round.name': 'Runde',
  'entity.EsopCreation.valuationType': 'Valuation type', // was ist das?
  'entity.EsopCreation.shareAmount': 'Pool-Größe',
  'entity.EsopCreation.backingTable': 'V(E)SOP Träger',
  'entity.EsopCreation.backingTable.investor.name': 'Gesellschafter',
  'entity.EsopCreation.backingTable.numberOfShares': 'Anzahl der Anteile',
  'entity.EsopCreation.defaultVestingSchedule.cliff': 'Standard Cliff in Monaten',
  'entity.EsopCreation.defaultVestingSchedule.cliffPercent': 'Standard Cliff in %',
  'entity.EsopCreation.defaultVestingSchedule.accelerationOnExit':
    'Aufholung des Vestings im Exit-Fall',
  'entity.EsopCreation.defaultVestingSchedule.schedule': 'Standard Vesting Plan',
  'entity.EsopCreation.defaultVestingSchedule.schedule.percent': 'Vesting %',
  'entity.EsopCreation.defaultVestingSchedule.schedule.months': 'Vesting in monaten',
  'entity.EsopCreation.defaultVestingSchedule.schedule.vestingTime': 'Vestinginterval',

  'entity.EsopGrant': 'Gewährte V(E)SOP',
  'entity.EsopGrant.esop.name': 'V(E)SOP',
  'entity.EsopGrant.round.name': 'Runde',
  'entity.EsopGrant.receiver.name': 'Begünstigter',
  'entity.EsopGrant.strikePrice': 'Ausübungspreis',
  'entity.EsopGrant.date': 'Datum',
  'entity.EsopGrant.expirationDate': 'Auslaufdatum',
  'entity.EsopGrant.shareAmount': 'Anzahl der Anteile',
  'entity.EsopGrant.vestingSchedule.cliff': 'Vesting cliff in Monaten',
  'entity.EsopGrant.vestingSchedule.cliffPercent': 'Vesting cliff in %',
  'entity.EsopGrant.vestingSchedule.accelerationOnExit': 'Vesting akzeleration',
  'entity.EsopGrant.vestingSchedule.startDate': 'Start Datum',
  'entity.EsopGrant.vestingSchedule.percentUnderlyingVesting': 'Prozent die Vesting unterliegen',
  'entity.EsopGrant.vestingSchedule.schedule': 'Vesting Plan',
  'entity.EsopGrant.vestingSchedule.schedule.percent': 'Vesting in %',
  'entity.EsopGrant.vestingSchedule.schedule.months': 'Vesting in Monaten',
  'entity.EsopGrant.vestingSchedule.schedule.vestingTime': 'Vestinginterval',
  'entity.EsopGrant.packageCalculation.packageValue': 'Optionspaket-Wert',
  'entity.EsopGrant.packageCalculation.salaryCompensation': 'Gehaltsverzicht',
  'entity.EsopGrant.packageCalculation.bonusCompensation': 'Variabler Bonus',
  'entity.EsopGrant.packageCalculation.compensationPeriodInMonths': 'Kompensationszeitraum',
  'entity.EsopGrant.packageCalculation.percentOfPackageBackedByThisGrant':
    '% vom Optionspaket getragen bei den Optionen',

  'date.today': 'Heute',
  'date.yesterday': 'Gestern',

  'd3.format.giga': 'Mrd',

  'general.enabled': 'Aktiviert',
  'general.disabled': 'Deaktiviert',

  // Translated Jakob (April 11th)
  'investmentForm.interestRate.types.title': 'Verschiedene Zinsmethoden',
  'investmentForm.interestRate.types.excerpt':
    'Es gibt verschiedene Definitionen zur Berechnung des Zinssatzes. ' +
    'Wir unterstützen die 5 gebräuchlichsten Methoden zur Berechnung auf jährlicher Basis. ' +
    'Für weitere Informationen bezüglich der Tageszählung der Zinsberechnung folgen Sie bitte dem Link. ',
  'investmentForm.interestRate.types.link': 'https://www.investopedia.com/terms/d/daycount.asp',
  // Translated Jakob (April 6th)
  'payout.distributionTable.fullyDiluted': 'FD',
  'payout.distributionTable.fullyDiluted.title': 'Vollständig verwässerte Anteile',
  'payout.distributionTable.fullyDiluted.excerpt':
    'Benutze die Eigenkapitalbeteiligungsquote (voll verwässert) der selektierten Runde um die Auszahlung aufzuteilen.',
  'payout.distributionTable.receivedAmount': 'Auszahlungsbetrag',
  'payout.distributionTable.quota': 'Auszahlungsanteil',
  'termsheet.manualSharesDelete': 'Entferne {name}',
  'termsheet.manualSharesAdd': 'Manuell Anteile hinzufügen',
  'termsheet.manualSharesEdit': 'Editier {name}',
  'termsheet.manualSharesModal.title': 'Manueller Eintrag',
  'enums.eventTypes.MANUAL_SHARES': 'Manueller Eintrag',
  'manualSharesForm.info':
    'Dieses Formular bietet die Möglichkeit, manuell Anteile hinzuzufügen.  ' +
    'Dies kann z.B. bei Abweichungen in Berechnungen oder derzeit nicht unterstützten Funktionen nützlich sein.  ' +
    'Geben Sie einfach einen Namen und die Anzahl der Anteile ein, die subtrahiert bzw. hinzugefügt werden sollen. ' +
    'Optional kann eine Investition oder ein Preis mit dem Eintrag verknüpft werden.  ' +
    'Falls Sie virtuelle Anteile ausgeben wollen (z.B. V(E)SOP-Backing), kreuzen Sie einfach das Kästchen an.  ' +
    'Der Eintrag wird in der Transaktionshistorie und dem Cap Table angezeigt. ',

  'antiDilution.warning.title': 'Verwässungsrunde',
  'antiDilution.warning.description':
    'Wir haben eine Abwertung in der Bewertung des Unternehmens festgestellt und den Verwässerungsschutz berechnet. ' +
    'Sie wird aktualisiert, wenn Sie die Informationen ändern. ',
  'antiDilution.disabled': 'Deaktiviert',
  'antiDilution.title': 'Ausgelöster Verwässerungsschutz',
  'antiDilution.switch': 'Abweichungen in den Berechnungen? Deaktivieren! ',
  'antiDilution.switch.hoverHelp.title':
    'Deaktivieren der automatischen Berechnung des Verwässerungschutzes',
  'antiDilution.switch.hoverHelp.excerpt':
    'Wenn der automatisch berechnete Verwässerungsschutz Abweichungen zu Ihren Berechnungen aufweist: ' +
    'Deaktivieren Sie sie einfach und geben Sie die Informationen manuell über "Optionen - Manuelle Eingabe von Anteilen" ein.',

  'manualSharesForm.negativeSharesError.message':
    'Der Anteilseigner besitzt nicht genügend Anteile dieser Art!',
  'manualSharesForm.negativeSharesError.description':
    'Bitte stellen Sie sicher, dass der Anteilseigner über genügend Anteile verfügt, da negative Anteile nicht möglich sind.',
  manualSharesDisplay: 'Andere',
  'manualSharesDisplay.notes': 'Anmerkungen',
  'manualSharesDisplay.isVirtualBacking': 'V(E)SOP Trägerschaft',
  'manualSharesForm.name': 'Name (z.B. Alternativer Anteilskauf)',
  'manualSharesForm.nameRequired': 'Bitte geben Sie die Namenskennung ein.',
  'manualSharesForm.investment': 'Assoziierte Investitionen',
  'manualSharesForm.price': 'Assoziierter Preis',
  'manualSharesForm.amountOfShares': 'Anzahl der Anteile',
  'manualSharesForm.amountOfSharesRequired': 'Bitte geben Sie die Anzahl der Anteile ein.',
  'manualSharesForm.shareType': 'Anteilstyp',
  'manualSharesForm.shareTypeRequired': 'Bitte wählen Sie einen Anteilstyp aus',
  'manualSharesForm.isVirtualBacking': 'Anteile sind virtuell (z.B. V(E)SOP-Trägerschaft)',
  'manualSharesForm.notes': 'Anmerkungen (z.B. Beschreibung)',

  // Translated Jakob (March 5th)
  'waterfall.payoutstructure.diagram.from': 'Partizipiert ab {exitAmount} Exit Einnahmen',
  'waterfall.payoutstructure.diagram.total': 'Gesamt',
  'waterfall.payoutstructure.diagram.title': 'Auszahlungskanal',
  'termsheet.esop.label': 'V(E)SOPs',
  'esop.grant.max': '(Max. Poolgröße - {poolSize}({poolSizePct}))',
  'bugReportPage.exportImportProject': 'Export/Import eines Projekts (nur für Admins)',
  'bugReportPage.exportProject': 'Projekt exportieren',
  'bugReportPage.importProject': 'Projekt importieren',
  'modellingPage.superForm.error.validForms':
    'Das Formular enthält noch Fehler. Die fehlenden Felder sind rot markiert und unten aufgelistet.',
  'modellingPage.superForm.error.emptyInvestors':
    'Bitte geben Sie einen Namen für den Investor ein und entfernen Sie alle Investoren ohne Investitionen.',
  'modellingPage.superForm.error.cnOrEquitySelected':
    'Bitte wählen Sie für die Finanzierungsrunde entweder eine CN-Investition, eine Equity-Investition oder beides aus.',
  'modellingPage.superForm.error.equitySelected':
    'Wenn Sie die Registerkarte "Eigenkapital" gewählt haben, müssen Sie Investoren hinzufügen, die Eigenkapital investieren. ' +
    'Andernfalls heben Sie bitte die Markierung auf.  (Möglicherweise müssen Sie zuerst die Registerkarten wechseln)',
  'modellingPage.superForm.error.cnSelected':
    'Wenn Sie die Registerkarte "Wandeldarlehen" gewählt haben, müssen Sie Investoren hinzufügen, die Wandeldarlehen investieren. ' +
    'Andernfalls heben Sie bitte die Markierung auf.  (Möglicherweise müssen Sie zuerst die Registerkarten wechseln)',
  // Translated Jakob (March 4th)
  'transactionTimeline.exitReturns': 'Exit Einnahmen',
  'termsheet.parValueAdd': 'Nominalwert-Investition hinzufügen',
  'termsheet.parValueEdit': 'Nominalwert-Investition bearbeiten',
  'termsheet.parValueDelete': 'Nominalwert-Investition löschen',
  'termsheet.parValueDisplay.label': 'Nominalwert Anteile',
  'termsheet.parValueModal.title': 'Nominalwert Anteile',
  'parValueForm.sharesNumberRequired': 'Bitte geben Sie die Anzahl der Anteile ein.',

  // Translated Jakob (March 2nd)
  'stakeholdersPage.inviteUser.success': '{name} wurde eingeladen zu dem Projekt.',
  'stakeholdersPage.inviteUser.success.description':
    'Der Benutzer wurde per E-Mail benachrichtigt und kann die Einladung annehmen.',
  'stakeholdersPage.saveInvitation.success': 'Die Einladung von {name} wurde aktualisiert.',
  'stakeholdersPage.removeUser.success': 'Der Benutzer wurde vom Projekt entfernt',
  'stakeholdersPage.removeUser.success.description':
    'Der Benutzer wurde per E-Mail benachrichtigt und hat keinen weiteren Zugriff auf das Projekt.',
  'stakeholdersPage.revokeInvitation.success': 'Die Einladung von {email} wurde widerrufen.',
  'stakeholdersPage.revokeInvitation.success.description':
    'Der Benutzer wird per E-Mail benachrichtigt, dass die Einladung storniert wurde.',
  'stakeholdersPage.saveUser.success': 'Die Zugriffsrechte von {name} wurden aktualisiert.',
  'stakeholdersPage.saveUser.success.description':
    'Der Benutzer wird per E-Mail über die Änderungen informiert.',
  'stakeholdersPage.resendInvitation.success':
    'Eine weitere Email Einladung wurde an {email} gesendet.',
  'stakeholdersPage.resendInvitation.success.description':
    'Bitte benachrichtigen Sie auch die eingeladene Person, dass die E-Mail möglicherweise im Spam-Ordner sein könnte.',

  'general.beta': 'Beta',
  'termsheet.equityDelete': 'Investition löschen',
  'termsheet.cnDelete': 'Wandeldarlehen löschen',
  // Translated Jakob (February 28th - 16:00)
  'esop.pool.excludeShareholders': 'Gesellschafter von der Verwässerung ausschließen.',
  'menu.upgradePremium.title': 'Premium Account benötigt',
  'menu.upgradePremium': 'Upgraden Sie Ihr Konto, um diese Funktion zu erhalten.',

  'bugReportPage.uniqueProjectId': 'Project-Erkennungnummer',
  'bugReportPage.uniqueProjectId.title': 'Project-Erkennungnummer',
  'bugReportPage.uniqueProjectId.excerpt':
    'Eine eindeutige Kennung für dieses Projekt. Auf Anfrage können Sie die Nummer dem Support zur Verfügung stellen, um ihm bei der Identifizierung des Problems zu helfen.',
  'general.venturySupport': 'Ventury Support',
  'modellingPage.welcome.title.back': 'Fortsetzen Ihrer Modellierungsprojekte',
  'modellingPage.welcome.title2.back':
    'Wählen Sie ein bestehendes Projekt oder erstellen Sie ein neues',
  'modellingPage.tree.fieldNames.roundDate': 'Runden Datum',
  'date.validation.title': 'Datumsvalidierung',
  'date.validation.excerpt':
    'Der Zeitpunkt muss nach der vorherigen und vor der nächsten Runde liegen. Alle ungültigen Termine sind deaktiviert.',
  'modellingPage.superForm.scenarioCount.parentInfo':
    'Anzahl der insgesamt generierten Szenarien (multipliziert mit der Konfiguration der vorherigen Finanzierungsrunde).',
  'modellingPage.welcome.project.startNew': 'Hier klicken für neues',

  'esop.pool.byPriceAdjustment.info.title': 'Getragen von alten Investoren durch Preisanpassung',
  'esop.pool.byPriceAdjustment.info.excerpt':
    'Ermäßigung des Standardrundenpreises für neue Investoren durch Einbeziehung der neuen V(E)SOP-Anteile in die Preisberechnung',

  'modellingPage.analysis.details.scenario.infoText.title': 'Mehrere Szenarien',
  'modellingPage.analysis.details.scenario.infoText.excerpt':
    'Es gibt mehrere Szenarien, die zum gleichen Ergebnis führten. Dies kann passieren, wenn sich die Parameter ausgleichen (z.B. Wandeldarlehen-Discount und Pre-Money-Cap) oder wenn höhere Fehlertoleranzen für Anteilsquoten/Exit-Renditen angewendet werden. Sie können die Szenarien auf der Grundlage ihrer verschiedenen Parameter auswählen (in dieser Runde oder in einer der vorhergehenden).',

  'modellingPage.superForm.nonEditableInvestors.title': 'Neue Investoren - nicht editierbar',
  'modellingPage.superForm.nonEditableInvestors.excerpt':
    'Neue Investoren werden anhand ihres Namens identifiziert und für zukünftige Runden zu den bestehenden Investoren hinzugefügt. Der Name ist daher nicht editierbar.',

  'modellingPage.superForm.cnForcedConversion.title': 'Annahmen für Wandeldarlehen',
  'modellingPage.superForm.cnForcedConversion.excerpt':
    'Wandeldarlehen werden in der nächsten Runde auf der Grundlage der vereinbarten Bewertung und des runden Preises unter Anwendung von Discounts und Zinsen zwangsweise umgewandelt.',

  'modellingPage.superForm.priceCalculation.title': 'Preisberechnung',
  'modellingPage.superForm.priceCalculation.excerpt':
    'Der runde Preis wird auf der Grundlage der <b>Pre-Money-As-If-Converted-Bewertung</b> geteilt durch die Gesamtzahl der <b>völlig verwässerten Anteils</b> berechnet.',

  'modellingPage.superForm.esopPoolSize.title': 'V(E)SOP Pool',
  'modellingPage.superForm.esopPoolSize.excerpt':
    'Der Prozentsatz basiert auf dem Post-Money-Pool mit vollständig verwässerten Anteilen, und es wird davon ausgegangen, dass der Pool von allen Aktionären getragen wird. ',

  'modellingPage.analysis.rangeWarning.excerpt':
    'Szenarien, die für jeden Investor das <b>gleiche Ergebnis (Anteilsbesitz und Exitgewinne)</b> haben, werden als <b>ein Ergebnis zusammengefasst.</b> <br /> <br />' +
    'Dies kann geschehen, wenn sich die Parameter ausgleichen (z.B. CN-Discount und Pre-Money-Cap) oder wenn sie sich nicht direkt auf die Anteil-/Exit-position auswirken.',

  'modellingPage.analysis.rangeWarning.multipleSummarized':
    '<b>{filteredResults} Gefilterte Ergebnisse</b> bleiben übrig, nachdem <b>{scenarios} Szenarien</b> zu <b>{results} Ergebnissen</b> zusammengefasst wurden und Filter angewendet wurden.',

  // Translated Jakob (February 23rd - 17:00)
  'portfolio.info':
    'Die Portfolio-Seite zeigt eine Übersicht über alle Unternehmen, an denen Sie beteiligt sind. ' +
    'Wenn Sie eine Beteiligung haben, wird Ihnen der IRR und ein Multiple basierend auf einem Exit, als ob das Unternehmen heute zur letzten Post-Money Bewertung verkauft worden wäre. ' +
    'Klicken Sie auf die einzelnen Zeilen, um die letzten Transaktionen zu sehen.',
  'modellingPage.welcome.privateProject':
    'Modellingprojekte sind privat und nur sie haben Zugriff darauf. Fühlen Sie sich frei herumzuprobieren!',
  'verifyEmail.welcome': 'Willkommen bei Ventury Analytics!',
  'verifyEmail.description':
    'Wir haben einen Bestätigungslink an Ihre E-Mail Adresse geschickt.<br/>Um fortfahren zu können, bestätigen Sie zuerst Ihre E-Mail Adresse, um den Anmeldeprozess zu beenden. Überprüfen Sie auch Ihren Spam Ordner.',
  'verifyEmail.haveVerified': 'Ich haben meinen Account verifiziert!',
  'verifyEmailPage.pathName': 'E-Mail-Verifizierung',
  // Translated Patrick (February 22th - 17:00)
  payout: 'Auszahlung',
  'modellingPage.tree.fieldNames.appliedDiscount': 'Angewandter Discount-Parameter',
  'modellingPage.tree.fieldNames.appliedDiscount.preMoneyCap': 'Cap',
  'modellingPage.tree.fieldNames.appliedDiscount.discount': 'Discount',
  'modellingPage.tree.fieldNames.appliedDiscount.either':
    'Discount/Cap ({discount}, {preMoneyCap})',

  'guided.defaultPrice': 'Standardpreis für neue Investitionen',
  'guided.customPrice': 'Manueller Preis',
  'conversionModal.conversionPrice': 'Preis pro Anteil (Vergünstigt)',

  // Translated Jakob (February 21th - 10:00)
  'modellingPage.analysis.result.name': 'Ergebnis {idx}',
  'topBar.accountType': 'Kontoart:',
  'topBar.breadcrumbs.home': 'Startseite',
  'accountRights.SUPPORT': 'Support',
  'help.inviteSupport': 'Support Einladen',
  'help.inviteSupport.confirm':
    'Dadurch wird ein Mitglied des offiziellen Ventury Analytics Support Teams zu Ihrem Projekt eingeladen. <br />' +
    'Dieser wird Zugang zu all Ihren hochgeladenen Daten haben. Sie können den Support jederzeit über diese Seite entfernen.',
  'help.inviteSupport.confirmation':
    'Der Support ist eingeladen und wird sich bald mit Ihnen in Verbindung setzen!',

  // Translated by Jakob & Merlin (February 20th - 12:00)
  '404.description': 'Die Seite ist veraltet, gelöscht oder existiert nicht mehr.',
  '404.goBack': 'Zurück zur Startseite',
  '404.heading': 'Seite nicht gefunden',
  '404.pathName': 'Seite nicht gefunden',
  absolute: 'Absolut',
  'accessDeniedPage.button': 'Zurück zur Übersicht',
  'accessDeniedPage.description':
    'Sie können nur auf Projekte zugreifen, für die Sie über ausreichende Berechtigungen verfügen.',
  'accessDeniedPage.goBack': 'Zurück zur Übersicht',
  'accessDeniedPage.heading': 'Zugang verweigert',
  'accessDeniedPage.pathName': 'Zugang verweigert',
  'accessDeniedPage.reportBug': 'Einen Fehler melden',
  'accountRights.ADMIN': 'Administrator',
  'accountRights.EDITOR': 'Editor',
  'accountRights.OWNER': 'Eigentümer',
  'accountRights.VIEWER': 'Betrachter',
  'accountRights.LIMITED_VIEWER': 'Betrachter (Limitiert)',
  'accountRights.title': 'Kontorechte',
  adPrice: 'Verwässerungsschutz-Preis',
  add: 'Hinzufügen',
  addLow: 'hinzufügen',
  'address.additional': 'Zusätzliche Informationen',
  'address.city': 'PLZ, Stadt',
  'address.country': 'Land',
  'address.street': 'Straße, Hausnummer',
  'address.streetRequired': 'Bitte geben Sie eine Straße ein',
  admin: 'Administrator',
  after: 'nach',
  amount: 'Betrag',
  antiDilution: 'Verwässerungsschutz',
  autosave: 'Autospeichern',
  'billing.actions.current': 'Aktueller Plan',
  'billing.actions.downgrade': 'Downgrade',
  'billing.actions.select': 'Plan auswählen',
  'billing.actions.upgrade': 'Upgrade',
  'billing.choose': 'Wählen Sie Ihren Plan aus',
  'billing.earlyStagePremium.confirm':
    'Hiermit bestätige ich, dass ich diese Software für ein deutsches Start Up verwende, das nicht mehr als 1 Mio. € an Finanzierung erhalten hat.',
  'billing.earlyStagePremium.description':
    'Sie sind ein Start Up in der Frühphase mit weniger als einer Million Finanzierung? Wir bieten Ihnen einen kostenlosen Premium-Zugang. Einfach beantragen!',
  'billing.earlyStagePremium.title': 'Frühphase? Kostenlos upgraden!',
  'billing.pageTitle': 'Abrechnung',
  'billing.pathName': 'Abrechnung',
  'billing.plans.enterprise.description':
    'Für professionelle Investoren zur Verwaltung von Portfoliounternehmen',
  'billing.plans.enterprise.features.1': 'Alle Premium-Funktionen',
  'billing.plans.enterprise.features.2': '2-stündige Strategieberatung & Cap Table Onboarding',
  'billing.plans.enterprise.features.3':
    'Manche Klauseln werden von der Software nicht unterstützt? Wir modellieren sie für Sie!',
  'billing.plans.enterprise.features.4': '2+ Projekte & vorrangiger Support',
  'billing.plans.enterprise.title': 'Investor Premium',
  'billing.plans.free.description':
    'Für Unternehmen zur einfachen Verwaltung Ihres Cap Tables und Mitarbeiteroptionen',
  'billing.plans.free.features.1': 'Cap Table Management',
  'billing.plans.free.features.2': 'Mitarbeiteroptionen',
  'billing.plans.free.features.3': 'Vesting Pläne',
  'billing.plans.free.features.4': 'Dokumenten Verwaltung',
  'billing.plans.free.title': 'Basis Account',
  'billing.plans.premium.description':
    'Für Unternehmen zur optimalen Vorbereitung für Finanzierungsrunden',
  'billing.plans.premium.features.1': 'All Basic Features',
  'billing.plans.premium.features.2': 'Financing Round Scenario Modeling',
  'billing.plans.premium.features.3': 'Waterfall analysis',
  'billing.plans.premium.features.4': 'Break Point Analysis & Exit Modelling',
  'billing.plans.premium.title': 'Startup Premium',
  'billing.pricePerPeriod': 'jährliche Rechnungsstellung (exkl. Ust)',
  'billing.underConstruction.callToAction': 'Holen Sie sich Premium!',
  'billing.underConstruction.description':
    'Der Zugang zu Ventury Analytics ist momentan nur eingeschränkt möglich. <br/> Wenn Sie auf alle unsere Premium-Features zugreifen möchten, wenden Sie sich bitte direkt an uns!',
  'billing.upgradeAccount': 'Konto Upgrade',
  'bugReportPage.descriptionPlaceholder':
    'Bitte beschreiben Sie das Problem im Detail und stellen Sie so viele Informationen wie möglich zur Verfügung, einschließlich:\n- was passiert ist und wie Sie betroffen waren,\n- wann ist es passiert, welche Aktionen haben Sie durchgeführt, bevor es zu dem Problem kam,\n- welche Plattform benutzen Sie (Betriebssystem, Browserversion usw.)',
  'bugReportPage.descriptionRequired': 'Bitte beschreiben Sie das Problem im Detail',
  'bugReportPage.pathName': 'Einen Fehler melden',
  'bugReportPage.problemTitle': 'Problemname',
  'bugReportPage.problemTitlePlaceholder':
    'Beschreiben Sie kurz, was passiert ist - in einem Satz oder weniger...',
  'bugReportPage.problemTitleRequired': 'Bitte geben Sie einen Problemnamen an',
  'bugReportPage.report': 'Fehler melden',
  'bugReportPage.success.description':
    'Vielen Dank! Wir wissen Ihren Beitrag zur Entwicklung der Plattform zu schätzen und werden das Problem so schnell wie möglich angehen.',
  'bugReportPage.success.message': 'Ihr Bericht wurde gesendet!',
  'bugReportPage.title': 'Einen Fehler melden',
  buyOut: 'Buy Out',
  'buyOutForm.buyOut': 'Buy Out',
  'buyOutForm.buyer': 'Käufer',
  'buyOutForm.edit': 'Bearbeiten',
  'buyOutForm.numberOfShares': 'Anzahl der Anteile',
  'buyOutForm.selectAnotherBuyer': 'Einen weiteren Käufer auswählen',
  'buyOutForm.selectBuyer': 'Käufer auswählen',
  'buyOutForm.selectBuyingShare': 'Zu verkaufende Anteile',
  'buyOutForm.sell': 'Verkaufen',
  'buyOutForm.sharesLeft': 'verbleibende Anteile',
  calculate: 'Berechnen',
  cancel: 'Abbrechen',
  'cancel-confirm': 'Sind Sie sich sicher, dass Sie abbrechen wollen?',
  cap: 'Cap',
  capPoint: 'Cap Punkt',
  'capTable.asIfConverted': 'As if converted: ',
  'capTable.capTableForRound': 'Cap Table {roundName}',
  'capTable.csv.columns.convertibleNote': 'Wandeldarlehen',
  'capTable.csv.columns.equityHolding': 'Anteilsquote (voll verwässert)',
  'capTable.csv.columns.esopBacking': 'V(E)SOP Träger',
  'capTable.csv.columns.name': 'Name',
  'capTable.csv.columns.newInvestment': 'Neue Investitionen',
  'capTable.csv.columns.newShares': 'Neue Anteile',
  'capTable.csv.columns.shareholding': 'Anteilsbesitz',
  'capTable.csv.columns.totalShares': 'Anteile gesamt',
  'capTable.esopTotal': 'Anteile (voll verwässert)',
  'capTable.founderTotal': 'Gründer gesamt',
  'capTable.fullHistoryTrace': 'Vollständige Transaktionshistorie',
  'capTable.investorTotal': 'Investoren gesamt',
  'capTable.overview': '{roundName} Übersicht',
  'capTable.overviewPerRound': 'Investitionsübersicht pro Runde',
  'capTable.pathName': 'Cap Table',
  'capTable.recap.cashRaised': 'Rundenvolumen',
  'capTable.recap.downRound': 'Down-Round',
  'capTable.recap.flatRound': 'Flat-Round',
  'capTable.recap.ifConverted': 'If Converted: {preMoney}',
  'capTable.recap.ownership': 'Anteilsquoten',
  'capTable.recap.postMoney': 'Post-Money',
  'capTable.recap.preMoney': 'Pre-Money',
  'capTable.recap.preMoneyIncrease': 'Pre-Money-Zuwachs',
  'capTable.recap.sharePrice': 'Anteilspreis',
  'capTable.recap.stakeholder': 'Anteilseigner',
  'capTable.recap.upRound': 'Up-Round',
  'capTable.recap.valuationStep': 'Bewertungsschritt',
  'capTable.title': 'Cap Table',
  'capTable.total': 'Gesamt',
  'changelogPage.pathName': 'Änderungsprotokoll',
  clear: 'löschen',
  clickToChange: 'Klicken zum Ändern',
  clickToEdit: 'Klicken um benutzerdefinierten Wert einzufügen',
  close: 'Schließen',
  collapse: 'einklappen',
  'companyInfo.address': 'Addresse',
  'companyInfo.addressRequired': 'Bitte geben Sie eine vollständige Adresse ein',
  'companyInfo.dateLastRound': 'Letztes Datum',
  'companyInfo.districtCourt': 'Amtsgericht',
  'companyInfo.existFounded': 'EXIST-Gründung',
  'companyInfo.foundingDate': 'Gründungsdatum',
  'companyInfo.furtherInfo': 'Weitere Informationen',
  'companyInfo.information': 'Zusätzliche Informationen',
  'companyInfo.informationPlaceholder': 'z.B. Geschäftszweck',
  'companyInfo.insertUserBusiness': 'Verwendung wie Anwenderunternehmen',
  'companyInfo.investGrant': 'INVEST Zuschuss',
  'companyInfo.lastInvestment': 'Letzte Investition <br/>({name})',
  'companyInfo.lastRound': 'Letzte Runde',
  'companyInfo.location': 'Standort',
  'companyInfo.locationRequired': 'Bitte geben Sie einen Standort ein',
  'companyInfo.longText':
    '<ins>{companyName}</ins> hat <strong>{investment}</strong> in {rounds} Runden eingesammelt. Die letzte <ins>{lastRoundName}</ins> wurde am <em>{lastRoundDate}</em> mit einem Betrag von <strong>{lastRoundInvestments}</strong> geschlossen.',
  'companyInfo.manually': 'manuell hinzufügen',
  'companyInfo.name': 'Unternehmensname',
  'companyInfo.nameRequired': 'Bitte geben Sie Ihren Unternehmensnamen ein',
  'companyInfo.postMoneyVal': 'Post-Money-Bewertung<br/>({name})',
  'companyInfo.preMoneyVal': 'Pre-Money-Bewertung',
  'companyInfo.registrationNumber': 'Register-Nr.',
  'companyInfo.sector': 'Sektor',
  'companyInfo.sectorRequired': 'Bitte geben Sie einen Sektor ein',
  'companyInfo.shareholders': 'Gesellschafter',
  'companyInfo.title': 'Unternehmens Info',
  'companyInfo.totalRaised': 'Total Raised',
  compensation: 'Kompensation',
  confirm: 'Bestätigen',
  convPoint: 'Wandlungspunkt',
  conversion: 'Wandlung',
  conversionVoluntary: 'Freiwillige Wandlung',
  conversions: 'Wandlung',
  convertibleNote: 'Wandeldarlehen',
  create: 'Erstellen',
  cumulative: 'Compounding',
  date: 'Datum',
  dateEntry: 'Eintrittsdatum',
  'dates.month': 'Monat',
  'dates.months': 'Monate',
  'dates.year': 'Jahr',
  defaultInvestor: 'Vertretener Gesellschafter',
  delete: 'Löschen',
  deleteConfirm: 'Sind Sie sich sicher {title} zu löschen?',
  deleteLow: 'löschen',
  deleteObj: 'Lösche {name}',
  description: 'Beschreibung',
  detail: 'Details',
  discount: 'Discount',
  dividend: 'Dividende',
  dividends: 'Dividenden',
  'documents.documentDetails': 'Dokumentendetails',
  'documents.documentTitle': 'Dokumententitel',
  'documents.empty': 'Es wurden noch keine Dokumente hochgeladen...',
  'documents.enterMode.delete': 'Dokumente löschen...',
  'documents.enterMode.edit': 'Dokumente bearbeiten...',
  'documents.fileExists.text':
    'Eine Datei mit dem gleichen Dateinamen existiert bereits. Wollen Sie diese überschreiben?',
  'documents.fileExists.title': 'Diese Datei existiert bereits',
  'documents.instructions.hint':
    'Unterstützte Dateiendungen: .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .xlm, .xlsm.<br/>You will be prompted to enter a document title',
  'documents.instructions.title':
    'Klicken oder ziehen Sie Ihr Dokument in diesen Bereich, um es hochzuladen',
  'documents.pageTitle': 'Dokumente',
  'documents.pathName': 'Dokumente',
  'documents.save': 'Dokument speichern',
  'documents.search': 'Dokumente suchen...',
  'documents.titleRequired': 'Bitte geben Sie einen Dokumententitel ein...',
  'documents.upload': 'Dokumentenupload',
  download: 'Download',
  drag: 'Verschieben',
  duration: 'Laufzeit',
  'edge-user':
    'Oh schau ein {name} Benutzer, wir empfehlen stattdessen Chrome oder Firefox zu verwenden!',
  edit: 'Bearbeiten',
  'edit.addCompany': 'Unternehmen hinzufügen',
  'edit.backToGuidedTour': 'Zurück zur Guided Tour',
  'edit.companyInfo': 'Unternehmensinformationen',
  'edit.deleteModelling': 'Sie können Ihres löschen durch besuchen von {link}',
  'edit.deleteProject': 'Projekt löschen',
  'edit.error.projectCorrupted.noCompany':
    'Dieses Projekt scheint beschädigt zu sein. Bitte kontaktieren Sie unseren Support.',
  'edit.error.projectDelete.modelling': 'Sie müssen das Modellierungsprojekt zuerst löschen!',
  'edit.error.projectDelete.shared': 'Sie können ein geteiltes Projekt nicht löschen!',
  'edit.financingRounds': 'Finanzierungsrunde:',
  'edit.projectDeleteConfirm':
    'Sind Sie sicher, dass Sie das Projekt löschen möchten? <br />' +
    'Alle Daten werden gelöscht, inc. Dokumenten und Modellierungsprojekten. <br />' +
    'Alle eingeladenen Gesellschafter werden darüber informiert, dass das Projekt gelöscht wurde und keinen weiteren Zugriff hat. <br/>' +
    'Wenn sie premium Features für dieses Projekt aktiviert haben gehen diese verloren und können nicht zurückerstattet werden. <br/>' +
    'Dies kann nicht rückgängig gemacht werden.',
  'edit.projectInfo': 'Projekt-Info',
  'edit.selectTermsheet.addRound': 'Neue Runde hinzufügen',
  editLow: 'bearbeiten',
  'editPage.pathName': 'Edit',
  editing: 'Bearbeiten',
  limitedViewer: 'Betrachter (Limitiert)',
  email: 'E-Mail',
  emptyResults: 'Leere Resultate',
  'enums.accumulationTypes.Daily': 'Täglich',
  'enums.accumulationTypes.Monthly': 'Monatlich',
  'enums.accumulationTypes.Quarterly': 'Quartalsweise',
  'enums.accumulationTypes.Yearly_acc_acc': 'Jährlich (act/act)',
  'enums.accumulationTypes.Yearly_acc_360': 'Jährlich (act/360)',
  'enums.accumulationTypes.Yearly_30_360': 'Jährlich (30/360 EU)',
  'enums.accumulationTypes.Yearly_US_360': 'Jährlich (30/360 US)',
  'enums.accumulationTypes.Yearly_acc_365': 'Jährlich (act/365)',
  'enums.accumulationTypesShort.Daily': 'tgl.',
  'enums.accumulationTypesShort.Monthly': 'mtl.',
  'enums.accumulationTypesShort.Quarterly': 'quart.',
  'enums.accumulationTypesShort.Yearly_acc_acc': 'jährl. (act/act)',
  'enums.accumulationTypesShort.Yearly_acc_360': 'jährl. (act/360)',
  'enums.accumulationTypesShort.Yearly_30_360': 'jährl. (30/360 EU)',
  'enums.accumulationTypesShort.Yearly_US_360': 'jährl. (30/360 US)',
  'enums.accumulationTypesShort.Yearly_acc_365': 'jährl. (act/365)',
  'enums.antiDilutionCompensation.COMMON_SHARES': 'Stammanteile',
  'enums.antiDilutionCompensation.DOWN_ROUND': 'Down-Round',
  'enums.antiDilutionCompensation.INITIAL_INVESTMENT_ROUND': 'Ursprüngliche Finanzierungsrunde',
  'enums.antiDilutionDuration.INDEFINITE': 'Unbegrenzt',
  'enums.antiDilutionDuration.NEXT_DOWN': 'Nächste Down-Round',
  'enums.antiDilutionDuration.NEXT_ROUND': 'Nächste Runde',
  'enums.antiDilutionTransferTypes.CAPITAL_INCREASE': 'Kapitalerhöhung',
  'enums.antiDilutionTransferTypes.TRANSFER_SHARES': 'Anteilsübertragung',
  'enums.antiDilutionTypes.BROAD_BASED': 'Broad-Based',
  'enums.antiDilutionTypes.FULL_RATCHET': 'Full-Ratchet',
  'enums.antiDilutionTypes.NARROW_BASED': 'Narrow-Based',
  'enums.capTypes.EXIT_VALUATION': 'Exitbewertung',
  'enums.capTypes.INVESTMENT_RETURN': 'Investitionserlöse',
  'enums.capTypes.NONE': 'Kein Cap',
  'enums.shareholderTypesPlural.Business_Angel': 'Business Angels',
  'enums.shareholderTypesPlural.Corporate_Venture_Capitalist': 'Corporate Venture Capitalists',
  'enums.shareholderTypesPlural.ESOP_Pool': 'V(E)SOP Pools',
  'enums.shareholderTypesPlural.Employee': 'Mitarbeiter',
  'enums.shareholderTypesPlural.Family': 'Familie & Freunde',
  'enums.shareholderTypesPlural.Founder': 'Gründer',
  'enums.shareholderTypesPlural.Management': 'Management',
  'enums.shareholderTypesPlural.New_Investor': 'Neue Investoren',
  'enums.shareholderTypesPlural.Venture_Capitalist': 'Venture Capitalists',
  'enums.eventTypes.BUY_OUT': 'Buy Out',
  'enums.eventTypes.CN_CONVERSION': 'Wandlung',
  'enums.eventTypes.CN_INVESTMENT': 'Wandeldarlehen',
  'enums.eventTypes.DEBT_INVESTMENT': 'Verschuldung',
  'enums.eventTypes.EQUITY_INVESTMENT': 'Eigenkapitalbeteiligung',
  'enums.eventTypes.ESOP_CREATION': 'V(E)SOP-Erstellung',
  'enums.eventTypes.ESOP_GRANT': 'V(E)SOP-Gewährung',
  'enums.eventTypes.SIM_ANTI_DILUTION': 'Verwässerungsschutz',
  'enums.eventTypes.SIM_AUTO_CN_CONVERSION': 'Autom. Wandlung',
  'enums.eventTypes.SIM_DIVIDENDS': 'Zins akkumulierung',
  'enums.exitReturnTypes.CAP_POINT': 'Kappungspunkt',
  'enums.exitReturnTypes.CONVERSION_POINT': 'Wandlungspunkt',
  'enums.exitReturnTypes.DEFAULT': 'Multiple',
  'enums.exitReturnTypes.MULTIPLE': 'Multiple',
  'enums.exitReturnTypes.PREFERENCE_AMOUNT': 'Vorzugsbetrag',
  'enums.exitReturnTypes.STRIKE_POINT': 'Optionen-Gewinnschwelle',
  'enums.expertTypes.BEGINNER': 'Anfänger',
  'enums.expertTypes.EXPERT': 'Experte',
  'enums.operationTypes.ADD': 'Addieren',
  'enums.operationTypes.ADD_DIVIDENDS': 'Dividenden addieren',
  'enums.operationTypes.RECEIVE_LP_RIGHTS': 'Erhaltene LP-Rechte',
  'enums.operationTypes.SUB': 'Subtrahieren',
  'enums.operationTypes.TRANSFER_LP_RIGHTS': 'Übertragene LP-Rechte',
  'enums.participationTypes.ConvertibleNote': 'Wandeldarlehen Tranche',
  'enums.participationTypes.Debt_Capital': 'Fremdkapital',
  'enums.participationTypes.Esop_Pool': 'V(E)SOP Pool',
  'enums.participationTypes.Exit_Money': 'Geld aus Exit',
  'enums.participationTypes.GrantedShares': 'Gewährte Optionen',
  'enums.participationTypes.Shares': 'Anteile',
  'enums.userStatus.ADMIN': 'ADMIN-MODUS',
  'enums.userStatus.SUPPORT': 'SUPPORT-MODUS',
  'enums.userStatus.FREE': 'Free',
  'enums.roundingModes.CEILING': 'Aufrunden',
  'enums.roundingModes.FLOOR': 'Abrunden',
  'enums.roundingModes.HALF_UP': 'Nächste ganze Zahl',
  'enums.sectors.AGRICULTURE': 'Agrar- und Landwirtschaft',
  'enums.sectors.AUTOMOTIVE': 'Automobile/ Mobilität/ Logisitik',
  'enums.sectors.CONSULTING': 'Beratung und Agentur',
  'enums.sectors.EDUCATION': 'Bildung',
  'enums.sectors.ENERGY': 'Energie und Elektrizität',
  'enums.sectors.ENTERTAINMENT': 'Freizeit, Sport und (Online-) Gaming',
  'enums.sectors.FINANCE': 'Banken und Finanzen/ Versicherung',
  'enums.sectors.FOOD': 'Ernährung und Nahrungsmittel/Konsumgüter',
  'enums.sectors.HEALTH': 'Medizin und Gesundheitswesen',
  'enums.sectors.HUMAN_RESOURCES': 'Human Resources',
  'enums.sectors.INDUSTRIAL_GOODS': 'Industriegüter',
  'enums.sectors.INFORMATION_TECHNOLOGY': 'Informations- und Kommunikationstechnologie',
  'enums.sectors.LIFE_SCIENCE': 'Chemie und Pharma/ Biologie',
  'enums.sectors.MEDIA': 'Medien- und Kreativwirtschaft',
  'enums.sectors.OTHER': 'Sonstiges',
  'enums.sectors.REAL_ESTATE': 'Bau und Immobilien',
  'enums.sectors.TEXTILE': 'Textilbranche',
  'enums.sectors.TOURISM': 'Tourismus',
  'enums.shareholderTypes.CORPORATE_VENTURE_CAPITALIST': 'Corporate Venture Capitalist',
  'enums.shareholderTypes.ESOP_POOl': 'V(E)SOP Pool',
  'enums.shareholderTypes.EMPLOYEE': 'Mitarbeiter',
  'enums.shareholderTypes.FAMILY': 'Familie & Freunde',
  'enums.shareholderTypes.FOUNDER': 'Gründer',
  'enums.shareholderTypes.MANAGEMENT': 'Management',
  'enums.shareholderTypes.NEW_INVESTOR': 'Neuer Investor',
  'enums.shareholderTypes.VENTURE_CAPITALIST': 'Venture Capitalist',
  'enums.shareholderTypes.Business_Angel': 'Business Angel',
  'enums.shareholderTypes.Corporate_Venture_Capitalist': 'Corporate Venture Capitalist',
  'enums.shareholderTypes.ESOP_Pool': 'V(E)SOP Pool',
  'enums.shareholderTypes.Employee': 'Mitarbeiter',
  'enums.shareholderTypes.Family': 'Familie & Freunde',
  'enums.shareholderTypes.Founder': 'Gründer',
  'enums.shareholderTypes.Management': 'Management',
  'enums.shareholderTypes.New_Investor': 'Neuer Investor',
  'enums.shareholderTypes.Venture_Capitalist': 'Venture Capitalist',
  'enums.simulationRoundTypes.DOWN_ROUND': 'DOWN',
  'enums.simulationRoundTypes.FLAT_ROUND': 'FLAT',
  'enums.simulationRoundTypes.UP_ROUND': 'UP',
  equityHolding: 'Eigenkapitalbeteiligung',
  error: 'Error',
  'error.tryAgainOrSupport':
    'Bitte versuchen Sie es erneut, wenn der Fehler bestehen bleibt, kontaktieren Sie unseren Support.',
  'error.optionExists': 'Diese Option existiert bereits.',
  'errorPage.button': 'Zurück zur Übersicht',
  'errorPage.description':
    'Bitte versuchen Sie es noch einmal und überlegen Sie sich, einen Fehlerbericht einzureichen.',
  'errorPage.heading': 'Hoppla, etwas ist schiefgegangen. ',
  'errorPage.pathName': 'Fehlerhinweis',
  'errorPage.reportBug': 'Einen Fehler melden',
  'errorPage.timeout.button': 'Erneut versuchen',
  'errorPage.timeout.description':
    'Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.',
  'errorPage.timeout.heading': 'Für die Serveranfrage liegt eine Zeitüberschreitung vor.',
  errorTitle: 'Hoppla ein Error!',
  'errors.accessDeniedException.description': 'Das Zugangsticket ist ungültig oder abgelaufen.',
  'errors.accessDeniedException.title': 'Zugriff für Serveranfrage verweigert.',
  'errors.arithmeticException.title':
    'Das Projekt scheint beschädigt zu sein. Bitte kontaktieren Sie unseren Support und melden Sie den Fehler.',
  'errors.invitationRevokedException.description':
    'Bitte kontaktieren Sie den Eigentümer des Projekts, damit er es mit Ihnen teilen kann.',
  'errors.invitationRevokedException.title': 'Die Einladung wurde widerrufen.',
  'errors.networkException.description':
    'Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.',
  'errors.networkException.title': 'Die Serververbindung wurde zeitweise unterbrochen.',
  'errors.optimisticLockException.description': 'Bitte versuchen Sie es erneut.',
  'errors.optimisticLockException.title': 'Hoppla, etwas ist schiefgelaufen.',
  'esop.addGrant': 'Mitarbeiteroption hinzufügen',
  'esop.addPool': 'Pool hinzufügen',
  'esop.available': 'Verfügbarer Pool',
  'esop.backing.amountError':
    'Die Poolgröße übersteigt die Gesamtzahl der Anteile der Gesellschaft und kann nicht erstellt werden.',
  'esop.backing.backer': 'Träger des bestehenden VESOP',
  'esop.backing.backing': '% der Trägerschaft',
  'esop.backing.backingError':
    'Einige Investoren besitzen nicht genug Anteile, um den Pool zu tragen.',
  'esop.backing.quotaError':
    'Die Gesamtsumme der hinterlegten Anteile muss der Poolgröße entsprechen.',
  'esop.backing.shares': '# getragener V(E)SOP-Anteile',
  'esop.backing.title': 'Sicherung von {for}',
  'esop.backing.totals': 'summe',
  'esop.cliff': 'Cliff',
  'esop.deleteReferencedPool':
    '{title} hat immer noch gewährte Optionen. Sind Sie sicher, dass Sie diese auch streichen wollen?',
  'esop.editGrant': 'Mitarbeiteroption bearbeiten - {name}',
  'esop.editPool': 'Pool bearbeiten - {name}',
  'esop.exercised': 'Ausgeübt',
  'esop.expiredDate': 'Verfallsdatum',
  'esop.fullyDiluted': 'Voll verwässert',
  'esop.grant.accerelation': 'Vesting Aufholung im Exit-Fall',
  'esop.grant.addCliff': 'Cliff hinzufügen',
  'esop.grant.addCustomSchedule': 'Neuen Vestingeintrag hinzufügen',
  'esop.grant.addEmployee': 'Neuen Mitarbeiter hinzufügen',
  'esop.grant.amountLeft': 'verbleibend',
  'esop.grant.cliff': 'Cliff',
  'esop.grant.duration': 'Laufzeit (in Monaten)',
  'esop.grant.lastRoundPrice': 'Letzter Rundenpreis {price}',
  'esop.grant.numberOfOptions': 'Anzahl an Optionen',
  'esop.grant.optional': 'optional',
  'esop.grant.saveEmployee': 'Den Mitarbeiter speichern',
  'esop.grant.to': 'an',
  'esop.grant.vesting': 'Vesting',
  'esop.grant.vestingStart': 'Vesting Startdatum',
  'esop.grant.vests': 'Vestet jeden (in Monaten)',
  'esop.grantTitle': 'Ausgegebene Optionen von {for}',
  'esop.granted': 'Gewährt',
  'esop.hideBacking': 'Trägerschaft ausblenden',
  'esop.hideGrants': 'Mitarbeiteroptionen ausblenden',
  'esop.modelling.grantedTable.columns.assigned': 'Zugeteilte Anteile bis {date} ',
  'esop.modelling.grantedTable.columns.exit': 'Anteilspreis zum Exit',
  'esop.modelling.grantedTable.columns.status': 'Status (inkl. Akzeleration)',
  'esop.modelling.grantedTable.columns.strikePrice': 'Ausübungspreis',
  'esop.modelling.grantedTable.columns.title':
    'Aufsichtsratsmitglied / Management / leitende Angestellte',
  'esop.modelling.grantedTable.months.plural': '({time} Monate)',
  'esop.modelling.grantedTable.months.singular': '({time} Monat)',
  'esop.modelling.grantedTable.status.nonVested': 'nicht gevested',
  'esop.modelling.grantedTable.status.vested': 'gevested',
  'esop.modelling.grantedTable.years.plural': '({time} Jahre)',
  'esop.modelling.grantedTable.years.singular': '({time} Jahr)',
  'esop.modelling.headerTable.fullyDilutedBasis': 'Voll verwässerte Basis',
  'esop.modelling.headerTable.numberOfShares': 'Anzahl Anteile',
  'esop.modelling.headerTable.remaining': 'Verbleibende Anteile',
  'esop.modelling.headerTable.totalAssigned':
    'Anzahl der bereits zugeteilten Anteile -gevestet und nicht gevestet-',
  'esop.modelling.headerTable.totalProposed': 'Anzahl der beantragten Anteile',
  'esop.modelling.headerTable.totalShares':
    'Gesamtzahl der Anteile einschließlich virtueller Anteile (Incentive-Pläne)',
  'esop.modelling.headerTable.totalVirtual': 'Gesamtzahl der virtuellen Anteile (Incentive-Pläne)',
  'esop.name': 'Eigentümer',
  'esop.pathName': 'V(E)SOP',
  'esop.pool.amount.info.title': 'Berechnung der Pool Größe',
  'esop.pool.amount.info1':
    'Der Betrag kann in Prozent der Gesamtzahl der Anteile angegeben werden.',
  'esop.pool.amount.info2': 'Der Prozentsatz wird gerundet um ganze Anteile zu erhalten.',
  'esop.pool.amount.info3':
    'Die Gesamtzahl basiert auf dem Pre-Money-Pool oder dem Post-Money-Pool (nach Investitionen).',
  'esop.pool.amount.info4':
    'Wenn der Pool von allen Investoren getragen wird, werden neue Anteile ausgegeben, wodurch sich die Gesamtsumme der Anteile erhöht.',
  'esop.pool.amountHelp': 'Kann sowohl in % als auch in # sein.',
  'esop.pool.backingBy': 'Getragen von',
  'esop.pool.byBacking': 'Ausgewählten Investoren',
  'esop.pool.byDilutionOfAll': 'Allen Investoren',
  'esop.pool.byPriceAdjustment': 'Allen & Preisanp.',
  'esop.pool.name': 'Pool Name',
  'esop.pool.notes': 'Notizen',
  'esop.pool.postMoney': 'Post-Money-Pool',
  'esop.pool.preMoney': 'Pre-Money-Pool',
  'esop.pool.shareClassLabel': 'Anteilsklasse',
  'esop.pool.shareClassValue': 'Stammanteile (Optionen)',
  'esop.poolTitle': 'Pools',
  'esop.showBacking': 'Trägerschaft einblenden',
  'esop.showGrants': 'Mitarbeiteroptionen anzeigen',
  'esop.strikePrice': 'Ausübungspreis',
  'esopTable.title.long': 'Mitarbeiterbeteiligungsprogramme - V(E)SOPs',
  'esop.totalAgreed': 'Pool Größe',
  'esop.vested': 'Gevested',
  'esop.vestingDuration': 'Vesting Laufzeit',
  event: 'Event',
  eventRound: 'Event Runde',
  eventType: 'Event Typ',
  events: 'Evente',
  exclude: 'Ausschließen',
  expand: 'ausklappen',
  finish: 'Beenden',
  fullyDilutedNote: '(voll verwässert)',
  'general.comingSoon': 'Kommt Demnächst!',
  'guidedTour.addNewRound': 'Eine neue Runde hinzufügen',
  'guidedTour.defaultProjectName': 'Mein Projekt-{num}',
  'guidedTour.finalSteps.finalCheck.name': 'Abschlusskontrolle',
  'guidedTour.finalSteps.finalCheck.subtitle':
    'Bitte überprüfen Sie, ob alle Ihre Daten korrekt sind.',
  'guidedTour.finalSteps.finalCheck.title': 'Wir sind fast fertig.',
  'guidedTour.finalSteps.newRound.name': 'Neue Runde',
  'guidedTour.finalSteps.newRound.subtitle':
    'Fügen Sie eine neue Runde hinzu oder fahren Sie mit der Abschlusskontrolle fort.',
  'guidedTour.finalSteps.newRound.title': 'Gibt es noch weitere historische Runden?',
  'guidedTour.finalSteps.sharing.name': 'Teilen',
  'guidedTour.finalSteps.sharing.skip': 'Oder überspringen',
  'guidedTour.finalSteps.sharing.subtitle':
    'Teilen Sie Ihr Projekt mit Ihrem Anwalt oder anderen Gesellschaftern.',
  'guidedTour.finalSteps.sharing.title': 'Projekt teilen',
  'guidedTour.help.tutorialEnabled': 'Tutorial beginnen',
  'guidedTour.introSteps.companyInfo.name': 'Unternehmensinformationen',
  'guidedTour.introSteps.companyInfo.subtitle': ' ',
  'guidedTour.introSteps.companyInfo.title': 'Unternehmensinformationen',
  'guidedTour.introSteps.profile.name': 'Profil',
  'guidedTour.introSteps.profile.subtitle':
    'Füllen Sie Ihre Profilinformationen aus, damit andere Gesellschafter Sie identifizieren können.',
  'guidedTour.introSteps.profile.title': 'Profilinformationen',
  'guidedTour.loginNotification.description': 'Sie werden auf die Übersicht weitergeleitet.',
  'guidedTour.loginNotification.message':
    'Sie müssen eingeloggt sein, um ein Projekt zu erstellen.',
  'guidedTour.pathName': 'Guided Tour',
  'guidedTour.proceedToFinal': 'Weiter zur Abschlusskontrolle',
  'guidedTour.roundEnterPrevious':
    'Zunächst müssen Ihre historischen Finanzierungsrunden Schritt für Schritt eingetragen werden (z.B. Gründung, Pre-Seed, Seed, etc.).',
  'guidedTour.roundNames.buyOut': 'Buy Out',
  'guidedTour.roundNames.convertibleOnly': 'Wandeldarlehen-Runde',
  'guidedTour.roundNames.create': 'Neuen Rundenamen erstellen',
  'guidedTour.roundNames.custom': 'Benutzerdefiniert',
  'guidedTour.roundNames.defaults': 'Standardeinstellungen',
  'guidedTour.roundNames.edit': 'Rundennamen bearbeiten',
  'guidedTour.roundNames.founding': 'Gründung',
  'guidedTour.roundNames.preSeed': 'Pre-Seed',
  'guidedTour.roundNames.seed': 'Seed',
  'guidedTour.roundNames.seriesA': 'Series A',
  'guidedTour.roundNames.seriesB': 'Series B',
  'guidedTour.roundNames.seriesC': 'Series C',
  'guidedTour.roundNames.seriesD': 'Series D',
  'guidedTour.roundNames.seriesE': 'Series E',
  'guidedTour.selectDefaultInvestor': 'Investor auswählen',
  'guidedTour.skipDashboard': 'Zurück zum Dashboard',
  'guidedTour.skipGuided': 'Überspringen',
  'guidedTour.start': 'Start',
  'guidedTour.title': 'Guided Tour',
  'guidedTour.tutorial.additionalRound.step1.content':
    'Benennen Sie diese Runde zuerst und beginnen Sie danach mit dem Hinzufügen Ihrer Bewertung und des Investitionsdatums. Es gibt dieses mal unterschiedliche Anteile? Falls ja, fügen Sie einfache Neue hinzu.',
  'guidedTour.tutorial.additionalRound.step1.title':
    'Lassen Sie uns noch einige Details hinzufügen!',
  'guidedTour.tutorial.check.step1.content':
    'Alles in Ordnung? Dann gehen Sie weiter zu Ihren Dashboards. Keine Sorge - Sie können die Daten jederzeit bearbeiten.',
  'guidedTour.tutorial.check.step1.title': 'Prüfen Sie Ihren Cap Table!',
  'guidedTour.tutorial.company.step1.content':
    'Lassen Sie uns Ihnen eine kurze Anleitung zu den Hauptfunktionen geben! Wenn Sie sich bereits auskennen, können Sie jederzeit auf  "Überspringen" klicken.',
  'guidedTour.tutorial.company.step1.title': 'Brauchen Sie Hilfe?',
  'guidedTour.tutorial.company.step2.content':
    'Fangen wir damit an, allgemeine Informationen über das Unternehmen, dessen Cap Table Sie anlegen möchten, hinzuzufügen.',
  'guidedTour.tutorial.newRound.step1.content':
    'Wenn Sie mehr Geld als in der Gründungsrunde gesammelt haben, fügen Sie hier noch eine neue Runde hinzu.',
  'guidedTour.tutorial.newRound.step1.title': 'Schon fertig?',
  'guidedTour.tutorial.round.step1.content':
    'Wir können nun mit ihrer Gründung beginnen. Tragen Sie zunächst das Gründungsdatum ein!',
  'guidedTour.tutorial.round.step1.title': 'Perfekt!',
  'guidedTour.tutorial.round.step2.content':
    'Normalerweise werden Stammanteile bei der Gründung eines Unternehmens ausgegeben. Andernfalls fügen Sie eine Vorzugsanteile hinzu!',
  'guidedTour.tutorial.round.step2.title': 'Stammanteile?',
  'guidedTour.tutorial.round.step3.content':
    'Fügen Sie alle Ihre Gründer, Business Angels oder andere Personen, die an der Gründung beteiligt waren, mit der Schaltfläche " Gesellschafter hinzufügen" hinzu.',
  'guidedTour.tutorial.round.step3.title': 'Gesellschafter',
  'guidedTour.welcomePage.description':
    'In den nächsten Minuten werden wir Sie durch alle notwendigen Schritte führen, um Ihr Unternehmensprofil zunächst zu erstellen und zu erfassen. Sie benötigen die Informationen über Ihre Unternehmensstruktur und Finanzierungsrunden. Falls Sie weitere Unterstützung benötigen, bieten wir auch einen Onboarding-Service an. Kontaktieren Sie uns dazu einfach.',
  'guidedTour.welcomePage.name': 'Willkommen',
  'guidedTour.welcomePage.subtitle': 'Lassen Sie uns gemeinsam Ihr Projekt anlegen!',
  'guidedTour.welcomePage.title': 'Willkommen bei',
  help: 'Hilfe',
  'help.directSupport': 'Kontaktieren Sie uns',
  'help.documentation': 'Dokumentation',
  'help.faq': 'FAQ',
  'imageUpload.remove': 'Bild entfernen',
  'info.unsavedChanges.description': 'Bitte speichern Sie zum Fortfahren',
  'info.unsavedChanges.title': 'Sie haben ungespeicherte Änderungen!',
  information: 'Informationen',
  interest: 'Zinsen',
  investment: 'Investition',
  investmentAmount: 'Investitionen',
  'investmentForm.accumulationType': 'Kumulationsart',
  'investmentForm.accumulationTypeRequired': 'Bitte wählen Sie eine Kumulationsart',
  'investmentForm.amountRequired': 'Bitte geben Sie einen Betrag ein',
  'investmentForm.convComplete': 'Vollständige Wandlung',
  'investmentForm.convNoteAdd': 'Wandeldarlehen hinzufügen',
  'investmentForm.convNoteLeft': 'Verbleibendes Wandeldarlehen',
  'investmentForm.convPartial': 'Teilweise Wandlung',
  'investmentForm.dateDeposit': 'Datum der Einzahlung',
  'investmentForm.dateMaturity': 'Fälligkeitsdatum',
  'investmentForm.defaultGroup': 'Standard',
  'investmentForm.discountRequired': 'Bitte geben Sie einen Discount ein',
  'investmentForm.equityCapitalAdd': 'Eigenkapital hinzufügen',
  'investmentForm.interestPercent': 'Zinsen (%)',
  'investmentForm.interestRequired': 'Bitte geben Sie einen Zinssatz ein',
  'investmentForm.limitAsDate': 'Begrenzter Zinszeitraum',
  'investmentForm.limitAsDateError': 'Bitte geben Sie das Enddatum für die Verzinsung an',
  'investmentForm.limitAsDateQuestion': 'Begrenzter Zeitraum?',
  'investmentForm.limitInMonths': 'Begrenzter Zeitraum (in Monaten)',
  'investmentForm.limitInMonthsError': 'Bitte geben Sie die Anzahl der Monate ein',
  'investmentForm.limitInMonthsQuestion': 'Begrenzter Zeitraum?',
  'investmentForm.maturityDateRequired': 'Bitte geben Sie ein Fälligkeitsdatum ein',
  'investmentForm.preMoneyCapRequired': 'Bitte geben Sie eine Pre-Money-Cap ein',
  'investmentForm.preMoneyFloorRequired': 'Bitte geben Sie eine Pre-Money-Floor ein',
  'investmentForm.pricePerShareRequired':
    'Bitte geben Sie einen Anteilspreis größer oder gleich eins ein',
  'investmentForm.retainDividends': 'Zinssatz bei der Wandlung beibehalten',
  'investmentForm.share': 'Erhaltene Anteile',
  'investmentForm.shareConversionRound': 'Anteile der Wandlungsrunde',
  'investmentForm.shareGroup': 'Anteile',
  investmentTotal: 'Gesamte Investition',
  investmentsNew: 'Neue Investitionen',
  investmentsTotal: 'Gesamte Investitionen',
  investor: 'Investor',
  'investorForm.nameRequired': 'Bitte geben Sie einen Namen ein',
  'investorForm.roundRequired': 'Bitte wählen Sie die Einstiegsrunde aus',
  'investorForm.typeRequired': 'Please select type',
  investorParticipating: 'Partizipierender Investor',
  investors: 'Investoren',
  left: 'links',
  liquidPref: 'Liquidationspräferenz (LP)',
  loading: 'Lade',
  'loadingType.add_user': 'Kontoregistrierung',
  'loadingType.authenticate': 'Authentifizierung',
  'loadingType.done': 'Es ist alles für Sie vorbereitet.',
  'loadingType.fetch_modelling': 'Ihr Arbeitsbereich wird geladen.',
  'loadingType.fetch_project': 'Ihr Projekt wird geladen',
  'loadingType.fetch_projects': 'Empfang Ihrer Projekte',
  'loadingType.fetch_token': 'Autorisierung',
  login: 'Login',
  logout: 'Logout',
  'menu.addProject': 'Neues Projekt hinzufügen',
  'menu.adminDashboard': 'Administrator Dashboard',
  'menu.benchmarking': 'Benchmarking',
  'menu.capTable': 'Cap Table',
  'menu.demoProject': 'Demo des ausgewählten Projekts',
  'menu.documents': 'Dokumente',
  'menu.editProject': 'Projekt bearbeiten',
  'menu.esop': 'V(E)SOP',
  'menu.esop.overview': 'Pools',
  'menu.esop.grantsOverview': 'Mitarbeiterkompensation',
  'menu.esop.grantModelling': 'Mitarbeiteroptionen Rechner',
  'menu.futureModelling': 'Szenario-Modellierung',
  'menu.language.de': 'Deutsch',
  'menu.language.en': 'Englisch',
  'menu.overview': 'Übersicht',
  'menu.securities': 'Securities',
  'menu.settings': 'Einstellungen',
  'menu.stakeholders': 'Stakeholders',
  'menu.vestingSchedules': 'Vesting',
  'menu.waterfallAnalysis': 'Wasserfallrechnung',
  missingField: '{name} Feld fehlt',
  modelling: 'Modellierung',
  'modellingPage.analysis.details.heading.intermediate': 'Runde',
  'modellingPage.analysis.details.heading.previousCaptable': 'Vorheriger Cap Table',
  'modellingPage.analysis.details.heading.result': 'Ergebnis',
  'modellingPage.analysis.details.heading.scenario': 'Szenario',
  'modellingPage.analysis.details.infoText':
    'Untersuchen Sie Details für die ausgewählte Runde. Runden, die das gleiche Ergebnis haben, werden zu einem Ergebnis zusammengefasst (z.B. könnte ein Wandeldarlehen-Discount zu demselben Ergebnis führen wie ein Pre-Money-Cap).',
  'modellingPage.analysis.details.selectResult.placeholder': 'Bitte wählen Sie ein Ergebnis aus',
  'modellingPage.analysis.details.selectRound.placeholder': 'Bitte wählen Sie eine Runde aus',
  'modellingPage.analysis.details.selectScenario.placeholder': 'Szenario auswählen',
  'modellingPage.analysis.details.tabs.captable': 'Cap Table',
  'modellingPage.analysis.details.tabs.exitSimulation': 'Exit-Berechnung (Tabelle)',
  'modellingPage.analysis.details.tabs.waterfall': 'Wasserfall (Grafik)',
  'modellingPage.analysis.filter.exits': 'Exits',
  'modellingPage.analysis.filter.exits.infix': 'erhält eine Auszahlung in Höhe von',
  'modellingPage.analysis.filter.exits.suffix': 'nach einem Exit von',
  'modellingPage.analysis.filter.extended': 'Erweiterte Filter',
  'modellingPage.analysis.filter.extended.exitTolerance.label':
    'Tolerierbare Exit-Differenz (Fehler) pro Investor für die Gruppierung der Ergebnisse: ',
  'modellingPage.analysis.filter.extended.ignoreInvestors':
    'Wählen Sie Investoren aus, deren Ergebnis irrelevant ist: ',
  'modellingPage.analysis.filter.extended.infoText':
    'Die erweiterten Filter ermöglichen es Ihnen, das Ergebnis bestimmter Investoren zu ignorieren und die Ergebnisse mit einer definierten Fehlertoleranz zu gruppieren. Wenn ein Investor ignoriert wird und zwei verschiedene Anteilsquoten und Exit-Renditen in zwei Szenarien hat, würden sie immer noch als ein Ergebnis in der Baum- und Ergebnisauswahl zusammengefasst werden. Die Fehlertoleranzen funktionieren ähnlich. Wenn Sie eine Fehler-Toleranz von 5% für die Exit-Renditen anwenden, dann werden alle Szenarien, bei denen die Exit-Renditen der Investoren (für jeden Exit-Betrag) innerhalb von +/- 5% der tatsächlichen Rendite liegen würden, zu einem Ergebnis zusammengefasst. Es funktioniert sehr ähnlich wie Histogramme, die Szenarien werden durch einen definierten Bereich für die Exit Return/Anteilsquote gruppiert. ',
  'modellingPage.analysis.filter.extended.shareTolerance.label':
    'Tolerierbare Anteilsdifferenz (Fehler) pro Investor für die Gruppierung der Ergebnisse: ',
  'modellingPage.analysis.filter.infoText':
    'Setzen Sie beliebige Filter für Anteilsquoten oder Exit-Renditen pro Gesellschafter und es werden Ihnen nur die relevanten Ergebnisse angezeigt.',
  'modellingPage.analysis.filter.share': 'Gesellschafter',
  'modellingPage.analysis.filter.share.infix': 'hält eine Anteilsquote von',
  'modellingPage.analysis.filter.share.suffix': 'nach der Investition.',
  'modellingPage.analysis.noSuperNodes':
    'Es wurden noch keine zukünftigen Finanzierungsrunden erstellt.<br />Klick auf die letzte Finanzierungsrunde um eine weitere hinzuzufügen.',
  'modellingPage.analysis.rangeWarning.description1':
    'Die Ergebnisse zeigen die Exit-Bereiche basierend auf der Fehlertoleranz.',
  'modellingPage.analysis.rangeWarning.description2':
    'Die Diagramme zeigen ein Szenario, das in der definierten Fehlertoleranz bestehen würde.',
  'modellingPage.analysis.rangeWarning.title':
    'Mehrere Szenarien werden zu einem Ergebnis zusammengefasst.',
  'modellingPage.analysis.recalculating': 'Berechne {count}/{total} Szenarien...',
  'modellingPage.analysis.results.diagram': 'Investoren die im Diagramm angezeigt werden sollen:',
  'modellingPage.analysis.results.infoText':
    'Vergleichen Sie verschiedene Ergebnisse nach Anteilsquoten der Gesellschafter, Exit-Beträgen oder Investitionsrenditen.',
  'modellingPage.analysis.results.irrMultiple.investmentMultiple': 'Investitionsmultiple: ',
  'modellingPage.analysis.results.irrMultiple.investmentVolume': 'Investitionsvolumen',
  'modellingPage.analysis.results.irrMultiple.investorDoesNotExit':
    'Der Invester existiert in diesem Szenario nicht.',
  'modellingPage.analysis.results.irrMultiple.irr': 'IRR: ',
  'modellingPage.analysis.results.irrMultiple.totalExitRevenue': 'Exit-Erlöse insgesamt',
  'modellingPage.analysis.results.tabs.irrMultiple': 'IRR & Multiple',
  'modellingPage.analysis.results.tabs.sharequota': 'Anteilsquote',
  'modellingPage.analysis.results.tabs.waterfall': 'Wasserfall',
  'modellingPage.analysis.results.volumeTable': 'Gesamtes Investitionsvolumen',
  'modellingPage.analysis.resultsDisplay': 'Resultat je Investor',
  'modellingPage.analysis.tabs.Details': 'Details',
  'modellingPage.analysis.tabs.filters': 'Filter',
  'modellingPage.analysis.tabs.results': 'Vergleich ({bucketNumber})',
  'modellingPage.bestScenarios': 'Beste Szenarien nach Exit-Betrag',
  'modellingPage.cn': 'Wandeldarlehen',
  'modellingPage.cnShort': 'Wandeldarlehen',
  'modellingPage.debt': 'Verschuldung',
  'modellingPage.equity': 'Eigenkapitalbeteiligung',
  'modellingPage.equityShort': 'Eigenkapital',
  'modellingPage.exitAmount': 'Exit-Betrag',
  'modellingPage.general': 'Allgemeine Felder',
  'modellingPage.infos.analysis':
    'Auf der rechten Seite haben Sie einen dreigeteilten Analysebereich zum Vergleich der Ergebnisse. Ein Filterbereich, in dem Sie die Anzahl der Ergebnisse reduzieren können, indem Sie die erforderlichen Anteilssquoten oder minimale Exit-Beträge festlegen. Ein Ergebnisabschnitt, in dem Sie die verschiedenen Ergebnisse für ausgewählte Anteilseigner gegenüberstellen können. Sie können wählen, ob Sie Anteilsquoten, Investitionsrenditen oder eine vollständige Wasserfallanalyse miteinander vergleichen möchten!Im Abschnitt "Details" können Sie den Captable jeder Runde anzeigen lassen und auf alle Details der Simulation eingehen, wie z.B. Wertsteigerungen, ausgelöster Verwässerungsschutz oder Zwangswandlungen. ',
  'modellingPage.infos.scenarios':
    'Auf der linken Seite befindet sich der Szenarien-Baum. Es gibt zwei Optionen, eine zum Bearbeiten des aktuellen Baums und eine weitere zum Analysieren der Ergebnisse. Sie können zwischen beiden Optionen mit Hilfe von Schaltflächen in der oberen Leiste wechseln. Im Bearbeitungsbaum können Sie das Seitenmenü verwenden, um Szenarien hinzuzufügen, zu löschen oder zu bearbeiten. Im Ergebnisbaum lassen sich die verschiedenen Szenarien und der zugehörige Captable einlenden! ',
  'modellingPage.infos.templates':
    'Vorlagen, die Ihnen bei den verbreitesten Anwendungsfällen helfen. Demnächst verfügbar!',
  'modellingPage.resultParameters': 'Result parameters',
  'modellingPage.resultParameters.short': 'RP',
  'modellingPage.investorsTable': 'Investoren Tabelle - Eigenkapital/Wandeldarlehen ({currency})',
  'modellingPage.investorsTable.short': 'IT',
  'modellingPage.menu.side.add': 'Weitere Finanzierungsrunde hinzufügen',
  'modellingPage.menu.side.delete': 'Finanzierungsrunde entfernen',
  'modellingPage.menu.side.edit': 'Finanzierungsrunde editieren',
  'modellingPage.menu.side.showDetails': 'Details anzeigen',
  'modellingPage.menu.top.analysis': 'Analyse',
  'modellingPage.menu.top.editing': 'Editierung',
  'modellingPage.menu.top.project': 'Projekte',
  'modellingPage.menu.top.results': 'Ergebnisse',
  'modellingPage.menu.top.template': 'Vorlagen',
  'modellingPage.menu.top.backToOverview': 'Zurück zur Übersicht',
  'modellingPage.menu.top.shareholders': 'Anteilseigner hinzufügen',
  'modellingPage.menu.top.shareclasses': 'Anteilsklassen hinzufügen',
  'modellingPage.pathName': 'Modellierung und Simulation',
  'modellingPage.selectInvestor': 'Bitte wählen Sie einen Investor aus...',
  'modellingPage.selectInvestorToCompare':
    'Bitte wählen Sie einen <span class="text-primary font-weight-bold">Investor</span> zum vergleichen aus.',
  'modellingPage.selectRound':
    'Sie benötigen mindestens ein <span class="text-primary font-weight-bold">Ergebnis</span> zum vergleichen.',
  'modellingPage.superForm.addExisting': 'Existierende Investoren hinzufügen',
  'modellingPage.superForm.cn.dateOfDeposit': 'Datum der Einzahlungsrunde',
  'modellingPage.superForm.cn.discount': 'Discount',
  'modellingPage.superForm.cn.general': 'Cap & Discount',
  'modellingPage.superForm.cn.ir': 'Zinssatz',
  'modellingPage.superForm.cn.ir.accumulationType': 'Zinsmethode',
  'modellingPage.superForm.cn.ir.cumulative': 'Kumulativ',
  'modellingPage.superForm.cn.ir.cumulative-non': 'Nicht kumulativ',
  'modellingPage.superForm.cn.ir.interestRate': 'Zinssatz',
  'modellingPage.superForm.cn.ir.limitInMonths': 'Begrenzung in Monaten',
  'modellingPage.superForm.cn.ir.retainDividends': 'Thesaurierung von Dividenden',
  'modellingPage.superForm.cn.ir.retainDividends-non': 'keine Thesaurierung von Dividenden',
  'modellingPage.superForm.cn.maturityDate': 'Fälligkeitsdatum',
  'modellingPage.superForm.cn.preMoneyCap': 'Pre-Money Cap',
  'modellingPage.superForm.cnPercent': 'Wandeldarlehen (%)',
  'modellingPage.superForm.createNew': 'Neuen Investor anlegen',
  'modellingPage.superForm.customOptionsLabel': 'Neue Investoren',
  'modellingPage.superForm.equity.ad.short': 'AD',
  'modellingPage.superForm.equity.ad': 'Verwässerungsschutz',
  'modellingPage.superForm.equity.ad.compensation': 'Kompensation',
  'modellingPage.superForm.equity.ad.duration': 'Laufzeit',
  'modellingPage.superForm.equity.ad.transferType': 'Art der Übertragung',
  'modellingPage.superForm.equity.ad.type': 'Typ',
  'modellingPage.superForm.equity.lp.short': 'LP',
  'modellingPage.superForm.equity.lp': 'Liquidationspräferenz Investoren',
  'modellingPage.superForm.equity.lp.agreedConversion': 'Wandlung',
  'modellingPage.superForm.equity.lp.agreedConversion-non': 'Keine Wandlung',
  'modellingPage.superForm.equity.lp.cap': 'Cap',
  'modellingPage.superForm.equity.lp.capType': 'Cap Typ',
  'modellingPage.superForm.equity.lp.ir.short': 'IR',
  'modellingPage.superForm.equity.lp.ir': 'Zinssatz LP',
  'modellingPage.superForm.equity.lp.ir.accumulationType': 'Zinsmethode',
  'modellingPage.superForm.equity.lp.ir.cumulative': 'Kumulativ',
  'modellingPage.superForm.equity.lp.ir.cumulative-non': 'Nicht kumulativ',
  'modellingPage.superForm.equity.lp.ir.interestRate': 'Zinssatz',
  'modellingPage.superForm.equity.lp.ir.limitInMonths': 'Begrenzung in Monaten',
  'modellingPage.superForm.equity.lp.ir.retainDividends': 'Thesaurierende Dividende',
  'modellingPage.superForm.equity.lp.ir.retainDividends-non': 'Nicht thesaurierende Dividende',
  'modellingPage.superForm.equity.lp.multiple': 'Multiple',
  'modellingPage.superForm.equity.lp.simple': 'Anrechenbare Liquidationspräferenz (SLP)',
  'modellingPage.superForm.equity.lp.simple-non': 'Nicht-anrechenbare Liquidationspräferenz (PLP)',
  'modellingPage.superForm.equity.preMoneyValuation': 'Pre-Money-Bewertung',
  'modellingPage.superForm.equityPercent': 'Eigenkapital (%)',
  'modellingPage.superForm.error.fullInvestment':
    'Die Summe aus Eigenkapital und Wandeldarlehen muss der Gesamtinvestitionssumme entsprechen.',
  'modellingPage.superForm.esopPoolSize': 'V(E)SOP Pool Größe',
  'modellingPage.superForm.existingOptionsLabel': 'Alte Investors',
  'modellingPage.superForm.investmentByInvestor': 'Investition je Investor',
  'modellingPage.superForm.investor': 'Investor',
  'modellingPage.superForm.ir': 'Zinssatz',
  'modellingPage.superForm.name': 'Name',
  'modellingPage.superForm.proRata':
    'Pro rata Betrag basierend auf dem Cap Table der {roundName} Runde.',
  'modellingPage.superForm.restAmount': 'Rest des Gesamtinvestitionsbetrags.',
  'modellingPage.superForm.roundDate': 'Rundendatum',
  'modellingPage.superForm.scenarioCount': 'Szenarienzahl',
  'modellingPage.superForm.scenarioCount.info':
    'Anzahl der durch die Konfiguration erzeugten Szenarien.',
  'modellingPage.superForm.totalInvestmentAmount': 'Gesamtinvestitionsbetrag',
  'modellingPage.templates.baseScenario': 'Base Szenario',
  'modellingPage.templates.convertibleNote': 'Wandeldarlehen',
  'modellingPage.templates.highScenario': 'High Szenario',
  'modellingPage.templates.lowScenario': 'Low Szenario',
  'modellingPage.topMenu.Delete': 'Löschen',
  'modellingPage.topMenu.Delete-text':
    'Sind Sie sich sicher, dass Sie das Projekt und alle zugehörigen Inhalte löschen möchten? Dies kann nicht rückgängig gemacht werden.',
  'modellingPage.topMenu.Delete-title': 'Das Projekt {name} löschen',
  'modellingPage.topMenu.Project': 'Projekte',
  'modellingPage.topMenu.Template': 'Vorlagen',
  'modellingPage.topMenu.createProject': 'Erstelle ein neues Projekt',
  'modellingPage.topMenu.editProject': 'Projekt editieren',
  'modellingPage.topMenu.noProject': 'Keine Projekte',
  'modellingPage.topMenu.super-delete-text':
    'Sind Sie sich sicher, dass Sie die Finanzierungsrunde und alle ihre untergeordneten Runden löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden!',
  'modellingPage.topMenu.super-delete-title': 'Die Finanzierungsrunde "{name}" löschen.',
  'modellingPage.tree.fieldNames.PLP': 'PLP',
  'modellingPage.tree.fieldNames.SLP': 'SLP',
  'modellingPage.tree.fieldNames.cap': 'Cap',
  'modellingPage.tree.fieldNames.cnInterest': 'Zinsen Wandeldarlehen',
  'modellingPage.tree.fieldNames.cumulative': 'Kumulierend',
  'modellingPage.tree.fieldNames.discount': 'Discount',
  'modellingPage.tree.fieldNames.esop': 'V(E)SOP',
  'modellingPage.tree.fieldNames.investment': 'Investition',
  'modellingPage.tree.fieldNames.lpInterest': 'LP-Zinsen',
  'modellingPage.tree.fieldNames.monthLimit': 'Monatslimit',
  'modellingPage.tree.fieldNames.multiple': 'Multiple',
  'modellingPage.tree.fieldNames.noRanges': 'Keine Bereiche',
  'modellingPage.tree.fieldNames.nonCumulative': 'Nicht kumulierend',
  'modellingPage.tree.fieldNames.ppS': 'Runden Preis',
  'modellingPage.tree.fieldNames.preMoney': 'Pre-Money-Bewertung',
  'modellingPage.tree.fieldNames.preMoneyCap': 'Pre-Money-Cap',
  'modellingPage.tree.fieldNames.withAndWithoutConversion': 'mit & ohne Wandlung',
  'modellingPage.tree.fieldNames.withConversion': 'mit Wandlung',
  'modellingPage.tree.fieldNames.withoutConversion': 'ohne Wandlung',
  'modellingPage.welcome.blocked.noCapTable':
    'Sie benötigen mindestens eine Runde, um mit der Modellierung zu beginnen.',
  'modellingPage.welcome.blocked.noShares':
    'Um mit der Modellierung beginnen zu können, muss mindestens ein Stammanteil ausgegeben worden sein.',
  'modellingPage.welcome.options1.info': 'erstelle eigene',
  'modellingPage.welcome.options1.name': 'Szenarien',
  'modellingPage.welcome.options2.info': 'probiere unsere',
  'modellingPage.welcome.options2.name': 'Vorlagen',
  'modellingPage.welcome.options3.info': 'nutze die',
  'modellingPage.welcome.options3.name': 'Analyse',
  'modellingPage.welcome.project': 'PROJEKT',
  'modellingPage.welcome.title': 'Willkommen bei der Szenario-Modellierung',
  'modellingPage.welcome.title2':
    'Ein Spielfeld, um Zukunftsszenarien zu simulieren und die Ergebnisse auszuwerten!',
  multiple: 'Multiple',
  name: 'Name',
  new: 'Neu',
  next: 'Weiter',
  no: 'Nein',
  noCharts: 'Es gibt keine Diagramme die angezeigt werden können...',
  noConversion: 'Keine Wandlung',
  noOptionsAvailable: 'Keine Optionen verfügbar',
  non: 'Keine',
  none: 'None',
  number: 'Zahl',
  ok: 'Ok',
  operations: 'Funktionen',
  optionalValueHide: 'Einklappen',
  optionalValueRemove: 'Optionalen Wert löschen',
  optionalValueShow: 'Optionalen Wert einfügen',
  options: 'Optionen',
  over: 'über',
  'overview.capTableOverview': 'Cap Table Übersicht',
  'overview.companyInfo': 'Zusammenfassung',
  'overview.companyStructure': 'Gesellschaftsstruktur ',
  'overview.delta': 'Delta',
  'overview.pathName': 'Übersicht',
  'overview.postMoney': 'Post-Money',
  'overview.preMoney': 'Pre-Money',
  'overview.valuationHistory': 'Bewertungshistorie',
  overwrite: 'Überschreiben',
  owner: 'Eigentümer',
  ownership: 'Eigentum',
  page: 'Seite',
  'pageNotice.createCompany': 'Erstellen Sie das Unternehmen des Projekts',
  'pageNotice.createFinancingRound': 'Erstellen Sie eine Finanzierungsrunde',
  'pageNotice.createModelling': 'Erstellen Sie ein Modellierungsprojekt',
  'pageNotice.createProject': 'Erstellen Sie ein Projekt',
  'pageNotice.login': 'Sie müssen sich einloggen.',
  'pageNotice.noCharts': 'Keine Diagramme vorhanden.',
  'pageNotice.noModellingBase':
    'Sie benötigen ein Projekt, um mit der Modellierung beginnen zu können.',
  'pageNotice.noModellingProjects': 'Keine Modellierungsprojekte vorhanden.',
  'pageNotice.noProjects': 'Keine Projekte vorhanden.',
  'pageNotice.processingChanges': 'Verarbeite Änderungen...',
  'pageNotice.retryApplyChanges': 'Versuche Änderungen erneut anzuwenden',
  'pageNotice.unlimitedProcessing': 'Die Verbindung wurde abgebrochen.',
  pariPassu: 'Pari Passu',
  participatingPref: 'Nicht-anrechenbare <br /> Liquidationspräferenz (PLP)',
  'payout.add': 'Auszahlungsstufe hinzufügen',
  'payout.deleteConfirm': 'Sind Sie sicher, dass Sie diese Auszahlung löschen wollen?',
  'payout.dragError.description':
    'Etwas ist bei dem Versuch, die Rangfolge zu verändern, schief gelaufen. Versuchen Sie es noch einmal!',
  'payout.dragError.seniorityDescription': 'Die {Name} kann keine Seniorität von 0 haben.',
  'payout.dragError.seniorityTitle': 'Das ist nicht möglich.',
  'payout.dragError.title': 'Verschieben konnte nicht gespeichert werden',
  'payout.editPayout': 'Auszahlung {name} bearbeiten',
  'payout.editShare': 'Anteilsklasse {name} bearbeiten',
  'payout.level': 'Auszahlungsstufte',
  'payout.multipleReceivers': 'Mehrere Empfänger',
  'payout.payoutLevel': 'Auszahlungsstufte (Seniorität)',
  'payout.payoutReciver': 'Auszahlungsempfänger',
  'payout.receiver': 'Empfänger',
  'payout.receivers': 'Empfänger',
  'payout.senioritySameError': 'Auszahlungen können nicht dieselbe Senioritätsstufe haben',
  'payout.singleReceiver': 'Ein Empfänger',
  'payout.title': 'Auszahlung',
  'payout.types.PayOut': 'Auszahlung',
  'payout.types.Share': 'Anteilsklasse',
  pending: 'ausstehend',
  percent: 'Prozent',
  'placeholder.end': 'Ende',
  'placeholder.fixed': 'Fixiert',
  'placeholder.name': 'Beispiel Name',
  'placeholder.select': '-{name} auswählen-',
  'placeholder.selectSingle': 'Auswählen',
  'placeholder.start': 'Start',
  'placeholder.step': 'Schrittgröße',
  pleaseEnterA: 'Please enter a {name}',
  pleaseEnterAn: 'Please enter an {name}',
  pleaseEnter: 'Please enter {name}',
  pleaseInput: 'Please Input {name}',
  pleaseProvideA: 'Please provide a {name}',
  pleaseSelect: 'Please select {name}',
  pleaseSelectA: 'Bitte wählen Sie ein {name}',
  pleaseSelectOption: 'Please select one of the following options',
  'portfolio.IRR': 'IRR',
  'portfolio.chart.amount': 'Exit-Erlöse',
  'portfolio.chart.difference': 'Gewinn',
  'portfolio.chart.exitReturn': 'Exit-Erlöse',
  'portfolio.chart.monthly': 'Nach Monaten',
  'portfolio.chart.quarterly': 'Nach Quartalen',
  'portfolio.chart.title': 'Übersicht der Investitionsrenditen',
  'portfolio.chart.totalInvestments': 'Gesamte Investitionen',
  'portfolio.chart.weekly': 'Nach Wochen',
  'portfolio.chart.yearly': 'Nach Jahren',
  'portfolio.companyName': 'Unternehmensname',
  'portfolio.currentProject': 'Aktuelles Projekt',
  'portfolio.lastPostMoneyValuation': 'Letze Post-Money-Bewertung',
  'portfolio.multiple': 'Multiple',
  'portfolio.my': 'Meine Projekte',
  'portfolio.pathName': 'Portfolio',
  'portfolio.selectDefaultInvestor': 'Wählen Sie aus, welchen Steakholder Sie vertreten.',
  'portfolio.selectDefaultInvestorFor':
    'Wählen Sie aus, welchen Stakeholder Sie vertreten für {companyName}',
  'portfolio.shared': 'Geteilte Projekte',
  'portfolio.switchProject': 'Zu diesem Projekt wechseln',
  'portfolio.title': 'Portfolio',
  'portfolio.totalInvestment': 'Gesamte Investitionen',
  postMoneyVal: 'Post-Money-Bewertung',
  preMoneyCap: 'Pre-Money-Cap',
  preMoneyFloor: 'Pre-Money-Floor',
  preMoneyVal: 'Pre-Money-Bewertung',
  preMoneyValAsIfConverted: 'Pre-Money-Bewertung (as-if-converted)',
  premium: 'Premium',
  previous: 'Zurück',
  price: 'Preis',
  pricePaid: 'Gezahlter Preis',
  pricePerShare: 'Preis pro Anteil',
  'project.currency': 'Währung',
  'project.name': 'Projektname',
  'project.nameRequired': 'Bitte geben Sie einen Projektnamen ein.',
  'project.roundingMode': 'Rundungsmethode',
  'project.title': 'Projekt',
  'projectInvitationPage.pathName': 'Projekt-Einladung',
  provideName: 'Bitte geben Sie einen Namen an',
  quota: 'Anteilsquote',
  'range.set': 'Bereich festlegen',
  'range.step': 'Schrittgröße',
  'reactJoyride.back': 'Zurück',
  'reactJoyride.close': 'Schließen',
  'reactJoyride.last': 'Letzte',
  'reactJoyride.next': 'Weiter',
  'reactJoyride.skip': 'Überspringen',
  readMore: 'Mehr lesen',
  recalculate: 'Neuberechnen',
  recalculating: 'Neuberechnung',
  relative: 'Relativ',
  reportBug: 'Einen Fehler melden',
  round: 'Runde',
  roundDate: 'Rundendatum',
  'roundForm.currentInvestments': 'Bisherige Investitionen: {total}',
  'roundForm.dateRequired': 'Bitte geben Sie ein Datum ein',
  'roundForm.postMoneyRequired':
    'Bitte geben Sie eine Post-Money-Bewertung größer als die Investitionen ein',
  'roundForm.preMoneyValAsConverted': 'Info: {amount} (as-if-converted)',
  'roundForm.roundNameRequired': 'Bitte geben Sie einen Rundennamen ein',
  'roundForm.shareAdd': 'Neue Anteilsklasse hinzufügen',
  'roundForm.shareDelete': 'Anteilsklasse löschen',
  'roundForm.shareEditSelected': 'Ausgewählte Anteilsklasse bearbeiten',
  'roundForm.shareNew': 'Neuer Anteil',
  'roundForm.shareRound': 'Anteilsklasse',
  'roundForm.shareUsedError': 'Fehler! Die Anteilskasse wird noch in {roundName} benutzt!',
  'roundForm.totalInvestmentsAdd': 'Gesamtinvestitionen hinzufügen',
  roundPrice: 'Rundenpreis',
  save: 'Speichern',
  saveAndCalculate: 'Speichern & Berechnen',
  saved: 'Gespeichert',
  saving: 'Speichern',
  'securities.esop': 'Voll verwässert',
  'securities.excludeFounders': 'Gründer-Vesting ausgeschlossen',
  'securities.exit': 'Exit Event',
  'securities.investorPerspective': 'Investorenperspektive',
  'securities.investorShares': 'Eigentumsverteilung nach Gesellschaftern',
  'securities.pathName': 'Securities',
  'securities.payoutStructure': 'Auszahlungsstruktur',
  'securities.sharePerspective': 'Anteilsperspektive',
  'securities.shareTypesOwnership': 'Anteilsklassen und Eigentumsverteilung',
  'securities.shares': 'Investorenanteile',
  'securities.slider': 'Anteilsverteilung in verschiedenen Szenarien',
  'securities.specialRights': 'Sonderrechte',
  'securities.title': 'Securities',
  'securities.vested': 'Vesting angewandt',
  selectedProject: 'Ausgewähltes Projekt',
  senior: 'Senior',
  seniority: 'Seniorität',
  seniotityLevel: 'Senioritätsstufe',
  series: 'Runde',
  'settings.description':
    'Diese Komponente Einstellungen bietet die Möglichkeit, benutzerdefinierte Blöcke mit beliebigen Widgets, Komponenten und Elementen darin zu konstruieren, wie diese Themeneinstellungen',
  'settings.isBorderless': 'Randloses Design',
  'settings.isFixedWidth': 'Feste Breite',
  'settings.isLightTheme': 'Helles Thema',
  'settings.isSquaredBorders': 'Eckige Kanten',
  'settings.menuCollapsed': 'Eingeklapptes Menü',
  'settings.menuShadow': 'Menü-Schatten',
  'settings.menuTop': 'Menü oben (horizontal)',
  'settings.title': 'Themen Einstellungen',
  share: 'Anteil',
  'shareForm.cappedPartRequired': 'Bitte wählen Sie den Cap-Typ',
  'shareForm.cappedParticipation': 'Gekappte Beteiligung',
  'shareForm.compensationRequired': 'Bitte wählen Sie eine Kompensation',
  'shareForm.durationRequired': 'Bitte wählen Sie eine Laufzeit',
  'shareForm.multipleRequired': 'Bitte geben Sie einen Multiple ein',
  'shareForm.nameRequired': 'Bitte geben Sie einen Namen für die Anteilsklasse ein',
  'shareForm.participationCap': 'Partizipationsbegrenzung',
  'shareForm.payoutHide': 'Auszahlungsvorschau verbergen',
  'shareForm.payoutPreview': 'Auszahlungsvorschau',
  'shareForm.seniorLastInFirstOut': 'Senior (Last in First Out)',
  'shareForm.seniorityRequired': 'Bitte geben Sie die Seniorität der Anteilsklasse ein',
  'shareForm.simpleRequired': 'Bitte wählen Sie den LP-Typ',
  'shareForm.text': 'Notizen',
  'shareForm.defaultPriceCalculationMethod': 'Preisberechnungsmethode',
  'shareForm.defaultPriceCalculationMethod.isRequired':
    'Bitte wählen Sie eine Preisberechnungsmethode aus',
  'shareForm.transferType': 'Übertragungsart',
  'shareForm.transferTypeRequired': 'Bitte wählen Sie eine Übertragungsart',
  'shareForm.typeRequired': 'Bitte wählen Sie einen AD-Typ',
  shareHolding: 'Anteilsquote',
  shareQuota: 'Anteilsquote',
  shareholder: 'Gesellschafter / Investor',
  'shareholder-types.plural.business_angel': 'Business Angel',
  'shareholder-types.plural.corporate_venture_capitalist': 'Corporate VCs',
  'shareholder-types.plural.employee': 'Mitarbeiter',
  'shareholder-types.plural.esop_pool': 'V(E)SOPs',
  'shareholder-types.plural.esop': 'V(E)SOPs',
  'shareholder-types.plural.family': 'Family & Friends',
  'shareholder-types.plural.founder': 'Gründer',
  'shareholder-types.plural.investor': 'Investoren',
  'shareholder-types.plural.management': 'Management',
  'shareholder-types.plural.sim_investor': 'Neue Investoren',
  'shareholder-types.plural.new_investor': 'Neue Investoren',
  'shareholder-types.plural.venture_capitalist': 'Investoren',
  'shareholder-types.singular.business_angel': 'Business Angel',
  'shareholder-types.singular.corporate_venture_capitalist': 'Investor',
  'shareholder-types.singular.employee': 'Mitarbeiter',
  'shareholder-types.singular.esop_pool': 'V(E)SOP',
  'shareholder-types.singular.family': 'Familie',
  'shareholder-types.singular.founder': 'Gründer',
  'shareholder-types.singular.investor': 'Investor',
  'shareholder-types.singular.management': 'Management',
  'shareholder-types.singular.venture_capitalist': 'Investor',
  shareholderDefault: 'Standard-Gesellschafter',
  shareholders: 'Gesellschafter',
  shares: 'Anteile',
  sharesEsop: '# V(E)SOP Anteile',
  sharesNew: 'Neue Anteile',
  sharesNumber: 'Anzahl an Anteilen',
  'sharesOverview.ownership-esop': 'Eigentumsverteilung (voll verwässert)',
  'sharesOverview.ownership-exit': 'Eigentumsverteilung (zum Exit)',
  'sharesOverview.ownership-granted': 'Eigentumsverteilung (inkl. Optionen)',
  'sharesOverview.ownership-shares': 'Eigentumsverteilung (unverwässert)',
  'sharesOverview.ownership-vested': 'Eigentumsverteilung (inkl. gevesteter Anteile)',
  'sharesOverview.ownershipDiluted': 'Anteilsquote (voll verwässert)',
  'sharesOverview.sharesOutstanding': 'Ausstehende Anteile',
  'sharesOverview.sharesOutstanding-esop': 'Ausstehende Anteile (voll verwässert)',
  'sharesOverview.sharesOutstanding-exit': 'Ausstehende Anteile (zum Exit)',
  'sharesOverview.sharesOutstanding-granted': 'Ausstehende Anteile (inkl. Optionen)',
  'sharesOverview.sharesOutstanding-shares': 'Ausstehende Anteile (unverwässert)',
  'sharesOverview.sharesOutstanding-vested': 'Ausstehende Anteile (inkl. gevesteter Anteile)',
  'sharesOverview.sharesOutstandingDiluted': 'Ausstehende Anteile (inkl. gevesteter Anteile)',
  sharesTotal: 'Anteile gesamt',
  simple: 'Anrechenbare <br /> Liquidationspräferenz (SLP)',
  simulation: 'Simulation',
  'specialRightsOverview.empty': 'Keine Runde mit Sonderrechten',
  'specialRightsOverview.sharesComp': 'Ausgleichsanteile',
  'specialRightsOverview.simplePref': 'Anrechenbare Liquidationspräferenz (SLP)',
  'stakeholdersPage.accessRightInfos': 'Informationen über Zugangsrechte',
  'stakeholdersPage.accessRights': 'Zugriffsrechte',
  'stakeholdersPage.accessRightsRequired': 'Bitte geben Sie die Zugriffsrechte des Benutzers an',
  'stakeholdersPage.addName': 'Oder Namen hinzufügen',
  'stakeholdersPage.addUser': 'Neuen Benutzer hinzufügen',
  'stakeholdersPage.admin.six': 'Editierungsseite',
  'stakeholdersPage.admin.five':
    'Alle Mitglieder der Organisation (z.B. VC/Co-Founders) können auf das Projekt zugreifen',
  'stakeholdersPage.admin.three':
    'Rechte zum editieren und entfernen von Dokumenten, welche von dem Account erstellt wurden',
  'stakeholdersPage.admin.one': 'Alle Betrachter-Rechte',
  'stakeholdersPage.admin.four': 'Kann andere Nutzer hinzufügen (Betrachter und Support)',
  'stakeholdersPage.admin.two': 'Rechte zum editieren und entfernen von Projekt Daten',
  'stakeholdersPage.adminRights':
    'Administratoren können das Projekt modifizieren und zusätzlich Gäste und Benutzer einladen.',
  'stakeholdersPage.alreadyInvited': 'Dieser Benutzer ist bereits eingeladen worden.',
  'stakeholdersPage.bystandingUsers': 'Bystanding Users',
  'stakeholdersPage.detail': 'Details',
  'stakeholdersPage.limitedViewer.one': 'z.B. ein Mitarbeiter welcher nur seine Optionen sieht',
  'stakeholdersPage.limitedViewer.three': 'Alle anderen Firmendaten sind nicht zugänglich',
  'stakeholdersPage.limitedViewer.two':
    'z.B. Ein Investor, welcher nur seine Investment Position sieht',
  'stakeholdersPage.limitedViewerRights':
    'Limitierte Betracher können nur ihren eigenen status in der Firma sehen.',
  'stakeholdersPage.emailExists': 'Diese E-Mail existiert bereits',
  'stakeholdersPage.emailInvalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'stakeholdersPage.emailRequired': 'Bitte geben Sie die E-Mail des Benutzers ein',
  'stakeholdersPage.guestNameLabel': 'Vor- und Nachname',
  'stakeholdersPage.guestNameRequired': 'Bitte geben Sie einen Gastnamen an',
  'stakeholdersPage.invitationResent': 'Sende Einladung erneut',
  'stakeholdersPage.invite': 'Einladen',
  'stakeholdersPage.inviteUser': 'Neuen Benutzer einladen',
  'stakeholdersPage.owner.four': 'Kann neue Nutzer (inkl. Administratoren, Eigentümern) hinzufügen',
  'stakeholdersPage.owner.one': 'Alle Administratorenrechte',
  'stakeholdersPage.owner.three': 'Kann das gesamte Projekt löschen',
  'stakeholdersPage.owner.two': 'Kann die Zugriffsrechte Anderer verändern',
  'stakeholdersPage.owner.five': 'Rechte zum editieren und entfernen aller Dokumente',
  'stakeholdersPage.ownerRights':
    'Eigentümer haben das Recht, das Projekt zu löschen und die Zugriffsrechte der Benutzer zu ändern oder zu entziehen.',
  'stakeholdersPage.pathName': 'Stakeholder',
  'stakeholdersPage.provideAccessRights': 'Bitte geben Sie ein Zugriffsrecht an',
  'stakeholdersPage.removeSelf': 'Entfernen Sie sich selbst',
  'stakeholdersPage.removeSelfConfirm': 'Sie werden damit aus dem Projekt entfernt, fortfahren?',
  'stakeholdersPage.removeUser': 'Benutzer entfernen',
  'stakeholdersPage.removeUserConfirm': 'Möchten Sie diesen Benutzer aus dem Projekt entfernen?',
  'stakeholdersPage.resend': 'Einladung erneut versenden',
  'stakeholdersPage.revokeInvitation': 'Einladung zurückziehen',
  'stakeholdersPage.revokeInvitationConfirm':
    'Wollen Sie die Einladung für diesen Benutzer zurücknehmen?',
  'stakeholdersPage.stakeholders': 'Stakeholder',
  'stakeholdersPage.thatsme': 'Das bin Ich!',
  'stakeholdersPage.title': 'Stakeholder',
  'stakeholdersPage.userSelectRequired':
    'Bitte wählen Sie einen bestehenden Investor oder fügen Sie einen neuen Benutzer hinzu.',
  'stakeholdersPage.viewer.four': 'Kann ein privates Modellierungsprojekt anlegen',
  'stakeholdersPage.viewer.one': 'Übersicht-, Securities- and Dokumentenseite',
  'stakeholdersPage.viewer.three': 'Stakeholder-, V(E)SOP- & Vestingseite',
  'stakeholdersPage.viewer.two': 'Cap Table Seite, Transaktionshistorie & Wasserfall-Berechnung',
  'stakeholdersPage.viewerRights':
    'Die Betrachter können das Projekt permanent nur ansehen, sie dürfen das Projekt nicht verändern.',
  sum: 'Summe',
  'termsheet.buyOutAdd': 'Buy Outs hinzufügen',
  'termsheet.buyOutDelete': 'Buy Out löschen',
  'termsheet.buyOutDeleteBy': 'Buy Out löschen von',
  'termsheet.buyOutEdit': 'Buy Outs bearbeiten',
  'termsheet.collapseHeaderError': 'Bitte füllen Sie alle fehlenden Felder aus & speichern Sie',
  'termsheet.conversionAdd': 'Wandlung hinzufügen (WD {roundName})',
  'termsheet.conversionDelete': 'Wandlungen löschen (WD {roundName})',
  'termsheet.conversionEdit': 'Wandlungen bearbeiten (WD {roundName})',
  'termsheet.deleteInvestorsError':
    'Sie müssen zuerst die neuen Investitionen, Buy Outs und V(E)SOP-Pools dieser Runde löschen!',
  'termsheet.disabledConversionDelete':
    'Sie können die Wandlungen erst löschen, nachdem Sie den Buy Out der Anteile entfernt haben.',
  'termsheet.disabledConversionEdit':
    'Sie können die Wandlungen erst bearbeiten, nachdem Sie den Buy Out der Anteile entfernt haben.',
  'termsheet.conversionExceeded': 'Wandlungsbetrag übersteigt die Investition',
  'termsheet.investorDelete': 'Investor löschen',
  'termsheet.prevQuota': 'Vorh. Anteilsquote',
  'termsheet.roundDelete': 'Runde löschen',
  'termsheet.roundDeleteConfirm': 'Sind Sie sicher, dass Sie die Runde löschen wollen?',
  'termsheet.roundDeleteDisabledFounding': 'Sie können die Gründungsrunde nicht entfernen.',
  'termsheet.roundDeleteDisabled': 'Sie können nur Ihre letzte Runde löschen.',
  'termsheet.stillHasBuyOutError':
    'Fehler beim Löschen des Investors, es existiert noch ein Buy Out in {roundName}!',
  'termsheet.stillHasDefaultInvestorError':
    'Fehler beim Löschen des Investors, es existiert noch eine Vertretung durch {userName}. Bitte entfernen Sie zuerst diesen Bezug.',
  'termsheet.stillHasEsopGrantError':
    'Fehler beim Löschen des Investors, es existieren noch gewährte Optionen in {roundName}!',
  'termsheet.stillHasEsopError':
    'Fehler beim Löschen des Investors, es existieren V(E)SOP Pools in welchen er als Träger angegeben ist!',
  'termsheet.stillHasConversionsError':
    'Fehler beim Löschen des Wandeldarlehens, es existiert noch eine Wandlung in {roundName}!',
  'termsheet.stillHasInvestmentError':
    'Fehler beim Löschen des Investors, es existiert noch eine Investition in {roundName}!',
  'termsheet.thatsMe': 'Das bin Ich!',
  'termsheet.valuationInput.help.cn':
    'Kaufkraft ({nominal} Nominal + {dividends} Zinsen (über {days} Tage) reduziert um {discount})',
  'termsheet.valuationInput.help.description':
    'Die Pre-Money-Bewertung as if-converted wird auf der Grundlage der Bilanzierung aller Wandeldarlehen einschließlich ihrer Zinsen und Rabatte durch Caps und Discounts berechnet. Die Zinsen der Wandeldarlehen werden auf Basis der Tage zwischen dem Anlagedatum und dem {Datum} berechnet.',
  'termsheet.valuationInput.help.title': 'Pre-Money-As-If-Converted Berechnung',
  today: 'Heute',
  'topBar.menu.editProfile': 'Profil bearbeiten',
  'topBar.menu.hello': 'Hallo, {name}',
  'topBar.menu.helloNoLogin': 'Hallo, Newby!',
  'topBar.menu.noLoginNotice': 'Melden Sie sich an oder erstellen Sie ein Konto, um mehr zu sehen.',
  'topBar.menu.portfolio': 'Portfolio',
  'topBar.menu.upgradePremium': 'Get Premium',
  'topBar.typeToSearch': 'Tippen um zu suchen...',
  'topBar.version': 'Software-Version {version}',
  total: 'Gesamt',
  totalResult: 'Gesamtergebnis',
  'tree.investment': 'Investitionen',
  'tree.postMoney': 'Post-Money-Bewertung',
  'tree.preMoney': 'Pre-Money-Bewertung',
  'triggeredEvents.antiDilution':
    'Die Verwässerungsschutz-Regelung greift, da eine Down-Round vorliegt.',
  'triggeredEvents.forcedConversion':
    'Die Wandlung erfolgte, weil während der Simulation alle Wandeldarlehen in der nächsten Runde zwangsweise gewandelt werden.',
  type: 'Typ',
  undefined: 'n.v.',
  'underConstruction.description':
    'Diese Seite befindet sich derzeit im Aufbau oder Sie haben keinen Zugang zu dieser Seite in der Demoversion..',
  underConstructionPage: 'Im Aufbau',
  'userProfile.accountType': 'Kontoart',
  'userProfile.avatar': 'Profilbild',
  'userProfile.avatarRemove': 'Profilbild entfernen',
  'userProfile.city': 'Stadt',
  'userProfile.companyDetails': 'Firmeninformationen zur aktuellen Beschäftigung',
  'userProfile.companyLogo': 'Unternehmenslogo ',
  'userProfile.companyLogoRemove': 'Unternehmenslogo löschen',
  'userProfile.companyName': 'Unternehmensname',
  'userProfile.country': 'Land',
  'userProfile.deleteAccount.confirmation':
    'Sind Sie sicher, dass Sie Ihr Konto bei Ventury Analytics löschen möchten?<br/>Alle Projektdaten gehen dauerhaft verloren.',
  'userProfile.deleteAccount.title': 'Account löschen',
  'userProfile.firstName': 'Vorname',
  'userProfile.generalInfo': 'Allgemeine Informationen',
  'userProfile.lastLogin': 'Letzer Login',
  'userProfile.lastName': 'Nachname',
  'userProfile.lastUpdate': 'Letzte Profilaktualisierung',
  'userProfile.pageTitle': 'Profil',
  'userProfile.passwordReset.confirmation':
    'Sind Sie sicher, dass Sie Ihr Passwort zurücksetzen möchten?',
  'userProfile.passwordReset.description':
    'Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse geschickt. Bitte folgen Sie den dort angegebenen Anweisungen!',
  'userProfile.passwordReset.message': 'Überprüfen Sie Ihre E-Mail!',
  'userProfile.passwordReset.title': 'Passwort zurücksetzen',
  'userProfile.pathName': 'Profil',
  'userProfile.personalInfo': 'Persönliche Informationen',
  'userProfile.postcode': 'Postleitzahl',
  'userProfile.profileActions': 'Profil-Aktionen',
  'userProfile.sendNewsletter': 'Newsletter abbonieren',
  'userProfile.signupTime': 'Registrierungsdatum ',
  'userProfile.streetNumber': 'Straße und Hausnummer',
  'userProfile.title': 'Tätigkeitsbezeichnung',
  valuation: 'Bewertung',
  'vesting.confirmDeletion': 'Möchten Sie wirklich den Vesting-Plan löschen?',
  'vesting.editVesting': 'Vesting-Plan bearbeiten - {name}',
  'vesting.numberOfUnvestedShares': 'Anzahl ungevesteter Anteile',
  'vesting.pathName': 'Vesting',
  'vesting.remainingVestingTime': 'Verbleibende Vestingzeit',
  'vesting.select': 'anzeigen',
  'vesting.unselect': 'verbergen',
  'vesting.unvestedShares': 'Ungevestete Anteile',
  'vesting.vestedShares': 'Gevestete  Anteile',
  viewer: 'Betrachter',
  warning: 'Warnung',
  'waterfall.breakpointAnalysis': 'Breakpoint-Analyse',
  'waterfall.calculationInfos.general':
    'Bei der Berechnung der IRR berücksichtigen wir die folgenden Transaktionen und Auszahlungen mit unregelmäßigen Investitionsintervallen (XIRR).',
  'waterfall.calculationInfos.notes':
    'Notes: Der IRR wird für Mitarbeiter-Optionen nicht berechnet, da die Option erst am Exit-Datum ausgeführt wird. Es wird ein alternativer Multiplikator berechnet, der die Differenz zum potentiell bezahlten Ausübungspreis darstellt.',
  'waterfall.customExitValue': 'Eigener Exit-Wert',
  'waterfall.distributeResiduals': 'V(E)SOP-Restbeträge pro rata verteilen',
  'waterfall.distributeResiduals.confirm':
    'Dadurch werden die Restbeträge an alle pro rata Beteiligten entsprechend ihrer rechtlichen Anteilsquote verteilt. <br />Bitte beachten Sie, dass dies zu veralteten Wandlungs- und Kappungspunkten führen kann. Wir empfehlen daher, diese Option deaktiviert zu lassen. ',
  'waterfall.dividendsShare': 'Dividenden je Anteil',
  'waterfall.effectiveCapPoint': 'Effektiver Kappungspunkt',
  'waterfall.exitDateLabel': 'Exitdatum',
  'waterfall.exitRevenue.investorBased': 'Investorenbasierte Exit-Erlöse',
  'waterfall.exitRevenue.shareBased': 'Anteilsbasierte Exit-Erlöse',
  'waterfall.hidePreview': 'Vorschau verbergen',
  'waterfall.investmentMultiple': 'Investitionsmultiple',
  'waterfall.irr': 'IRR',
  'waterfall.irr.transactionList': 'Transaktionsliste',
  'waterfall.irr.transactionsError':
    'Es konnten keine Transaktionen für den Investor für ein bestimmtes Szenario gefunden werden.',
  'waterfall.irrInvestments': 'In IRR-Transaktionen enthaltene Investitionsarten',
  'waterfall.irrInvestments.four': 'Investition in Wandeldarlehen',
  'waterfall.irrInvestments.one': 'Eigenkapitalbeteiligung',
  'waterfall.irrInvestments.three': 'Secondary (Käufer)',
  'waterfall.irrInvestments.two': 'Verwässerungsschutz (Kapitalerhöhung)',
  'waterfall.irrPayOuts': 'In IRR-Transaktionen enthaltene Auszahlungsarten',
  'waterfall.irrPayOuts.one': 'Pay Outs (z.B. Catch Ups)',
  'waterfall.irrPayOuts.three': 'Secondary (Verkäufer)',
  'waterfall.irrPayOuts.two': 'LP-, Dividenden- und Mitarbeiteroptionen erlöse',
  'waterfall.noPoints': 'Keine Cap- oder Wandlungspunkte',
  'waterfall.noPointsShow': 'Es gibt keine Cap- oder Wandlungspunkte zum anzeigen',
  'waterfall.noPrefAmount': 'Keine Vorzugsbeträge',
  'waterfall.pathName': 'Wasserfall-Berechnung',
  'waterfall.prefAmount': 'Vorzugsbetrag',
  'waterfall.prefAmountShare': 'Vorzugsbetrag pro Anteil / Auszahlung',
  preview: 'Vorschau',
  'waterfall.pricePerShare': 'Preis pro Anteil (Exit)',
  'waterfall.printAmount.LP': '{amount} LP-Betrag',
  'waterfall.printAmount.dividends': '{amount} Dividenden-Betrag',
  'waterfall.printAmount.exit': '{amount} Exit-Betrag',
  'waterfall.printAmount.proRata': '{amount} Pro-Rata-Betrag',
  'waterfall.proRataAmount': 'Pro rata Betrag',
  'waterfall.proRataShare': 'Pro rata je Anteil',
  'waterfall.prorata': 'Pro rata',
  'waterfall.strikePointAnalysis': 'Mitarbeiter-Optionen Gewinnschwellenanalyse',
  'waterfall.strikePointAnalysis.noPoints':
    'Keine Optionen mit Ausübungspreisen, daher können keine Ausübungspunkte angezeigt werden.',
  'waterfall.strikePointAnalysis.shareAmount': 'Anzahl Anteile',
  'waterfall.strikePointAnalysis.strikePoint': 'Gewinnschwelle',
  'waterfall.strikePointAnalysis.strikePrice': 'Ausübungspreis',
  'waterfall.targetExit': 'Ziel-Exit (in M{currency})',
  'waterfall.title': 'Liquidationspräferenz',
  'waterfall.totalExitRevenue': 'Gesamte Exit-Erlöse',
  'waterfall.exitAmount': 'Exit Betrag',
  'waterfall.totalIssued': 'Gesamt ausgegeben',
  'waterfall.undefinedIrr':
    'Der IRR konnte nicht berechnet werden, da er die Anzahl möglicher Iterationen überstieg. Dies geschieht, wenn das Exit-Datum zu nahe an der letzten Finanzierungsrunde liegt.',
  waterfallAnalysis: 'Wasserfall-Berechnung',
  yes: 'Ja',
}

export default {
  locale: 'de-DE',
  antdData,
  messages,
}
